<template>
  <div class="movies-form new_movie_layout">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-1">
        {{ $t("edit") }} {{ $tc("movie", 1) }}
      </div>
      <router-link class="btn-blue" to="/cinema-manager/movies"
        >{{ $tc("movie", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>

    <div class="edit-movie-container mb-5" style="padding:25px 25px">
      <form>
        <!-- MOVIE TOP INFO SECTION -->
        <section
          class="mb-3"
          :class="
            errorHandlerObj['errorSectionIndex'] == 1 ? 'sectionError' : ''
          "
        >
          <div class="row col-12">
            <div
              class="section-title mb-2 d-flex justify-content-between section-border section-border col-10"
              style="padding: 6px; align-items: center"
              v-b-toggle.basicInfoCollapse
            >
              <div>
                <span class="fs"
                  >{{ $tc("basic") }} {{ $tc("information") }}</span
                ><span class="font-weight-normal fs">{{ basicinfotext }} </span>

                <span
                  style="color: green; font-size: 17px"
                  v-if="this.MovieContainer.movie_isActive === 'Y'"
                >
                  Active
                </span>
                <span v-else style="color: red; font-size: 17px">
                  Inactive
                </span>
              </div>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>

            <div class="col-2 d-flex align-items-center justify-content-center">
              <label class="mb-0">{{ $t("active") }}</label>
              <b-form-checkbox
                v-model="MovieContainer.movie_isActive"
                unchecked-value="N"
                value="Y"
                name="check-button"
                class="j-checkbox ml-2 pb-0"
                @input="onChangeActiveStatus"
              />
            </div>
          </div>
          <b-collapse
            id="basicInfoCollapse"
            v-model="sectionCollapse.basicInfo"
          >
            <div class="basicInforWrapper">
              <div class="row px-2">
                <!-- show type -->
                <div class="col-md-12 mb-3" v-if="false">
                  <div class="row">
                    <div
                      class="col-md-3 col-lg-2 heading"
                      style="margin-top: 0px !important"
                    >
                      <h5>{{ $tc("screeningType") }}</h5>
                    </div>
                    <div
                      class="col-md-4 col-lg-2"
                      v-for="(screeningType,
                      screeningTypeIndex) in ShowTypeArrayNew"
                      :key="screeningTypeIndex"
                    >
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          :disabled="disableFeatureVersion"
                          :id="`ogshowtypearr${screeningTypeIndex}`"
                          v-model="MovieContainer[screeningType.column_name]"
                          @change="
                            onChangeOriginalShowtype(
                              $event,
                              screeningType.column_name
                            )
                          "
                        />

                        <label
                          class=""
                          :for="`ogshowtypearr${screeningTypeIndex}`"
                        >
                          {{ screeningType.screening_name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- MOVIE TITLE -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <label
                        >Movie Title <span class="required_star">*</span></label
                      >
                      <input
                        v-model="MovieContainer.movieTitle"
                        type="text"
                        name="movietitle"
                        id="movietitle"
                        v-validate="'required'"
                        placeholder="Movie Name"
                        @input="onChangeMovieTitle($event)"
                      />
                    </div>
                    <!-- <Tooltip :title="$t('movietitle_tooltip')" /> -->
                  </div>
                  <p class="error_message">
                    <span v-if="submitted && errors.has('movietitle')">{{
                      errors.first("movietitle")
                    }}</span>
                  </p>
                </div>
                <!-- MOVIE TITLE -->

                <!-- Unique Movie ID -->
                <div class="col-md-2 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <!-- <label>{{ $tc("movieUniqueID") }}</label> -->
                      <label
                        >Movie UUID<span class="required_star">*</span></label
                      >
                      <input
                        style="text-align: right"
                        v-model="MovieContainer.movie_unique_identifier"
                        type="text"
                        :disabled="
                          MovieContainer.is_event &&
                            MovieContainer.parent_movie_id
                        "
                        name="movie_unique_identifier"
                        id="movie_unique_identifier"
                        v-validate="{ required: 'required', regex: /^\S*$/ }"
                        placeholder="UUID"
                      />
                    </div>
                    <div
                      class="input-material ml-3 w-50"
                      v-if="
                        MovieContainer.is_event &&
                          MovieContainer.parent_movie_id
                      "
                    >
                      <label>{{ "Event ID" }}</label>
                      <input
                        v-model="event_identifier"
                        type="text"
                        name="event_identifier"
                        id="event_identifier"
                        :disabled="true"
                        :maxlength="3"
                        v-validate="{ required: 'required', regex: /^\S*$/ }"
                        placeholder="."
                      />
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="submitted && errors.has('movie_unique_identifier')"
                      >{{ errors.first("movie_unique_identifier") }}</span
                    >
                  </p>
                </div>

                <!--ORIGINAL LANGUAGE DROPDOWN -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $tc("Language") }} ( {{ $t("original") }})<span
                          class="required_star"
                          >*</span
                        >
                      </label>

                      <multiselect
                        v-model="original_language"
                        @select="onSelectOriginalLanguageHandler"
                        placeholder="Original Language"
                        :options="Languages"
                        label="lang_name"
                        track-by="lang_id"
                        :multiple="false"
                        name="selectoriginallanguage"
                        id="selectoriginallanguage"
                        select-label="Select"
                        deselect-label="Remove"
                      ></multiselect>
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        submitted &&
                          showErrorMessages &&
                          (!original_language || !original_language.lang_id)
                      "
                      >{{ messageoriginallanguage }}</span
                    >
                  </p>
                </div>
                <!--ORIGINAL LANGUAGE DROPDOWN -->

                <!-- Original Movie distributor -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $t("default") }}
                        {{ $tc("distributor", 1)
                        }}<span class="required_star">*</span>
                      </label>

                      <multiselect
                        v-model="original_distributor"
                        @select="onSelectOriginalDistributorHandler"
                        placeholder="Default Distributor"
                        :options="Distributors"
                        label="d_company_name"
                        track-by="d_id"
                        :multiple="false"
                        name="selectoriginalDistributor"
                        id="selectoriginalDistributor"
                        select-label="Select"
                        deselect-label="Remove"
                      ></multiselect>
                    </div>
                    <!-- <Tooltip
                      :title="$t('movieselectdefaultdistributor_tooltip')"
                    /> -->
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        submitted &&
                          showErrorMessages &&
                          MovieContainer.original_distributor_name.length == 0
                      "
                      >{{ messageoriginalDistributor }}</span
                    >
                  </p>
                </div>
                <!-- Original Movie distributor -->

                <!-- EVENT CHECKBOX -->
                <div class="col-md-1 mt-4">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="eventCheckbox"
                      name="eventCheckbox"
                      v-model="MovieContainer.is_event"
                      @change="onClickEvent($event)"
                    />
                    <label class="form-check-label" for="eventCheckbox">
                      {{ "Event?" }}
                    </label>
                  </div>
                </div>
                <!-- EVENT CHECKBOX -->

                <!-- EVENT SECTION -->
                <div class="col-12" v-if="MovieContainer.is_event">
                  <div class="row pt-2 mb-2">
                    <div class="col-md-3 mb-2">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              MovieContainer.selected_parent_movie
                                ? 'shift-up'
                                : ''
                            "
                          >
                            {{ $t("parent_movie")
                            }}<span class="required_star">*</span>
                          </label>
                          <multiselect
                            v-model="MovieContainer.selected_parent_movie"
                            id="ajax"
                            label="movie_title"
                            track-by="movie_id"
                            placeholder="Parent Movie"
                            open-direction="bottom"
                            :options="Movies"
                            :multiple="false"
                            :searchable="true"
                            :loading="isSearchLoading"
                            :internal-search="false"
                            :clear-on-select="false"
                            :close-on-select="true"
                            :options-limit="300"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @select="onSelectParentMovie"
                            @search-change="onAsyncSearchParentMovie"
                            select-label="Select"
                            deselect-label="Remove"
                          >
                            <span slot="noOptions">Search Parent Movie</span>
                            <span slot="noResult">Oops! No Results found.</span>
                          </multiselect>
                        </div>
                      </div>
                      <p class="error_message">
                        <span
                          v-if="
                            submitted &&
                              showErrorMessages &&
                              !MovieContainer.selected_parent_movie
                          "
                          >{{ "Please Select Parent Movie" }}</span
                        >
                      </p>
                    </div>

                    <div
                      class="col-md-5 mb-2"
                      v-if="MovieContainer.selected_parent_movie"
                    >
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <label
                            :class="
                              MovieContainer.selected_version.length > 0
                                ? 'shift-up'
                                : ''
                            "
                          >
                            {{ $t("parent_version")
                            }}<span class="required_star">*</span>
                          </label>

                          <multiselect
                            v-model="MovieContainer.selected_version"
                            @input="onSelectParentVersion($event)"
                            @remove="onRemoveParentVersion($event)"
                            :allow-empty="false"
                            placeholder="Parent Version"
                            :options="versionArray"
                            label="version_name"
                            track-by="version_id"
                            :multiple="true"
                            name="parent_version"
                            id="parent_version"
                            select-label="Select"
                            deselect-label="Remove"
                          ></multiselect>
                        </div>
                      </div>
                      <p class="error_message">
                        <span
                          v-if="
                            submitted &&
                              showErrorMessages &&
                              MovieContainer.selected_version.length == 0
                          "
                          >{{ "Please Select Parent Version" }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
                <!-- EVENT SECTION -->

                <!-- GENRE MULTISELECT -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $tc("Genre", 1) }}
                      </label>
                      <multiselect
                        v-model="MovieContainer.genres"
                        :placeholder="'Genre'"
                        :options="Genres"
                        label="g_name"
                        track-by="g_id"
                        :multiple="true"
                        name="selectgenre"
                        id="selectgenre"
                        select-label="Select"
                        deselect-label="Remove"
                        :closeOnSelect="false"
                        :limit="2"
                        :limit-text="(count) => `& +${count} More`"
                      >
                        <span
                          class="checkbox-label"
                          slot="option"
                          slot-scope="scope"
                        >
                          <input
                            class="test"
                            type="checkbox"
                            :checked="
                              MovieContainer.genres.some(
                                (x) => scope.option.g_id == x.g_id
                              )
                            "
                            @focus.prevent
                          />
                          {{ scope.option.g_name }}
                        </span>
                      </multiselect>
                    </div>
                    <!-- <Tooltip :title="$t('movieselectgenre_tooltip')" /> -->
                  </div>
                </div>
                <!-- GENRE MULTISELECT -->

                <!-- HO CODE -->
                <div class="col-md-2 mb-2">
                  <label>{{ "HO Film Code" }}</label>
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        style="text-align: right"
                        v-model.trim="MovieContainer.ho_film_code"
                        :disabled="MovieContainer.is_event"
                        type="text"
                        name="ho_film_code"
                        id="ho_film_code"
                        placeholder="HO Film Code"
                      />
                    </div>
                  </div>
                </div>
                <!-- HO CODE -->

                <!-- LABELS MULTISELECT -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $t("label") }}
                      </label>
                      <multiselect
                        v-model="MovieContainer.labels"
                        :placeholder="'Movie Labels'"
                        :options="Labels"
                        label="label_name"
                        track-by="label_id"
                        :multiple="true"
                        name="movielabel"
                        id="movielabel"
                        select-label="Select"
                        deselect-label="Remove"
                        :closeOnSelect="false"
                        :limit="2"
                        :limit-text="(count) => `& +${count} More`"
                      >
                        <span
                          class="checkbox-label"
                          slot="option"
                          slot-scope="scope"
                        >
                          <input
                            class="test"
                            type="checkbox"
                            :checked="
                              MovieContainer.labels.some(
                                (x) => scope.option.label_id == x.label_id
                              )
                            "
                            @focus.prevent
                          />
                          {{ scope.option.label_name }}
                        </span>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <!-- LABELS MULTISELECT -->

                <div class="col-md-3">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <label
                        :class="[
                          '',
                          MovieContainer.original_release_date ? 'active' : '',
                        ]"
                        >Release Date (Original)<span class="required_star"
                          >*</span
                        ></label
                      >
                      <div class="add-datepicker">
                        <input
                          type="date"
                          min="1900-01-01"
                          placeholder="Original Release Date"
                          v-model="MovieContainer.original_release_date"
                          ref="programaticOpen"
                          name="originalreleasedate"
                          id="originalreleasedate"
                          @keypress.enter.prevent
                          @change="onChangeOriginalReleaseDate($event)"
                          @input="onInputOriginalReleaseDate($event)"
                        />
                      </div>
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        submitted &&
                          showErrorMessages &&
                          (errors.has('originalreleasedate') ||
                            !MovieContainer.original_release_date)
                      "
                      >{{ errors.first("originalreleasedate") }}</span
                    >
                  </p>
                </div>

                <!-- Movie titles of other languages -->
                <div
                  class="col-md-3 mb-5"
                  v-for="(MovieContent,
                  MovieContentIndex) in MovieContentContainer"
                  :key="MovieContentIndex"
                  v-if="
                    !EPIX_CLIENT &&
                      MovieContent.langauge.toLowerCase() != 'english'
                  "
                >
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <label>{{
                        `Movie Title (${MovieContent.langauge})`
                      }}</label>
                      <!-- <label>Movie Title ({{ MovieContent.langauge }})</label> -->
                      <input
                        v-model="MovieContent.movieContentTitle"
                        type="text"
                        :name="'movietitle' + MovieContentIndex"
                        id="'movietitle'+MovieContentIndex"
                        :placeholder="
                          `Movie Title
                      (${MovieContent.langauge})`
                        "
                      />
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        submitted &&
                          showErrorMessages &&
                          MovieContent.langauge.toLowerCase() === 'english' &&
                          !MovieContent.movieContentTitle
                      "
                      >Enter Movie Title For
                      {{ MovieContent.langauge }} Language</span
                    >
                  </p>
                </div>

                     <!---------Proudction Company------------>
                     <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label>
                        {{ $tc("production", 1)
                        }} {{ $tc("company", 1)
                      }}<span class="required_star">*</span>
                      </label>

                      <multiselect
                        v-model="selectedProductionCompany"
                        @select="onSelectProductionCompany($event)"
                        @remove="onRemoveProudctionCompany($event)"
                        placeholder="Producers"
                        :options="Productions"
                        label="production_name"
                        track-by="production_id"
                        :multiple="true"
                        name="selectorProductionCompany"
                        id="selectorProductionCompany"
                        select-label="Select"
                        deselect-label="Remove"
                        :closeOnSelect="false"
                        :limit="2"
                        :limit-text="(count) => `& +${count} More`"
                      ></multiselect>
                    </div>
                  </div>
                  <p class="error_message"></p>
                </div>
               <!---------Proudction Company------------>

               <div class="col-2 d-flex align-items-center justify-content-center">
                 <label class="mb-0">{{ "Foreign Movie" }}</label>
                 <b-form-checkbox
                   v-model="MovieContainer.ms_foreign_movie"
                   unchecked-value="N"
                   value="Y"
                   name="check-button"
                   class="j-checkbox ml-2 pb-0"
                 />
               </div>
              </div>

              <div class="row p-0 m-0">
                <div class="col-12 p-0">
                  <table
                    class="swc-report-table"
                    border="1"
                    style="table-layout: auto; background: white; zoom: 0.9"
                  >
                    <thead>
                      <tr>
                        <th class="bg-lightprimary p-1" style="width: 200px;">
                          Region<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 200px;">
                          Release Date<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 190px;">
                          Ratings<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 110px;">
                          Runtime<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 110px;">
                          Intermission<span class="required_star">*</span>
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 110px;">
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        MovieContainer.movieRatings &&
                          MovieContainer.movieRatings.length > 0
                      "
                    >
                      <template
                        v-for="(Rating,
                        RatingIndex) in MovieContainer.movieRatings"
                      >
                        <tr :key="RatingIndex">
                          <td class="text-left p-0 manual_bill_item">
                            <multiselect
                              v-model="Rating.region_obj"
                              placeholder="Region"
                              @select="
                                onSelectRatingRegionHandler($event, RatingIndex)
                              "
                              :options="Regions"
                              label="region_name"
                              track-by="region_id"
                              :multiple="false"
                              name="selectregion"
                              id="selectregion"
                              select-label="Select"
                              deselect-label="Remove"
                            />
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <div class="manual_bill_input">
                              <input
                                type="date"
                                min="1900-01-01"
                                placeholder="Release Date"
                                v-model="Rating.releaseDate"
                                :name="'releasedate' + RatingIndex"
                                :id="'releasedate' + RatingIndex"
                                @keypress.enter.prevent
                              />
                            </div>
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <multiselect
                              style="text-align: left"
                              v-model="Rating.selected_rating"
                              @select="
                                onSelectMovieRatingHandler($event, RatingIndex)
                              "
                              placeholder="Rating"
                              :options="Ratings"
                              label="rating"
                              track-by="rating_id"
                              :multiple="false"
                              name="selectrating"
                              id="selectrating"
                              select-label="Select"
                              deselect-label="Remove"
                              selectLabel=""
                            />
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <div class="manual_bill_input">
                              <input
                                style="text-align: right"
                                v-model="Rating.runTime"
                                type="text"
                                name="runtime"
                                id="runtime"
                                placeholder="Runtime"
                                @keypress.enter.prevent
                                @input="onChangeRuntime($event, RatingIndex)"
                              />
                            </div>
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <div class="manual_bill_input">
                              <input
                                style="text-align: right"
                                v-model="Rating.intervalTime"
                                type="text"
                                name="intervaltime"
                                id="intervaltime"
                                placeholder="Interval"
                                @keypress.enter.prevent
                              />
                            </div>
                          </td>
                          <td>
                            <div
                              class="icon-sm-minus blue-icon ml-2 btn"
                              @click.prevent.stop="
                                removeRating($event, RatingIndex)
                              "
                            ></div>
                          </td>
                        </tr>
                      </template>
                      <tr class="">
                        <td colspan="12">
                          <div
                            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                          >
                            <button
                              v-if="checkAddMoreRatings"
                              @click.prevent.stop="addMoreRating($event)"
                              class="btn-transparent add-more-button addBtn_multi"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="">
                        <td colspan="12">
                          <div
                            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                          >
                            <button
                              v-if="checkAddMoreRatings"
                              @click.prevent.stop="addMoreRating($event)"
                              class="btn-transparent add-more-button addBtn_multi"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-collapse>

          <div
            class="px-2 py-2"
            v-if="
              errorHandlerObj['errMsg'] &&
                errorHandlerObj['errorSectionIndex'] == 1
            "
          >
            <div class="error_message">{{ errorHandlerObj["errMsg"] }}</div>
          </div>
        </section>

        <!-- MOVIE CONTENT SECTIONS START -->
        <section
          class="mb-3"
          :class="
            errorHandlerObj['errorSectionIndex'] == 2 ? 'sectionError' : ''
          "
        >
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.movieContent
          >
            <span class="fs"
              >{{ $tc("movie", 1) }} {{ $tc("Information", 2) }}
              <!-- {{ $t("Synopsis") }} -->
              {{ !moviecontentexists ? ` - TBA` : "" }}</span
            >

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="movieContent"
            class="mt-2"
            v-model="sectionCollapse.movieContent"
          >
            <div class="bn-tabs-nav" v-if="!showContentListView">
              <button
                v-for="(MovieContent,
                MovieContentIndex) in MovieContentContainer"
                :key="MovieContentIndex"
                :class="[
                  'btn-tab-title ',
                  { active: MovieContentIndex == activeClass },
                ]"
                @click.prevent.stop="
                  onChangeTabHandler($event, MovieContentIndex)
                "
              >
                <strong>
                  <span
                    :class="
                      MovieContent.langauge.toLowerCase() !== 'english'
                        ? MovieContent.movieShortDescription &&
                          MovieContent.movieDescription
                          ? ''
                          : 'text-danger'
                        : ''
                    "
                    >{{ MovieContent.langauge }}</span
                  >

                  <button
                    @click.prevent.stop="
                      translateToOtherLangs(MovieContent, MovieContentIndex)
                    "
                    class="btn-blue btn-blue-sm"
                  >
                    Translate &nbsp;
                    <b-spinner
                      v-if="translationLoading[MovieContentIndex] == true"
                      small
                      variant="light"
                      label="Spinning"
                      class="translate-spinner"
                    ></b-spinner>
                  </button>
                </strong>
              </button>
            </div>

            <div
              class="bn-tabs-content border pt-4"
              v-if="!showContentListView"
            >
              <div
                v-for="(MovieContent,
                MovieContentIndex) in MovieContentContainer"
                :key="MovieContentIndex"
              >
                <div v-if="MovieContentIndex === activeClass">
                  <div class="row px-3">
                    <div class="col-md-2 align-items-center d-flex">
                      Short Description ({{ MovieContent.langauge }})
                    </div>
                    <div class="col-md-10">
                      <div class="d-flex align-items-center">
                        <div class="input-material-textarea">
                          <textarea
                            v-model="MovieContent.movieShortDescription"
                            rows="2"
                            placeholder="Movie Plot (Short Description)"
                            :name="
                              `short_movie_description_${MovieContentIndex}`
                            "
                            :id="`short_movie_description_${MovieContentIndex}`"
                          ></textarea>
                        </div>
                      </div>
                      <p class="error_message">
                        <span
                          v-if="
                            submitted &&
                              showErrorMessages &&
                              errors.has('short_movie_description')
                          "
                          >{{ errors.first("short_movie_description") }}</span
                        >
                      </p>
                    </div>

                    <div class="col-md-2 align-items-center d-flex">
                      Long Description ({{ MovieContent.langauge }})<span
                        class="required_star"
                        >*</span
                      >
                    </div>
                    <div class="col-md-10 mt-2">
                      <div class="d-flex align-items-center">
                        <div class="input-material-textarea">
                          <textarea
                            v-model="MovieContent.movieDescription"
                            rows="2"
                            placeholder="Movie Plot (Long Description)"
                            :name="
                              `long_movie_description_${MovieContentIndex}`
                            "
                            :id="`long_movie_description_${MovieContentIndex}`"
                            v-validate="
                              MovieContent.langauge.toLowerCase() === 'english'
                                ? 'required'
                                : ''
                            "
                          ></textarea>
                        </div>
                      </div>
                      <p class="error_message">
                        <span
                          v-if="
                            submitted &&
                              showErrorMessages &&
                              errors.has('long_movie_description')
                          "
                          >{{ errors.first("long_movie_description") }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="MovieContentIndex === activeClass">
                  <h6 class="text-uppercase my-3 mx-2">
                    {{ $t("cast") }} & {{ $tc("crew", 1) }} ({{
                      MovieContent.langauge
                    }})
                  </h6>
                  <table
                    class="swc-report-table"
                    border="1"
                    style="table-layout: auto; background: white; zoom: 0.9"
                  >
                    <thead>
                      <tr>
                        <th class="bg-lightprimary p-1" style="width: 160px">
                          Crew Type
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 620px">
                          Cast Name
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 80px">
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="cast_and_crew && cast_and_crew.length > 0">
                      <template
                        v-for="(CastAndCrewItem,
                        CastAndCrewIndex) in cast_and_crew[englishContentIndex]
                          .movieCastAndCrewList"
                      >
                        <tr :key="MovieContentIndex + '_' + CastAndCrewIndex">
                          <td class="text-left p-0 manual_bill_item">
                            <multiselect
                              v-model="CastAndCrewItem.selected_cast"
                              @select="
                                onSelectCrewHandler(
                                  CastAndCrewItem,
                                  $event,
                                  CastAndCrewItem,
                                  CastAndCrewIndex,
                                  englishContentIndex
                                )
                              "
                              placeholder="Select Cast And Crew"
                              :options="Crews"
                              label="crew_title"
                              track-by="crew_id"
                              :multiple="false"
                              select-label="Select"
                              deselect-label="Remove"
                            />
                          </td>
                          <td class="text-left p-0 manual_bill_item">
                            <multiselect
                              v-model="CastAndCrewItem.selectedCastMembers"
                              @select="
                                onAddCastCrewOption($event, CastAndCrewItem)
                              "
                              @remove="
                                onRemoveCastCrewOption($event, CastAndCrewItem)
                              "
                              placeholder="Select Cast And Crew"
                              :options="CastMasters"
                              label="cast_name"
                              track-by="mcm_id"
                              :multiple="true"
                              select-label="Select"
                              deselect-label="Remove"
                            >
                             <span slot="noResult">Oops! No Results found.</span>
                            <div slot="option" slot-scope="props">
                              <span class="d-flex align-items-center">
                                 <CastIcon :name="props.option.cast_name" :image_url="props.option.cast_image_url" :width="40" :height="40" :classes="''" /> <p>{{ props.option.cast_name }}</p>
                              </span>
                            </div>
                            </multiselect>
                            <!-- <div class="">
                              <EditablePills
                                :elements="CastAndCrewItem.members"
                                input_prop_name="person_name"
                                :addElement="
                                  () => addCastCrewMember(CastAndCrewItem)
                                "
                                :removeElement="
                                  (itemIndex) =>
                                    removeCastCrewMember(
                                      CastAndCrewItem,
                                      itemIndex
                                    )
                                "
                              />
                            </div> -->
                          </td>
                          <td>
                            <div
                              class="icon-sm-minus blue-icon ml-2 btn"
                              @click.prevent.stop="
                                removeCastAndCrew(
                                  $event,
                                  CastAndCrewIndex,
                                  englishContentIndex
                                )
                              "
                            ></div>
                          </td>
                        </tr>
                      </template>
                      <tr class="">
                        <td colspan="12">
                          <div
                            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                          >
                            <button
                              @click.prevent.stop="
                                addCastAndCrew($event, englishContentIndex)
                              "
                              class="btn-transparent add-more-button addBtn_multi"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="">
                        <td colspan="12">
                          <div
                            class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                          >
                            <button
                              @click.prevent.stop="
                                addCastAndCrew($event, englishContentIndex)
                              "
                              class="btn-transparent add-more-button addBtn_multi"
                            >
                              <img
                                src="@/assets/img/icons/plus.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-collapse>

          <div
            class="px-2 py-2"
            v-if="
              errorHandlerObj['errMsg'] &&
                errorHandlerObj['errorSectionIndex'] == 2
            "
          >
            <div class="error_message">{{ errorHandlerObj["errMsg"] }}</div>
          </div>
        </section>

        <!-- Artwork -->
        <section
          class="mb-3"
          :class="
            errorHandlerObj['errorSectionIndex'] == 3 ? 'sectionError' : ''
          "
        >
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.images
          >
            <span class="fs">Artwork & Images</span>

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse id="images" class="mt-2" v-model="sectionCollapse.images">
            <div class="row" v-if="false">
              <!-- Movie Copyright -->
              <div class="col-md-5">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <label>{{ $tc("movie", 1) }} Copyright</label>
                    <input
                      v-model="MovieContainer.copyright"
                      type="text"
                      name="moviecopyright"
                      id="moviecopyright"
                      placeholder="Copyright"
                    />
                  </div>
                </div>
              </div>
              <p class="error_message">
                <span
                  v-if="
                    submitted &&
                      showErrorMessages &&
                      (errors.has('moviecopyright') ||
                        !MovieContainer.moviecopyright)
                  "
                  >{{ errors.first("moviecopyright") }}</span
                >
              </p>
            </div>

            <!-- Language Specific Artwork -->
            <div
              class="col-md-12 mt-1 p-0 rounded-10 mb-2"
              v-if="MovieContentContainer && MovieContentContainer.length > 0"
            >
              <div class="row">
                <div
                  class="col-md-12 heading d-none"
                  v-if="
                    MovieContentContainer && MovieContentContainer.length > 0
                  "
                >
                  <h5>Artwork</h5>
                </div>
                <div class="col-md-8 my-2">
                  <table
                    class="swc-report-table"
                    border="1"
                    style="table-layout: auto; background: white; zoom: 0.9"
                  >
                    <thead>
                      <tr>
                        <th
                          class="bg-lightprimary p-1"
                          style="width: 250px"
                        ></th>
                        <th class="bg-lightprimary p-1" style="width: 302px">
                          Upload
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 620px">
                          URL
                        </th>
                        <th class="bg-lightprimary p-1" style="width: 200px">
                          Preview
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        MovieContentContainer &&
                          MovieContentContainer.length > 0
                      "
                    >
                      <template
                        v-for="(MovieContent,
                        MovieContentIndex) in MovieContentContainer"
                      >
                        <tr :key="MovieContentIndex">
                          <td
                            class="text-left p-0 manual_bill_item text-center"
                          >
                            <div
                              class=""
                              style="margin-bottom: 15px; margin-top: 15px;"
                              >Artwork ({{ MovieContent.langauge }})</div
                            >
                          </td>
                          <td>
                            <div
                              class="d-flex justify-content-center align-items-center"
                              @click.prevent.stop="
                                setModalData(
                                  PosterIndex,
                                  artwork_image_height,
                                  artwork_image_width,
                                  5,
                                  MovieContentIndex,
                                  'Movie Poster',
                                  {
                                    lang_id: MovieContent.langaugeId,
                                    lang_name: MovieContent.langauge,
                                  }
                                )
                              "
                            >
                              <span
                                class="uploadposterBtn fa fa-upload"
                                style="font-size: 22px"
                              ></span>
                            </div>
                          </td>
                          <td>
                            {{ MovieContent.artwork }}
                          </td>
                          <td>
                            <ImagePreviewer
                              v-if="
                                MovieContent.artwork &&
                                  MovieContent.artwork.length > 0
                              "
                              :img="_GetImagePath(MovieContent.artwork)"
                              :clickFunc="
                                () => {
                                  openImageModal(
                                    'Artwork' + `(${MovieContent.langauge})`,
                                    MovieContent.artwork
                                  );
                                }
                              "
                            />
                            <img
                              v-if="MovieContent.artwork"
                              src="@/assets/img/icons/trash.svg"
                              height="25"
                              width="25"
                              class="rounded cursor-pointer"
                              @click="removeImageHandler(MovieContent, 1)"
                            />
                          </td>
                        </tr>
                      </template>
                      <tr>
                        <td>Movie Copyright</td>
                        <td class="" colspan="3">
                          <div class="manual_bill_input">
                            <input
                              v-model="MovieContainer.copyright"
                              type="text"
                              name="moviecopyright"
                              id="moviecopyright"
                              placeholder="Copyright"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="col-md-12 my-2 p-0">
              <button
                type="button"
                class="btn-outline-blue-sm ml-auto mr-15px collapsed"
                v-b-toggle.images_sub_section
              >
                Show
                {{ !sectionCollapse.images_sub_section ? "More" : "Less" }}
                <button type="button" class="btn-transparent chevron">
                  <chevron />
                </button>
              </button>
            </div>
            <b-collapse
              id="images_sub_section"
              class="col-md-12 mt-2 px-0"
              v-model="sectionCollapse.images_sub_section"
            >
              <div class="new-border rounded-10 py-2">
                <!-- Original Artwork -->
                <!-- <div class="col-md-12">
                  <h5>Original Artwork</h5>
                </div> -->

                <div class="col-md-12 mb-2">
                  <div class="row">
                    <div class="col-3 pr-0">
                      <div
                        class="d-flex justify-content-center align-item-center"
                      >
                        <label
                          class="material-file-upload"
                          @click.prevent.stop="
                            setModalData(
                              null,
                              artwork_image_height,
                              artwork_image_width,
                              4,
                              undefined,
                              'Movie Poster',
                              MovieContainer.original_lang_name
                            )
                          "
                        >
                          <div
                            class="label"
                            v-bind:class="{
                              'shift-up':
                                MovieContainer.original_artwork &&
                                MovieContainer.original_artwork.length > 0,
                            }"
                          >
                            Original Artwork
                          </div>
                          <div class="uploaded-file-name">
                            <div class="text-truncate pt-2">
                              {{ MovieContainer.original_artwork }}
                            </div>
                          </div>
                        </label>
                      </div>
                      <p class="error_message">
                        <!-- <span
                            v-if="
                              submitted &&
                                showErrorMessages &&
                                (!MovieContainer.original_artwork ||
                                  MovieContainer.original_artwork.length == 0)
                            "
                            >{{ messagepimage }}</span
                          > -->
                      </p>
                    </div>

                    <div class="col-2 pt-1 position-relative">
                      <ImagePreviewer
                        v-if="
                          MovieContainer.original_artwork &&
                            MovieContainer.original_artwork.length > 0
                        "
                        :img="_GetImagePath(MovieContainer.original_artwork)"
                        :clickFunc="
                          () => {
                            openImageModal(
                              'Original Artwork',
                              MovieContainer.original_artwork
                            );
                          }
                        "
                      />
                      <img
                        v-else
                        src="@/assets/img/icons/empty-image.svg"
                        alt="Empty Image"
                        height="35"
                        width="35"
                        class="rounded"
                      />
                      <img
                        v-if="MovieContainer.original_artwork !== ''"
                        src="@/assets/img/icons/trash.svg"
                        height="25"
                        width="25"
                        class="rounded cursor-pointer"
                        @click="removeImageHandler(MovieContainer, 5)"
                      />
                    </div>
                  </div>
                </div>

                <!-- Language Specific Other Images -->
                <div
                  class="col-md-12 mt-2"
                  v-if="
                    MovieContentContainer[0] &&
                      MovieContentContainer[0].moviePosters &&
                      MovieContentContainer[0].moviePosters.length > 0
                  "
                >
                  <h6 class="font-weight-bold"
                    >Language Specific Other Images (optional)</h6
                  >
                </div>

                <div
                  class="col-md-12 mt-1"
                  v-if="
                    MovieContentContainer[0] &&
                      MovieContentContainer[0].moviePosters &&
                      MovieContentContainer[0].moviePosters.length > 0
                  "
                >
                  <div class="row">
                    <div
                      class="col-md-4"
                      v-for="(MovieContent,
                      MovieContentIndex) in MovieContentContainer"
                      :key="MovieContentIndex"
                    >
                      <h6 class="my-2">{{ MovieContent.langauge }}</h6>
                      <div class="row">
                        <div
                          v-for="(PosterItem,
                          PosterIndex) in MovieContent.moviePosters"
                          :key="PosterIndex + PosterItem.image_setting_name"
                          class="col-md-12 mb-3"
                        >
                          <div class="row">
                            <div class="col-8 pr-0">
                              <label
                                class="material-file-upload c-pointer"
                                @click.prevent.stop="
                                  setModalData(
                                    PosterIndex,
                                    PosterItem.image_setting_height,
                                    PosterItem.image_setting_width,
                                    2,
                                    MovieContentIndex,
                                    'Movie Poster',
                                    {
                                      lang_id: MovieContent.langaugeId,
                                      lang_name: MovieContent.langauge,
                                    }
                                  )
                                "
                              >
                                <div
                                  class="label"
                                  v-bind:class="{
                                    'shift-up':
                                      PosterItem.image_setting_path &&
                                      PosterItem.image_setting_path.length > 0,
                                  }"
                                >
                                  <div class="text-truncate">
                                    {{
                                      PosterItem.image_setting_name +
                                        " - " +
                                        PosterItem.image_setting_width +
                                        " X " +
                                        PosterItem.image_setting_height
                                    }}
                                  </div>
                                </div>
                                <div class="uploaded-file-name">
                                  <div class="text-truncate pt-2">
                                    {{ PosterItem.image_setting_path }}
                                  </div>
                                </div>
                              </label>
                            </div>
                            <div
                              class="col-4 align-self-start position-relative"
                            >
                              <ImagePreviewer
                                v-if="
                                  PosterItem.image_setting_path &&
                                    PosterItem.image_setting_path.length > 0
                                "
                                :img="
                                  _GetImagePath(PosterItem.image_setting_path)
                                "
                                :clickFunc="
                                  () => {
                                    openImageModal(
                                      PosterItem.image_setting_name,
                                      PosterItem.image_setting_path
                                    );
                                  }
                                "
                              />
                              <img
                                v-else
                                src="@/assets/img/icons/empty-image.svg"
                                height="35"
                                width="35"
                                class="rounded"
                              />
                              <img
                                v-if="PosterItem.image_setting_path !== ''"
                                src="@/assets/img/icons/trash.svg"
                                height="25"
                                width="25"
                                class="rounded cursor-pointer"
                                @click="removeImageHandler(PosterItem, 2)"
                              />
                              <!-- <img
                                  src="@/assets/img/icons/question.svg"
                                  height="20"
                                  width="20"
                                  class="ml-2"
                                  v-b-tooltip.hover
                                  :title="PosterItem.image_setting_desciption"
                                /> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Movie Scenes -->
                <div class="col-md-12 rounded-10">
                  <div class="col-md-12 heading pl-0">
                    <h5>Movie Scenes</h5>
                  </div>

                  <div class="col-md-12 mb-2">
                    <div class="row">
                      <div
                        v-for="(movieScenesItem,
                        movieScenesIndex) in movieScenes"
                        :key="movieScenesIndex"
                        class="col-md-1 mb-2 maxW85"
                      >
                        <div
                          class="movieSceneImageIcon"
                          v-if="movieScenesItem.image_path"
                        >
                          <img
                            :src="_GetImagePath(movieScenesItem.image_path)"
                            class="image-circle"
                            @click.prevent.stop="
                              setModalData(
                                movieScenesIndex,
                                NaN,
                                NaN,
                                3,
                                undefined,
                                'Movie Scene'
                              )
                            "
                          />
                          <div class="movieSceneImageoptions">
                            <div class="col-6 borderRight">
                              <span
                                class="icon-eye"
                                @click="
                                  openImageModal(
                                    'Scene Image',
                                    movieScenesItem.image_path
                                  )
                                "
                              ></span>
                            </div>
                            <div class="col-6">
                              <span
                                class="icon-delete-red"
                                @click="
                                  removeSceneImage($event, movieScenesIndex)
                                "
                              ></span>
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="false">
                          <div class="col-6 p-0">
                            <label
                              class="material-file-upload c-pointer"
                              @click.prevent.stop="
                                setModalData(
                                  movieScenesIndex,
                                  NaN,
                                  NaN,
                                  3,
                                  undefined,
                                  'Movie Scene'
                                )
                              "
                            >
                              <div
                                class="label"
                                v-bind:class="{
                                  'shift-up':
                                    movieScenesItem.image_path &&
                                    movieScenesItem.image_path.length > 0,
                                }"
                              >
                                <div class="text-truncate">
                                  Scene Image {{ movieScenesIndex + 1 }}
                                </div>
                              </div>
                              <div class="uploaded-file-name">
                                <div class="text-truncate pt-2">
                                  {{ movieScenesItem.image_path }}
                                </div>
                              </div>
                            </label>
                          </div>
                          <div class="col-6 align-self-start position-relative">
                            <ImagePreviewer
                              v-if="
                                movieScenesItem.image_path &&
                                  movieScenesItem.image_path.length > 0
                              "
                              :img="_GetImagePath(movieScenesItem.image_path)"
                              :clickFunc="
                                () => {
                                  openImageModal(
                                    'Scene Image',
                                    movieScenesItem.image_path
                                  );
                                }
                              "
                            />
                            <img
                              v-else
                              src="@/assets/img/icons/empty-image.svg"
                              height="35"
                              width="35"
                              class="rounded"
                            />
                            <img
                              v-if="movieScenesItem.image_path !== ''"
                              src="@/assets/img/icons/trash.svg"
                              height="25"
                              width="25"
                              class="rounded cursor-pointer"
                              @click="removeImageHandler(movieScenesItem, 3)"
                            />
                            <button
                              @click.prevent.stop="
                                removeSceneImage($event, movieScenesIndex)
                              "
                              class="btn-transparent"
                            >
                              <img
                                src="@/assets/img/icons/minus.svg"
                                height="30"
                                width="30"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="movieSceneImage">
                        <div
                          class="plusScenes"
                          @click.prevent.stop="
                            setModalData(
                              null,
                              NaN,
                              NaN,
                              7,
                              undefined,
                              'Movie Scene'
                            )
                          "
                        >
                          &#x254b;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-collapse>
        </section>

        <!-- Signage Section -->
        <section class="mb-3">
          <div
            class="
              section-title
              mb-3
              d-flex
              justify-content-between
              section-border section-border
            "
            style="padding:6px;align-items:center"
            v-b-toggle.signage
          >
            <span class="fs">Signage Images</span>

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="signage"
            class="mt-2"
            v-model="sectionCollapse.signage"
          >
            <div class="">
              <!-- Movie Scenes -->

              <div class="col-md-12 new-border rounded-10 back">
                <div class="col-md-12 my-2">
                  <div class="row">
                    <div class="col-11">
                      <div class="row">
                        <div
                          v-for="(signageItem,
                          signageItemIndex) in signageContainer"
                          :key="signageItemIndex + 'SignageContainer'"
                          class="col-md-12 mb-3"
                        >
                          <div class="row">
                            <div class="col-1 pl-0">
                              <div class="input-material mt-2">
                                <input
                                  type="number"
                                  v-model="signageItem.width"
                                  :disabled="signageItemIndex < 2"
                                  placeholder="Set Width"
                                />
                              </div>
                            </div>
                            <div class="col-1 pl-0">
                              <div class="input-material mt-2">
                                <input
                                  type="number"
                                  v-model="signageItem.height"
                                  :disabled="signageItemIndex < 2"
                                  placeholder="Set Height"
                                />
                              </div>
                            </div>
                            <div class="col-3 pl-0">
                              <label
                                class="material-file-upload c-pointer"
                                @click.prevent.stop="
                                  setModalData(
                                    signageItemIndex,
                                    signageItem.height,
                                    signageItem.width,
                                    6,
                                    undefined,
                                    'Signage Scene'
                                  )
                                "
                              >
                                <div
                                  class="label"
                                  v-bind:class="{
                                    'shift-up':
                                      signageItem.imageUrl &&
                                      signageItem.imageUrl.length > 0,
                                  }"
                                >
                                  <div class="text-truncate">
                                    Signage Image {{ signageItemIndex + 1 }}
                                  </div>
                                </div>
                                <div class="uploaded-file-name">
                                  <div class="text-truncate pt-2">
                                    {{ signageItem.imageUrl }}
                                  </div>
                                </div>
                              </label>
                            </div>

                            <div
                              class="col-2 align-self-start"
                              v-if="signageItem.imageUrl"
                            >
                              <ImagePreviewer
                                :img="_GetImagePath(signageItem.imageUrl)"
                                :clickFunc="
                                  () => {
                                    openImageModal(
                                      'Signage ' + `(${signageItem.imageUrl})`,
                                      signageItem.imageUrl
                                    );
                                  }
                                "
                              />
                              <img
                                v-if="signageItem.imageUrl"
                                src="@/assets/img/icons/download.svg"
                                height="25"
                                width="25"
                                class="rounded cursor-pointer"
                                @click="
                                  downloadImageSignage(
                                    signageItem,
                                    signageItemIndex
                                  )
                                "
                              />
                              <img
                                v-if="signageItem.imageUrl"
                                src="@/assets/img/icons/trash.svg"
                                height="25"
                                width="25"
                                class="rounded cursor-pointer"
                                @click="deleteImageSignage(signageItemIndex)"
                              />
                              <!-- <img
                          src="@/assets/img/icons/question.svg"
                          height="20"
                          width="20"
                          class="ml-2"
                          v-b-tooltip.hover
                          :title="
                            `Upload Artwork for the ${MovieContent.langauge} language`
                          "
                        /> -->
                            </div>
                            <div class="col-1" v-if="signageItemIndex > 1">
                              <img
                                class="rounded cursor-pointer"
                                @click.prevent.stop="
                                  removeSignage(signageItemIndex)
                                "
                                src="@/assets/img/icons/minus.svg"
                                height="35"
                                width="35"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="
                      col-1
                      d-flex
                      justify-content-center
                      align-items-center
                      border-left
                    "
                    >
                      <button
                        @click.prevent.stop="addSignageData()"
                        class="btn-transparent"
                      >
                        <img
                          src="@/assets/img/icons/plus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="new-border rounded-10 col-12 mt-2 back">
              <section class="m-2">
                <div class="col-md-12 text-center">
                  <button
                    :disabled="btenable"
                    class="btn-blue"
                    @click.prevent.stop="updateStep1('5')"
                  >
                    {{ 'Update Signage Images' }}
                  </button>
                </div>
              </section>
            </div> -->
          </b-collapse>
        </section>
        <!-- Trailers -->
        <section
          class="mb-3"
          :class="
            errorHandlerObj['errorSectionIndex'] == 4 ? 'sectionError' : ''
          "
        >
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.trailers
          >
            <span class="fs">Trailers</span>

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="trailers"
            class="mt-2"
            v-model="sectionCollapse.trailers"
          >
            <section class="row">
              <div class="w-100 mx-3 mb-3">
                <table
                  class="swc-report-table"
                  border="1"
                  style="table-layout: auto; background: white; zoom: 0.9"
                >
                  <thead>
                    <tr>
                      <th class="bg-lightprimary p-1" style="width: 160px">
                        Language
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 620px">
                        Trailer Link
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 110px">
                        Preview
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 110px">
                        Subtitle 1
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 110px">
                        Subtitle 2
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 80px"> </th>
                    </tr>
                  </thead>
                  <tbody v-if="movie_trailers && movie_trailers.length > 0">
                    <template
                      v-for="(movieTrailer,
                      movieTrailerIndex) in movie_trailers"
                    >
                      <tr :key="movieTrailerIndex">
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="movieTrailer.language"
                            @select="
                              onSelectLanguageHandler(
                                $event,
                                movieTrailerIndex,
                                1
                              )
                            "
                            placeholder="Language"
                            :options="Languages"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            :name="`trailerlang${movieTrailerIndex}`"
                            :id="`trailerlang${movieTrailerIndex}`"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td class="text-left p-0">
                          <div class="manual_bill_input">
                            <input
                              v-model="movieTrailer.trailer_link"
                              type="text"
                              :name="'langtrailer' + movieTrailerIndex"
                              id="'langtrailer' + movieTrailerIndex"
                              placeholder="Trailer Link"
                            />
                          </div>
                        </td>
                        <td>
                          <a
                            v-if="movieTrailer.trailer_link"
                            :href="movieTrailer.trailer_link"
                            @click.prevent="
                              openTrailerPopup(movieTrailer.trailer_link)
                            "
                            class="video-btn-play"
                          ></a>
                          <div class="" v-else>NA</div>
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="movieTrailer.subtitle_lang_1"
                            @select="
                              onSelectSubtitleLanguageHandler(
                                $event,
                                movieTrailerIndex,
                                1,
                                1
                              )
                            "
                            placeholder="Subtitles"
                            :options="Languages"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            :name="`trailersublang1${movieTrailerIndex}`"
                            :id="`trailersublang1${movieTrailerIndex}`"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="movieTrailer.subtitle_lang_2"
                            @select="
                              onSelectSubtitleLanguageHandler(
                                $event,
                                movieTrailerIndex,
                                2,
                                1
                              )
                            "
                            placeholder="Subtitles"
                            :options="Languages"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            :name="`trailersublang2${movieTrailerIndex}`"
                            :id="`trailersublang2${movieTrailerIndex}`"
                            selectLabel=""
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td>
                          <div
                            class="icon-sm-minus blue-icon ml-2 btn"
                            @click.prevent.stop="
                              removeMovieTrailer(movieTrailerIndex)
                            "
                          ></div>
                        </td>
                      </tr>
                    </template>
                    <tr class="">
                      <td colspan="12">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="addMovieTrailer()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="">
                      <td colspan="12">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="addMovieTrailer()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </b-collapse>
        </section>

        <!-- MOVIE DETAILS - MOVIE FORMAT - MOVIE LANGUAGES - MOVIE DISTRIBUTOR -->
        <section class="mb-3">
          <div
            class="section-title mb-1 d-flex justify-content-between section-border section-border"
            style="padding: 6px; align-items: center"
            v-b-toggle.movieDetails
          >
            <div>
              <span class="fs"> Feature {{ $tc("Versions", 2) }} </span>
              <span class="font-weight-normal fs">
                {{ featureVersionsText }}
              </span>
            </div>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="movieDetails"
            class="mt-2"
            v-model="sectionCollapse.detailsAndDistributors"
          >
            <section class="row">
              <div class="w-100 mx-3">
                <table
                  class="swc-report-table"
                  border="1"
                  style="table-layout: auto; background: white; zoom: 0.9"
                >
                  <thead>
                    <tr>
                      <th class="bg-lightprimary p-1" style="width: 160px">
                        Content Type<span class="required_star">*</span>
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 180px">
                        Language<span class="required_star">*</span>
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 145px">
                        Subtitle 1
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 145px">
                        Subtitle 2
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 200px">
                        Exp Format
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 160px">
                        Distributor<span class="required_star">*</span>
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 190px">
                        Sound Format
                      </th>
                      <!-- <th class="bg-lightprimary p-1" style="width: 190px">
                        Resolution
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 190px">
                        Aspect Ratio
                      </th> -->
                      <th class="bg-lightprimary p-1" style="width: 125px">
                        Update Poster
                      </th>
                      <th class="bg-lightprimary p-1" style="width: 80px"
                        >More</th
                      >
                      <th class="bg-lightprimary p-1" style="width: 80px"> </th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      MovieContainer.movieLangaugeFormatDistributor.length > 0
                    "
                  >
                    <template
                      v-for="(LangaugeFormatDistributor,
                      LangaugeFormatDistributorIndex) in MovieContainer.movieLangaugeFormatDistributor"
                    >
                      <tr
                        :key="`fv_` + LangaugeFormatDistributorIndex"
                        :class="
                          errorHandlerObj['errorSectionIndex'] == 5 &&
                          errorHandlerObj['errorArrayIndex'] ==
                            LangaugeFormatDistributorIndex
                            ? 'sectionError'
                            : ''
                        "
                      >
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            select-label="Select"
                            deselect-label="Remove"
                            v-model="
                              LangaugeFormatDistributor.searchable_format
                            "
                            :disabled="
                              checkDisableFeatureVersion(
                                LangaugeFormatDistributor
                              )
                            "
                            @select="
                              onSelectFormatHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            @remove="
                              onRemoveContentType(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            placeholder="Content Type"
                            :options="Formats"
                            label="mf_name"
                            track-by="mf_id"
                            :multiple="false"
                            name="selectformat"
                            id="selectformat"
                            v-validate="'required'"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            select-label="Select"
                            deselect-label="Remove"
                            v-model="
                              LangaugeFormatDistributor.searchable_language
                            "
                            :disabled="
                              checkDisableFeatureVersion(
                                LangaugeFormatDistributor
                              )
                            "
                            @select="
                              onSelectLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            @remove="
                              onRemoveLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            :placeholder="$tc('language', 1)"
                            :options="Languages"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            name="selectlanguage"
                            id="selectlanguage"
                            v-validate="'required'"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            select-label="Select"
                            deselect-label="Remove"
                            v-model="
                              LangaugeFormatDistributor.subtitle_language_name_1
                            "
                            @select="
                              onSelectSubtitleLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex,
                                1
                              )
                            "
                            @remove="
                              onRemoveSubtitleLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex,
                                1
                              );
                              checkScheduleExistsAlertForModification(
                                LangaugeFormatDistributor
                              );
                            "
                            placeholder="Subtitle 1"
                            :options="LanguagesCopy"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            name="selectsubtitlelanguage1"
                            id="selectsubtitlelanguage1"
                            :internalSearch="false"
                            @search-change="onSearchLanguage"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            select-label="Select"
                            deselect-label="Remove"
                            v-model="
                              LangaugeFormatDistributor.subtitle_language_name_2
                            "
                            @select="
                              onSelectSubtitleLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex,
                                2
                              )
                            "
                            @remove="
                              onRemoveSubtitleLanguageHandler(
                                $event,
                                LangaugeFormatDistributorIndex,
                                2
                              );
                              checkScheduleExistsAlertForModification(
                                LangaugeFormatDistributor
                              );
                            "
                            placeholder="Subtitle 2"
                            :options="LanguagesCopy"
                            label="lang_name"
                            track-by="lang_id"
                            :multiple="false"
                            name="selectsubtitlelanguage2"
                            id="selectsubtitlelanguage2"
                            :internalSearch="false"
                            @search-change="onSearchLanguage"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            select-label="Select"
                            deselect-label="Remove"
                            v-model="
                              LangaugeFormatDistributor.movie_experience_format_name
                            "
                            :disabled="
                              checkDisableFeatureVersion(
                                LangaugeFormatDistributor
                              )
                            "
                            @select="
                              onSelectExperienceHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            @remove="
                              onRemoveExperienceHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            placeholder="Experience Format"
                            :options="Experiences"
                            label="movie_experience"
                            track-by="movie_experience_id"
                            :multiple="false"
                            name="selectExperience"
                            id="selectExperience"
                          />
                        </td>
                        <td
                          class="text-left p-0 manual_bill_item"
                          v-for="(DistributorItem,
                          DistributorIndex) in LangaugeFormatDistributor.movieDistributors"
                          :key="DistributorIndex"
                        >
                          <multiselect
                            select-label="Select"
                            deselect-label="Remove"
                            v-model="DistributorItem.selected_distributor"
                            @select="
                              onSelectDistributorHandler(
                                $event,
                                DistributorIndex,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            @remove="
                              onRemoveDistributorHandler(
                                $event,
                                DistributorIndex,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            :options="Distributors"
                            label="d_company_name"
                            placeholder="Distributor"
                            track-by="d_id"
                            :multiple="false"
                            name="selectdistributor-1"
                            id="selectdistributor-1"
                            class="text-wrap-multiselect"
                            v-validate="'required'"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.selected_sound_format
                            "
                            @select="
                              onSelectSoundFormatHandler(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            @remove="
                              onRemoveSoundFormat(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            :multiple="false"
                            :options="soundFormatList"
                            :searchable="true"
                            label="sound_format_name"
                            track-by="sound_format_name"
                            placeholder="Sound Format"
                            select-label="Select"
                            deselect-label="Remove"
                          ></multiselect>
                        </td>
                        <!-- HIDE RESOLUTION AND ASPECT RATIO -->
                        <td class="text-left p-0 manual_bill_item" v-if="false">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.movie_resolution_name
                            "
                            @select="
                              onSelectMovieResolution(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            :placeholder="$tc('Resolution', 1)"
                            :options="Resolutions"
                            label="resolution_short_code"
                            track-by="resolution_id"
                            :multiple="false"
                            name="selectResolution"
                            id="selectResolution"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <td class="text-left p-0 manual_bill_item" v-if="false">
                          <multiselect
                            v-model="
                              LangaugeFormatDistributor.movie_aspect_ratio_name
                            "
                            @select="
                              onSelectAspectRatio(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                            placeholder="Aspect Ratio"
                            :options="AspectRatios"
                            label="aspect_ratio_name"
                            track-by="aspect_ratio_id"
                            :multiple="false"
                            name="selectAspectRatio"
                            id="selectAspectRatio"
                            select-label="Select"
                            deselect-label="Remove"
                          />
                        </td>
                        <!-- HIDE RESOLUTION AND ASPECT RATIO -->
                        <td>
                          <div
                            class=""
                            v-if="LangaugeFormatDistributor.md_thumbnail_url"
                          >
                            <ImagePreviewer
                              :img="
                                _GetImagePath(
                                  LangaugeFormatDistributor.md_thumbnail_url
                                )
                              "
                              :clickFunc="
                                () => {
                                  openImageModal(
                                    LangaugeFormatDistributor.md_thumbnail_name,
                                    LangaugeFormatDistributor.md_thumbnail_url
                                  );
                                }
                              "
                            />
                            <img
                              v-if="!LangaugeFormatDistributor.md_thumbnail_url"
                              src="@/assets/img/icons/trash.svg"
                              height="20"
                              width="20"
                              class="rounded cursor-pointer"
                              @click="
                                removeImageHandler(LangaugeFormatDistributor, 4)
                              "
                            />
                            <img
                              v-if="LangaugeFormatDistributor.md_thumbnail_url"
                              src="@/assets/img/icons/trash.svg"
                              height="25"
                              width="25"
                              class="rounded cursor-pointer"
                              @click="deleteImageUrl(LangaugeFormatDistributor)"
                            />
                          </div>
                          <div
                            v-else
                            class="d-flex justify-content-center align-items-center"
                            @click.prevent.stop="
                              setModalData(
                                LangaugeFormatDistributorIndex,
                                artwork_image_height,
                                artwork_image_width,
                                1,
                                undefined,
                                'Movie Poster',
                                LangaugeFormatDistributor.lang_name
                              )
                            "
                          >
                            <span
                              class="uploadposterBtn fa fa-upload"
                              style="font-size: 22px"
                            ></span>
                          </div>
                        </td>
                        <td>
                          <div
                            v-b-toggle="
                              `fv_collapse_${LangaugeFormatDistributorIndex}`
                            "
                          >
                            <button
                              type="button"
                              class="btn-transparent chevron"
                            >
                              <img
                                src="@/assets/img/icons/primary/chevron-down.svg"
                                height="24"
                                width="24"
                              />
                            </button>
                          </div>
                        </td>
                        <td>
                          <div
                            class="icon-sm-minus blue-icon ml-2 btn"
                            @click.prevent.stop="
                              removeLangaugeFormatDistributor(
                                $event,
                                LangaugeFormatDistributorIndex
                              )
                            "
                          ></div>
                        </td>
                      </tr>
                      <b-collapse
                        v-model="LangaugeFormatDistributor['showMore']"
                        :key="LangaugeFormatDistributorIndex"
                        :id="`fv_collapse_${LangaugeFormatDistributorIndex}`"
                        class="mt-2"
                        tag="tr"
                      >
                        <td
                          class="fv_collapse_inner"
                          colspan="10"
                          v-if="LangaugeFormatDistributor['showMore']"
                        >
                          <div class="row fv_collapse_inner_container">
                            <!-- Cinema Selection -->
                            <div class="col-3 mb-2">
                              <div class="row">
                                <div class="col-12 d-block align-items-center">
                                  <div class="dropdown-curve-container">
                                    <label>
                                      Cinema Code
                                      <span class="required_star"
                                        >*</span
                                      ></label
                                    >
                                    <multiselect
                                      v-model="
                                        LangaugeFormatDistributor.selected_cinema
                                      "
                                      track-by="cine_id"
                                      label="cine_code"
                                      :close-on-select="false"
                                      :options="newgroupRegionCinema"
                                      :multiple="true"
                                      group-values="Cinemas"
                                      group-label="label"
                                      :group-select="true"
                                      :limit="2"
                                      :limit-text="
                                        (count) => `& +${count} More`
                                      "
                                    >
                                      <span
                                        v-if="
                                          scope.option &&
                                            scope.option.hasOwnProperty(
                                              '$isLabel'
                                            ) &&
                                            scope.option['$isLabel']
                                        "
                                        class="checkbox-label"
                                        slot="option"
                                        slot-scope="scope"
                                      >
                                        {{ scope.option["$groupLabel"] }}
                                      </span>

                                      <span
                                        v-else
                                        class="checkbox-label"
                                        slot="option"
                                        slot-scope="scope"
                                      >
                                        <input
                                          class="test"
                                          type="checkbox"
                                          :checked="
                                            LangaugeFormatDistributor.selected_cinema.some(
                                              (x) =>
                                                scope.option.cine_id ==
                                                x.cine_id
                                            )
                                          "
                                          @focus.prevent
                                        />
                                        {{ scope.option.cine_name }}
                                      </span>
                                    </multiselect>
                                  </div>

                                  <p class="error_message"></p>
                                </div>
                              </div>
                            </div>
                            <div class="col-3 mb-2">
                              <div class="row">
                                <div class="col-12 d-block align-items-center">
                                  <div class="dropdown-curve-container">
                                    <label> Sales Channel </label>
                                    <multiselect
                                      v-model="
                                        LangaugeFormatDistributor.sales_channel
                                      "
                                      track-by="user_id"
                                      label="username"
                                      :close-on-select="false"
                                      :options="aggregatorUsersList"
                                      :multiple="true"
                                      :limit="2"
                                      :limit-text="
                                        (count) => `& +${count} More`
                                      "
                                    >
                                      <span
                                        class="checkbox-label"
                                        slot="option"
                                        slot-scope="scope"
                                      >
                                        <input
                                          class="test"
                                          type="checkbox"
                                          :checked="
                                            LangaugeFormatDistributor.sales_channel &&
                                              LangaugeFormatDistributor.sales_channel.some(
                                                (x) =>
                                                  scope.option.user_id ==
                                                  x.user_id
                                              )
                                          "
                                          @focus.prevent
                                        />
                                        {{ scope.option.username }}
                                      </span>
                                    </multiselect>
                                  </div>

                                  <p class="error_message">
                                    <span
                                      v-if="
                                        submitted &&
                                          showErrorMessages &&
                                          LangaugeFormatDistributor.sales_channel &&
                                          LangaugeFormatDistributor
                                            .sales_channel.length == 0
                                      "
                                      >{{ messagesaleschannel }}</span
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2 mb-2">
                              <label>{{ $tc("trailer", 2) }}</label>
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    v-model="LangaugeFormatDistributor.trailer"
                                    type="text"
                                    name="trailers"
                                    id="trailers"
                                    placeholder="Trailer Link"
                                    @change="
                                      checkScheduleExistsAlertForModification(
                                        LangaugeFormatDistributor
                                      )
                                    "
                                  />
                                </div>
                                <!-- <Tooltip :title="$t('movietrailer_tooltip')" /> -->
                                <a
                                  v-if="LangaugeFormatDistributor.trailer"
                                  data-v-1c16c5c0=""
                                  :href="LangaugeFormatDistributor.trailer"
                                  data-fancybox=""
                                  class="video-btn-play"
                                  @click.prevent="
                                    openTrailerPopup(
                                      LangaugeFormatDistributor.trailer
                                    )
                                  "
                                ></a>
                              </div>
                              <p class="error_message">
                                <span></span>
                              </p>
                            </div>
                            <div class="col-md-3 d-flex align-items-center">
                              <div
                                class="d-flex justify-content-center align-items-center"
                              >
                                <b-form-checkbox
                                  v-model="
                                    LangaugeFormatDistributor.macs_status
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  class="j-checkbox mx-3"
                                >
                                  <div class="text-capitalize">
                                    {{ $t("send_to_maccs") }}
                                  </div>
                                </b-form-checkbox>
                                <b-form-checkbox
                                  v-if="QFX_CLIENT || showForeignMovieSection"
                                  v-model="
                                    LangaugeFormatDistributor.is_foreign_movie
                                  "
                                  unchecked-value="N"
                                  value="Y"
                                  class="j-checkbox mx-3"
                                >
                                  <div class="text-capitalize">
                                    {{
                                      !showForeignMovieSection
                                        ? "Foreign Movie"
                                        : "Indian Movie"
                                    }}
                                  </div>
                                </b-form-checkbox>
                              </div>
                            </div>
                          </div>
                        </td>
                      </b-collapse>
                    </template>
                    <tr class="">
                      <td colspan="12">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="
                              addLangaugeFormatDistributor($event)
                            "
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="">
                      <td colspan="12">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="
                              addLangaugeFormatDistributor($event)
                            "
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </b-collapse>

          <div
            class="px-2 py-2"
            v-if="
              errorHandlerObj['errMsg'] &&
                errorHandlerObj['errorSectionIndex'] == 5
            "
          >
            <div class="error_message">{{ errorHandlerObj["errMsg"] }}</div>
          </div>
        </section>

        <!-- CUSTOM FIELDS SECTION -->
        <section class="mb-3">
          <div
            class="
              section-title
              mb-3
              d-flex
              justify-content-between
              section-border section-border
            "
            style="padding:6px;align-items:center"
            v-b-toggle.customFields
          >
            <span class="fs"
              >Additional Information
              {{
                !additionalContentExists && !EPIX_CLIENT ? " - TBA" : ""
              }}</span
            >

            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>

          <b-collapse
            id="customFields"
            class="mt-2"
            v-model="sectionCollapse.customFields"
          >
            <!-- Remarks -->
            <div class="row">
              <div
                class="col-md-3 mb-5"
                v-for="(MovieContent,
                MovieContentIndex) in MovieContentContainer"
                :key="MovieContentIndex"
                v-if="EPIX_CLIENT && MovieContentIndex == 0"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <label>{{ "WhatsApp Movie Title" }}</label
                    ><span class="required_star" v-if="EPIX_CLIENT">*</span>
                    <!-- <label>Movie Title ({{ MovieContent.langauge }})</label> -->
                    <input
                      v-model="MovieContent.movieContentTitle"
                      type="text"
                      :name="'movietitle' + MovieContentIndex"
                      id="'movietitle'+MovieContentIndex"
                      :placeholder="`WhatsApp Movie Title`"
                    />
                  </div>
                </div>
                <p class="error_message">
                  <span
                    v-if="
                      EPIX_CLIENT &&
                        submitted &&
                        MovieContent.movieContentTitle.length > 24
                    "
                    >Please Enter Movie Title For WhatsApp less then 24
                    characters {{ MovieContent.langauge }} Language</span
                  >
                </p>
              </div>
              <div class="col-md-12 mb-2">
                <div class="d-flex align-items-center">
                  <div class="input-material-textarea">
                    <textarea
                      v-model="MovieContainer.remarks"
                      type="text"
                      rows="3"
                      name="remarks"
                      id="remarks"
                      placeholder="."
                    ></textarea>
                    <label>{{ $t("Remarks") }}</label>
                  </div>
                  <!-- <Tooltip :title="`Remarks`" /> -->
                </div>
                <p class="error_message"></p>
              </div>
            </div>
            <div class="p-3" v-if="bannerlist.length > 0">
              <span class="font-weight-bold text-blue fs-16">Movie Banner</span>
              <table class="list-view-table border mb-3">
                <thead>
                  <tr>
                    <th>{{ $t("type") }}</th>
                    <th>{{ $t("Banner Name") }}</th>
                    <th>{{ $t("From Date") }}</th>
                    <th>{{ $t("To Date") }}</th>
                    <th>{{ $t("Cinema") }}</th>
                    <th class="text-right">
                      <span class="pr-5">{{ $tc("status", 2) }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(banner, key) in bannerlist" :key="key">
                    <td>{{ $tc("banner", 1) }}</td>
                    <td>{{ banner.banner_name ? banner.banner_name : "-" }}</td>
                    <td>
                      {{ banner.from_date ? parseDate(banner.from_date) : "-" }}
                    </td>
                    <td>
                      {{ banner.to_date ? parseDate(banner.to_date) : "-" }}
                    </td>
                    <td>{{ banner.cine_name ? banner.cine_name : "-" }}</td>
                    <td>
                      <div class="text-center">
                        <StatusDot
                          :status="
                            banner.banner_is_active === 'Y'
                              ? 'active'
                              : banner.banner_is_active === 'N' && 'inactive'
                          "
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-12">
              <div
                class=""
                v-for="(version,
                versionIndex) in MovieContainer.movieLangaugeFormatDistributor"
                :key="versionIndex"
              >
                <div
                  v-if="
                    version &&
                      version.MainRateCardArray &&
                      version.MainRateCardArray.length > 0
                  "
                >
                  <span class="font-weight-bold"
                    ><span class="text-blue fs-16">Movie Rate Cards </span
                    >&nbsp;{{ getMovieVersionText(version) }}</span
                  >
                  <table class="list-view-table mb-0 border">
                    <thead>
                      <tr>
                        <th>{{ "Cinema" }}</th>
                        <th>{{ "Screen" }}</th>
                        <th>{{ "Seat Type" }}</th>
                        <th>{{ "From Date" }}</th>
                        <th>{{ "To Date" }}</th>
                        <th>{{ "Time" }}</th>
                        <th>{{ "Rate Card" }}</th>
                        <th>{{ "Private Rate Card" }}</th>
                      </tr>
                    </thead>
                    <template
                      v-if="
                        version.MainRateCardArray &&
                          version.MainRateCardArray.length > 0
                      "
                    >
                      <tbody>
                        <tr
                          v-for="(mrc, mrcIndex) in version.MainRateCardArray"
                          :key="mrcIndex"
                        >
                          <td>{{ mrc.cine_name }}</td>
                          <td>{{ mrc.screen_name }}</td>
                          <td>{{ mrc.sst_seat_type }}</td>
                          <td>{{ mrc.from_date | dateFormat }}</td>
                          <td>{{ mrc.to_date | dateFormat }}</td>
                          <td>
                            {{
                              mrc.start_date_time + " - " + mrc.end_date_time
                            }}
                          </td>
                          <td>{{ mrc.rc_g_name }}</td>
                          <td>{{ mrc.rc_gp_name }}</td>
                        </tr>
                      </tbody>
                    </template>
                    <tbody v-else>
                      <td colspan="6">
                        <NoRecords />
                      </td>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mb-2">
                <!-- {{bannerlist}} -->
              </div>
            </div>
            <form v-if="custom_fields_list" class="row">
              <div
                v-for="(field, fieldKey) in custom_fields_list"
                :key="fieldKey"
                class="col-lg-6 col-xl-4 mb-4"
              >
                <div v-if="field.custom_field_type == 'text'">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        :minlength="field.min_length"
                        :maxlength="field.max_length"
                        type="text"
                        name="text_input"
                        v-model="input_data[fieldKey]"
                        placeholder="."
                      />
                      <label
                        :class="
                          input_data[fieldKey] !== undefined &&
                          input_data[fieldKey].length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ field.custom_field_name }}</label
                      >
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        (input_data[fieldKey] === undefined ||
                          input_data[fieldKey] == '') &&
                          field.field_is_required == 'Y'
                      "
                      >Please Select {{ field.custom_field_name }}</span
                    >
                  </p>
                </div>
                <div v-if="field.custom_field_type == 'textarea'">
                  <div class="d-flex align-items-center">
                    <div class="input-material-textarea">
                      <textarea
                        :minlength="field.min_length"
                        :maxlength="field.max_length"
                        name="text_area"
                        v-model="input_data[fieldKey]"
                        placeholder="."
                      ></textarea>
                      <label
                        :class="
                          input_data[fieldKey] != undefined &&
                          input_data[fieldKey].length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ field.custom_field_name }}</label
                      >
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        (input_data[fieldKey] === undefined ||
                          input_data[fieldKey] == '') &&
                          field.field_is_required == 'Y'
                      "
                      >Please Select {{ field.custom_field_name }}</span
                    >
                  </p>
                </div>
                <div v-if="field.custom_field_type == 'number'">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <input
                        type="number"
                        :minlength="field.min_length"
                        :maxlength="field.max_length"
                        name="number"
                        :placeholder="field.custom_field_name"
                        v-model="input_data[fieldKey]"
                      />
                      <label
                        :class="
                          input_data[fieldKey] != undefined &&
                          input_data[fieldKey].length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ field.custom_field_name }}</label
                      >
                    </div>
                  </div>
                  <p class="error_message">
                    <span
                      v-if="
                        (input_data[fieldKey] === undefined ||
                          input_data[fieldKey] == '') &&
                          field.field_is_required == 'Y'
                      "
                      >Please Select {{ field.custom_field_name }}</span
                    >
                  </p>
                </div>
                <div
                  v-if="field.custom_field_type == 'checkbox'"
                  class="d-flex align-items-center"
                >
                  <label class="mr-2">{{ field.custom_field_name }}</label>
                  <b-form-checkbox
                    name="check-button"
                    switch
                    v-model="input_data[fieldKey]"
                  ></b-form-checkbox>
                </div>

                <div
                  v-if="field.custom_field_type == 'rating'"
                  class="d-flex align-items-center"
                >
                  <label class="mr-2">{{ field.custom_field_name }}</label>
                  <star-rating v-model="rating"></star-rating>
                </div>

                <!-- <p class="error_message">{{errorMessage}}</p> -->
              </div>

              <!-- <div class="col-md-12 text-center">
              <button @click.prevent.stop="submit" class="btn-blue">{{ $t('submit') }}</button>
                      </div>-->
            </form>

            <!-- <div class="new-border rounded-10 col-12 mt-2 back" >
              <section class="m-2">
                <div class="col-md-12 text-center">
                  <button
                    :disabled="btenable"
                    class="btn-blue"
                    @click.prevent.stop="updateStep1('8')"
                  >
                    {{ 'Update Additional Info' }}
                  </button>
                </div>
              </section>
            </div> -->
          </b-collapse>
        </section>

        <section>
          <div class="col-md-12 text-center">
            <!-- <button @click.prevent.stop="OnFinalSubmit" class="btn-blue">{{ $t('saveaddmore') }}</button> -->
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="OnFinalSubmit"
            >
              {{ $t("update") }}
            </button>
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="onSaveAsDraft"
            >
              {{ $t("update") }} As Draft
            </button>
            <!-- <button class="btn-black">{{ $t('reset') }}</button> -->
            <b-button class="btn-outline-grey" variant="default" to="movies">{{
              $t("cancel")
            }}</b-button>
          </div>
        </section>
      </form>
    </div>

    <!-- MOVIE POSTER IMAGE MODAL -->
    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      :title="tempModalImageName"
      id="selected-image-preview-modal"
    >
      <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
    </b-modal>

    <b-modal title="All Movie Content" hide-footer ref="viewallmodal">
      <div
        v-for="(MovieContent, MovieContentIndex) in MovieContentContainer"
        :key="MovieContentIndex"
        class="mb-3"
      >
        <h4 class="mb-2">{{ MovieContent.langauge }}</h4>

        <div class="d-flex">
          <h6 class="pr-2">{{ $t("title") }}:</h6>
          <p>{{ MovieContent.movieContentTitle }}</p>
        </div>

        <h6>
          {{ $t("short") }} {{ $tc("movie", 1) }} {{ $t("description") }}:
        </h6>
        <p>{{ MovieContent.movieShortDescription }}</p>

        <h6>{{ $t("long") }} {{ $tc("movie", 1) }} {{ $t("description") }}:</h6>
        <p>{{ MovieContent.movieDescription }}</p>
        <hr />
      </div>
    </b-modal>

    <ImageGallery
      v-bind:propImageName="MovieContainer.movieTitle"
      :img_desc="`${MovieContainer.movieTitle} Poster`"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      :showPercentageLoader="true"
      menu="B"
      :category="image_category"
      :language="image_language"
      :resetImgData="false"
      :cropSizeResizable="cropSizeEnable"
    ></ImageGallery>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import _ from "lodash";
  import moment from "moment";
  import VueCropper from "vue-cropperjs";
  import "cropperjs/dist/cropper.css";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";
  import EditablePills from "@/components/Partials/EditablePills.vue";
  import chevron from "@/components/Partials/Chevron.vue";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import ImagePreviewer from "@/components/Partials/ImagePreviewer.vue";
  import xml2js from "xml2js";
  import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
  import CastIcon from "@/components/Partials/CastIcon.vue";

  export default {
    components: {
      VueCropper,
      ImageGallery,
      VueTimepicker,
      EditablePills,
      chevron,
      StatusDot,
      ImagePreviewer,
      CastIcon
    },
    data() {
      return {
        CastMasters: [],
        whatsAppMovieTitleForEpix: {},
        newgroupRegionCinema: [],
        errorHandlerObj: {
          errMsg: ``,
          errorSectionIndex: null,
          errorArrayIndex: null,
        },
        job_status_check_count: 0,
        job_id: null,
        job_checker: null,
        aggregatorUsersList: [],
        artwork_image_height: 3050,
        artwork_image_width: 2160,
        selectedCinemas: [],
        kdmArray: [
          {
            kdm_id: 1,
            kdm_title: "No KDM",
          },
          {
            kdm_id: 2,
            kdm_title: "KDM myCinema",
          },
          {
            kdm_id: 3,
            kdm_title: "KDM Studio",
          },
        ],
        cropSizeEnable: true,
        originalFeatureArray: [],
        versionArray: [],
        featureVersionArray: [],
        Movies: [],
        uuidErrorMessage: "",
        ErrorIndex: [],
        componentKey1: 0,
        translationLoading: [false, false, false, false, false, false],
        translated: [false, false, false, false, false, false],
        movieContentIndex: null,
        showContentListView: false,
        calledby: null,
        set_width: null,
        set_height: null,
        finalIndex: null,
        showModal: false,
        selected_country_rating: null,
        selected_country: null,
        original_distributor: null,
        original_language: null,
        btenable: false,
        posteritem: {},
        movieindex: "",
        width: null,
        height: null,
        file: "",
        imgSrc: "",
        cropImg: "",
        filename: "",
        indexofthubmnail: "",
        messagegenre: "Please Select Genre.",
        messageproduction: "Please Select Production Company.",
        messagecinema: "Please Select Cinema.",
        messageprating: "Please Select Ratings",
        messagedistributor: "Please Select Distributor",
        messagepimage: "Please Upload Thumbnail Image.",
        messagepgenre: "Please Select Genre.",
        messagecountry: "Please Select Country.",
        messagestate: "Please Select State.",
        messagecity: "Please Select City.",
        messagerole: "Please Select Role.",
        messagepcompany: "Please Select Production Company.",
        messageformat: "Please Select Format.",
        messagesoundformat: "Please Select Sound Format.",
        messagelanguage: "Please Select Language.",
        messageoriginallanguage: "Please Select Original Language.",
        messagespokenlanguage: "Please Select Spoken Language.",
        messagecontenttype: "Please Select Content Type",
        messageoriginalDistributor: "Please Select Default Distributor.",
        messagesaleschannel: "Please Select Sales Channel.",
        messagetrailers: "Please Select Trailers.",
        submitted: false,
        showErrorMessages: true,
        productioncompany: "Production Company",
        selectgenre: "Select Genre",
        messageExperience: "Please Select Experience Format.",
        messageAspectRatio: "Please Select Aspect Ratio.",
        messageResolution: "Please Select Movie Resolution.",
        image_category: "",
        image_language: {},
        /**
         * Saif
         */
        activeClass: 0,
        selectedNewDate: "",
        ContentLanguages: [],
        ContentLanguagesMethod: {
          GET: "/admin/",
          tableName: "global_options",
          urlKey: "",
        },
        Countries: [],
        Genres: [],
        Productions: [],
        Languages: [],
        LanguagesCopy: [],
        LanguagesMethod: {
          GET: "/admin/",
          tableName: "ms_language",
          urlKey: "languages",
        },
        Formats: [],
        Ratings: [],
        Crews: [],
        Cities: [],
        States: [],
        Labels: [],
        Distributors: [],
        subdistributor: [],
        Cinemas: [],
        isRoleID: true,
        CinemasGroupedByRegion: [],
        // JAY
        tempModalImageName: null,
        tempModalImagePath: null,
        // JAY

        Experiences: [],
        AspectRatios: [],
        Resolutions: [],
        Regions: [],

        ShowTypeArray: [
          {
            booking_type_id: "4",
            screening_name: "Classic",
            column_name: "is_classic_show",
          },
          {
            booking_type_id: "3",
            screening_name: "Private",
            column_name: "is_private_show",
          },
          {
            booking_type_id: "1",
            screening_name: "Confirmed",
            column_name: "is_confirmed_show",
          },
          {
            booking_type_id: "2",
            screening_name: "Crowd Source",
            column_name: "is_crowd_show",
          },
          {
            booking_type_id: "5",
            screening_name: "Movie Club",
            column_name: "is_movie_club",
          },
        ],

        // Variable
        movie_details_id: null,
        selectedProductionCompany:[],
        inactiveProductionCompany:[],
        MovieContainer: {
          movieTitle: "",

          movieAlternateLangTitle: "",
          movie_isActive: "Y",
          ms_foreign_movie: "Y",
          movie_is_draft: "N",
          is_upcoming: "N",
          imdb_link: "",
          country_name: "Select Country",
          country_id: null,
          productionCompany: [],
          genres: [],
          labels: [],
          movie_unique_identifier: "",
          external_code: "",
          ho_film_code: "",
          original_lang: [
            {
              lang_name: "",
              lang_id: null,
              d_company_name: "",
              d_id: null,
            },
          ],
          original_lang_id: null,
          original_lang_name: "",
          original_distributor_id: null,
          original_distributor_name: "",
          original_artwork: "",
          // original_trailer: "",
          original_trailer: {
            language_id: null,
            language: null,
            trailer_link: "",
            subtitle_lang_id_1: null,
            subtitle_lang_1: null,
            subtitle_lang_id_2: null,
            subtitle_lang_2: null,
          },
          original_release_date: "",
          is_classic_show: false,
          is_confirmed_show: false,
          is_private_show: false,
          is_crowd_show: false,
          is_movie_club: false,
          is_event: false,
          selected_version: [],
          selected_parent_movie: null,
          parent_movie_id: null,
          parent_md_id: null,
          movieLangaugeFormatDistributor: [],
          movieRatings: [
            {
              id: "",
              country_name: "",
              country_id: null,
              rating: "",
              rating_id: null,
              releaseDate: null,
              runTime: "",
              temp_rating_name: "",
              temp_rating_id: null,
              region_id: null,
              region_obj: null,
              region_name: "",
            },
          ],
        },
        MovieContentContainer: [],

        //
        MovieDetailsCityAndStatesHandler: [
          [
            {
              country_id: null,
              stateList: [],
              cityList: [],
            },
          ],
        ],
        custom_fields_list: [],
        input_data: [],
        soundFormatList: [],
        removedMovies: [],
        movie_id: null,
        sectionCollapse: {
          basicInfo: true,
          filmInfo: false,
          detailsAndDistributors: false,
          censorRatings: false,
          movieContent: false,
          images: false,
          signage: false,
          scenes: false,
          customFields: false,
          trailers: false,
          images_sub_section: false,
          trailers_sub_section: false,
          other_cast_crew: false,
        },
        selectedCinema: [],
        // movieScenes: [
        //   {
        //     image_path: "",
        //   },
        // ],
        movieScenes: [],
        signageContainer: [],
        movie_trailers: [],
        defaultCountry: {},
        movieDistributors: [
          {
            id: "",
            distributor_name: "",
            distributor_id: null,
            sub_distributor_name: "",
            sub_distributor_id: null,
            city_name: "",
            city_id: null,
            state_name: "",
            state_id: null,
            country_name: "",
            country_id: null,
            fromdate: new Date(),
            todate: new Date(),
            // NEW
            selected_distributor: "",
            selected_cinema: [],
            removed_cinema: [],
            // cinema_id: null,
            // cinema_name: ""
          },
        ],
        cast_and_crew: [],
        bannerlist: [],
        dummy: 5,
        fpsOptions: [24, 25],
        removedLabels: [],
        // messageoriginallanguage: "Please Select Original Language.",
        // messageoriginalDistributor: "Please Select Default Distributor."
        leadTimes: [
          {
            leadTimeHH: "00",
            leadTimeMM: "00",
          },
        ],
        fv_errorMessage: "",
        fv_errorMessage_index: null,
        /**
         * END
         */
      };
    },
    created() {},
    beforeMount() {
      const { movie_id } = this.$route.query;
      if (movie_id) {
        // this.movie_details_id = movie_details_id;
        this.getPosAggregatorUsers();
        this.getMoviesDetails(movie_id);
        this.getCustomFields(movie_id);
      } else {
        this.$router.go(-1);
      }

      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.getCinemasList(obj);
      // this.getCinemasList();
      this.getFormatsList();
      this.getCountriesList();
      this.getProductionList();
      this.getGenreList();
      this.getLanguagesList();
      this.getDistributorsList();
      this.getRatingsList();
      this.getCrewsList();
      this.getCastMasters();
      this.getSoundFormats();
      this.getResolutionsList();
      this.getAspectRatiosList();
      this.getMovieExperiencesList();
      this.getRegions();
      this.getBannerList(movie_id);
      this.getLabelList();
    },
    mounted() {},
    watch: {
      finalImagePath(newval) {
        if (newval) {
          if (this.calledby == 1) {
            this.MovieContainer.movieLangaugeFormatDistributor[
              this.finalIndex
            ].md_thumbnail_url = newval;
            this.MovieContainer.movieLangaugeFormatDistributor[
              this.finalIndex
            ].is_compressed = "N";
            this.MovieContainer.movieLangaugeFormatDistributor[
              this.finalIndex
            ].original_md_thumbnail_url = null;
          } else if (this.calledby == 2) {
            console.log("this.movieContentIndex :>> ", this.movieContentIndex);
            console.log("this.finalIndex :>> ", this.finalIndex);
            this.MovieContentContainer[this.movieContentIndex].moviePosters[
              this.finalIndex
            ].image_setting_path = newval;
            this.MovieContentContainer[this.movieContentIndex].moviePosters[
              this.finalIndex
            ].is_compressed = "N";
            this.MovieContentContainer[this.movieContentIndex].moviePosters[
              this.finalIndex
            ].original_mp_poster_url = null;
            //     this.MovieContentContainer[MovieContentIndex].moviePosters[
            //   PosterIndex
            // ];
          } else if (this.calledby == 3) {
            this.movieScenes[this.finalIndex].image_path = newval;
            console.log(
              "this.imagepath :>> ",
              this.movieScenes[this.finalIndex].image_path
            );
            console.log("newval", newval);
          } else if (this.calledby == 4) {
            this.MovieContainer.original_artwork = newval;
          } else if (this.calledby == 5) {
            this.MovieContentContainer[this.movieContentIndex].artwork = newval;
            this.MovieContentContainer[this.movieContentIndex].is_compressed =
              "N";
            this.MovieContentContainer[
              this.movieContentIndex
            ].original_artwork = null;
          } else if (this.calledby == 6) {
            this.signageContainer[this.finalIndex].imageUrl = newval;
          } else if (this.calledby == 7) {
            this.movieScenes.push({
              image_path: newval,
            });
          }
        }
        this.$forceUpdate();
      },
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
      englishContentIndex() {
        let index = 0;
        index = this.MovieContentContainer.findIndex((i) => (i.langaugeId == 1))
        console.log('index', index);

        return index < 0 ? 0 : index
      },
      QFX_CLIENT() {
        return CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME;
      },
      EPIX_CLIENT() {
        return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME;
      },
      showForeignMovieSection() {
        return CLIENT_NAMES_OBJ.has_foreign_movie_options.includes(
          String(this.CLIENT_SETUP_NAME)
        );
      },
      checkAddMoreRatings() {
        let count = 0;
        this.MovieContainer.movieRatings.forEach((x) => {
          if (x.region_id == 0) {
            count++;
          }
        });
        if (count > 0) {
          return false;
        } else {
          return true;
        }
      },
      ShowTypeArrayNew() {
        let tempArray = [];
        if (this.getMyCinemaStatusNew() == "N") {
          tempArray = this.ShowTypeArray.filter((x) => x.booking_type_id == 4);
        } else {
          tempArray = this.ShowTypeArray;
        }

        return tempArray;
      },
      disableFeatureVersion() {
        if (this.MovieContainer.is_event) {
          return true;
        } else {
          return false;
        }
      },
      basicinfotext: function() {
        let textarr = [];
        if (this.MovieContainer.movie_unique_identifier) {
          textarr.push(this.MovieContainer.movie_unique_identifier);
        }
        if (this.MovieContainer.movieTitle) {
          let title = this.MovieContainer.movieTitle;

          if (
            this.MovieContainer.movieRatings &&
            this.MovieContainer.movieRatings[0] &&
            this.MovieContainer.movieRatings[0].releaseDate
          ) {
            let year = this.MovieContainer.movieRatings[0].releaseDate.substr(
              0,
              4
            );

            title += ` (${year})`;
          }
          textarr.push(title);
        }
        if (this.MovieContainer.is_classic_show) {
          textarr.push("CLAS");
        }
        if (this.MovieContainer.is_private_show) {
          textarr.push("PRIV");
        }
        if (this.MovieContainer.is_confirmed_show) {
          textarr.push("CONF");
        }
        if (this.MovieContainer.is_crowd_show) {
          textarr.push("CROWD,");
        }

        if (textarr.length > 0) {
          return ` - ${textarr.join(", ")}`;
        }

        return "";
      },
      moviecontentexists: function() {
        if (
          this.MovieContentContainer &&
          this.MovieContentContainer.length > 0
        ) {
          return this.MovieContentContainer.some((x) => {
            return x.movieShortDescription || x.movieDescription;
          });
        } else {
          return false;
        }
      },
      additionalContentExists: function() {
        if (this.MovieContainer.remarks) {
          return true;
        } else if (
          this.custom_fields_list &&
          this.custom_fields_list.some((x, i) => this.input_data[i])
        ) {
          return true;
        } else {
          return false;
        }
      },
      featureVersionsText: function() {
        let dummy = this.dummy;
        if (this.MovieContainer.movieLangaugeFormatDistributor.length > 0) {
          let main_text_arr = [];
          for (let x of this.MovieContainer.movieLangaugeFormatDistributor) {
            let temp_arr = [];
            if (x.searchable_language && x.searchable_language.iso_3)
              temp_arr.push(x.searchable_language.iso_3);
            if (x.subtitle_language_name_1 && x.subtitle_language_name_1.iso_3)
              temp_arr.push(x.subtitle_language_name_1.iso_3);
            if (x.subtitle_language_name_2 && x.subtitle_language_name_2.iso_3)
              temp_arr.push(x.subtitle_language_name_2.iso_3);
            if (x.searchable_format && x.searchable_format.mf_name)
              temp_arr.push(x.searchable_format.mf_name);

            if (temp_arr.length > 0) {
              main_text_arr.push(temp_arr.join("-"));
            }
          }

          if (main_text_arr.length > 0) {
            return ` - (${
              this.MovieContainer.movieLangaugeFormatDistributor.length
            }) (${main_text_arr.join(", ")})`;
          } else {
            return ` - (${this.MovieContainer.movieLangaugeFormatDistributor.length})`;
          }
        } else {
          return "";
        }
      },
    },
    methods: {
      onChangeMovieTitle(event) {
        let movieTitle = this.MovieContainer.movieTitle || "";
        let englishIndex = this.MovieContentContainer.findIndex(
          (MovieContent) => MovieContent.langauge.toLowerCase() === "english"
        );
        if (englishIndex > -1) {
          this.MovieContentContainer[englishIndex][
            "movieContentTitle"
          ] = movieTitle;
        }
      },
      openTrailerPopup(url) {
        const width = 800; // Set the desired width of the popup window
        const height = 600; // Set the desired height of the popup window
        const left = screen.width / 2 - width / 2; // Center the popup horizontally
        const top = screen.height / 2 - height / 2; // Center the popup vertically
        window.open(
          url,
          "_blank",
          `width=${width},height=${height},top=${top},left=${left},resizable=yes`
        );
      },
      deleteImageSignage(index) {
        this.signageContainer[index].imageUrl = "";
      },
      getPosAggregatorUsers: function() {
        MasterService.GetPosAggregatorUsers()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.aggregatorUsersList = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      onSelectKDM(kdm, fvIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[fvIndex].kdm =
          kdm.kdm_title;
        this.MovieContainer.movieLangaugeFormatDistributor[fvIndex].kdm_id =
          kdm.kdm_id;
        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[fvIndex]
        );
      },
      uploadXmlfile(event, fvIndex) {
        let file = event.target.files[0];
        let ContentKeysNotValidAfter = "";
        let ContentKeysNotValidBefore = "";
        if (file.type.indexOf("text/xml") === -1) {
          this.$toasted.show("Please select an XML file");
          return;
        } else {
          let self = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            let parser = new xml2js.Parser({
              trim: true,
              explicitArray: true,
            });

            parser.parseString(event.target.result, function(err, result) {
              if (result && result.hasOwnProperty("DCinemaSecurityMessage")) {
                if (
                  result.DCinemaSecurityMessage &&
                  result.DCinemaSecurityMessage.hasOwnProperty(
                    "AuthenticatedPublic"
                  ) &&
                  result.DCinemaSecurityMessage.AuthenticatedPublic.length > 0
                ) {
                  let AuthenticatedPublic =
                    result.DCinemaSecurityMessage.AuthenticatedPublic[0];
                  if (
                    AuthenticatedPublic.hasOwnProperty("RequiredExtensions") &&
                    AuthenticatedPublic.RequiredExtensions.length > 0
                  ) {
                    let RequiredExtensions =
                      AuthenticatedPublic.RequiredExtensions[0];
                    if (
                      RequiredExtensions.hasOwnProperty(
                        "KDMRequiredExtensions"
                      ) &&
                      RequiredExtensions.KDMRequiredExtensions.length > 0
                    ) {
                      let KDMRequiredExtensions =
                        RequiredExtensions.KDMRequiredExtensions[0];
                      if (
                        KDMRequiredExtensions &&
                        KDMRequiredExtensions.hasOwnProperty(
                          "ContentKeysNotValidAfter"
                        ) &&
                        KDMRequiredExtensions.ContentKeysNotValidAfter.length >
                          0
                      ) {
                        ContentKeysNotValidAfter =
                          KDMRequiredExtensions.ContentKeysNotValidAfter[0];
                      }

                      if (
                        KDMRequiredExtensions &&
                        KDMRequiredExtensions.hasOwnProperty(
                          "ContentKeysNotValidBefore"
                        ) &&
                        KDMRequiredExtensions.ContentKeysNotValidBefore.length >
                          0
                      ) {
                        ContentKeysNotValidBefore =
                          KDMRequiredExtensions.ContentKeysNotValidBefore[0];
                      }
                    } else {
                      self.$toasted.show("KDM keys info not available!");
                    }
                  } else {
                    self.$toasted.show("KDM keys info not available!");
                  }
                } else {
                  self.$toasted.show("KDM keys info not available!");
                }
              } else {
                self.$toasted.show("KDM keys info not available!");
              }

              if (!ContentKeysNotValidAfter && !ContentKeysNotValidBefore) {
                self.$toasted.show("KDM keys info not available!");
              }
              console.log("ContentKeysNotValidAfter", ContentKeysNotValidAfter);
              console.log(
                "ContentKeysNotValidBefore",
                ContentKeysNotValidBefore
              );

              self.MovieContainer.movieLangaugeFormatDistributor[
                fvIndex
              ].key_valid_from = ContentKeysNotValidAfter;
              self.MovieContainer.movieLangaugeFormatDistributor[
                fvIndex
              ].key_valid_to = ContentKeysNotValidBefore;
            });
          };
          reader.readAsText(file);
        }
      },
      getMovieVersionText(x) {
        let temp_arr = [];
        if (x.searchable_language && x.searchable_language.iso_3)
          temp_arr.push(x.searchable_language.iso_3);
        if (x.subtitle_language_name_1 && x.subtitle_language_name_1.iso_3)
          temp_arr.push(x.subtitle_language_name_1.iso_3);
        if (x.subtitle_language_name_2 && x.subtitle_language_name_2.iso_3)
          temp_arr.push(x.subtitle_language_name_2.iso_3);
        if (x.searchable_format && x.searchable_format.mf_name)
          temp_arr.push(x.searchable_format.mf_name);

        if (temp_arr.length > 0) {
          return temp_arr.join("-").toUpperCase();
        } else {
          return "";
        }
      },
      downloadImage(obj, index, type) {
        console.log(obj, type, this.MovieContainer);
        let imgPath = "";
        let fileName = "";
        let type_name;
        let langName = this.Languages.filter((x) => {
          return x.lang_id == this.MovieContainer.original_lang_id;
        })[0]["iso_3"];
        if (type == 1) {
          langName = this.Languages.filter((x) => {
            return x.lang_id == obj.content_lang_id;
          })[0]["iso_3"];

          //movie_artwork
          //window.location.href=BASEURL + obj
          imgPath = obj.artwork.includes("contentMinified")
            ? obj.original_artwork
            : obj.artwork;
          type_name = "artwork";
        } else if (type == 3) {
          //movie_scenes
          type_name = "scene";
          imgPath = obj.image_path;
          langName = index;
        }
        let extension_array = imgPath.split(".");
        let actual_extension = extension_array[extension_array.length - 1];
        fileName = `${this.MovieContainer.movie_unique_identifier.replaceAll(
          ".",
          ""
        )}_${type_name}_${langName}.${actual_extension}`;
        console.log(fileName, langName);

        this._downloadImagePath(imgPath, fileName);
      },

      downloadImageSignage(obj, index) {
        let imgPath = obj.imageUrl;
        let fileName = ``;
        let extension_array = imgPath.split(".");
        let actual_extension = extension_array[extension_array.length - 1];
        fileName = `Movie_Signage_${obj.width}x${obj.height}.${actual_extension}`;
        this._downloadImagePath(imgPath, fileName);
      },
      copyPreviousFeatureData(obj) {
        if (this.MovieContainer.movieLangaugeFormatDistributor.length > 0) {
          let LastIndex =
            this.MovieContainer.movieLangaugeFormatDistributor.length - 1;
          // obj = Object.assign(
          //   {},
          //   this.MovieContainer.movieLangaugeFormatDistributor[LastIndex]
          // );
          obj = _.cloneDeep(
            this.MovieContainer.movieLangaugeFormatDistributor[LastIndex]
          );
          obj.tms_id = "";
          obj.uuid = "";
          obj.is_schedule_available = "N";
          obj["showMore"] = false;
          delete obj.movieDistributors[0].mdistributor_id;
          delete obj.md_id;
        }
        return obj;
      },
      checkScheduleExistsAlertForModification(obj) {
        if (this.checkDisableFeatureVersion(obj)) {
          return this.$toasted.show(
            "Warning! You Are Changing Details of Scheduled Show",
            { duration: 6000 }
          );
        } else {
          return true;
        }
      },
      checkSchedule(obj) {
        if (this.checkDisableFeatureVersion(obj)) {
          return this.$toasted.show(
            "Schedule Exists for this feature version, Edit Not Allowed!"
          );
        } else {
          return true;
        }
      },
      checkDisableFeatureVersion(fv) {
        if (
          fv &&
          fv.hasOwnProperty("is_schedule_available") &&
          fv.is_schedule_available == "Y"
        ) {
          return true;
        } else {
          return false;
        }
      },
      onChangeEvent(index) {
        if (index == this.fv_errorMessage_index) {
          this.fv_errorMessage = "";
          this.fv_errorMessage_index = null;
        }
      },
      checkFeatureVersionValidation() {
        this.fv_errorMessage = "";
        this.fv_errorMessage_index = null;
        let count = 0;
        if (
          this.MovieContainer.movieLangaugeFormatDistributor &&
          this.MovieContainer.movieLangaugeFormatDistributor.length > 0
        ) {
          this.MovieContainer.movieLangaugeFormatDistributor.forEach(
            (x, index) => {
              if (x.selected_cinema && x.selected_cinema.length == 0) {
                this.fv_errorMessage = "Please Select Atleast One Cinema";
                this.fv_errorMessage_index = index;
                count++;
                return false;
              } else if (x.licence_start_date && !x.licence_end_date) {
                this.fv_errorMessage = "Please Select End Date";
                this.fv_errorMessage_index = index;
                count++;
              } else if (!x.licence_start_date && x.licence_end_date) {
                this.fv_errorMessage = "Please Select Start Date";
                this.fv_errorMessage_index = index;
                count++;
              } else if (
                !x.is_classic_show &&
                !x.is_confirmed_show &&
                !x.is_private_show &&
                !x.is_crowd_show &&
                !x.is_movie_club
              ) {
                this.fv_errorMessage =
                  "Please Select Atleast One Screening Type";
                this.fv_errorMessage_index = index;
                count++;
              }
            }
          );

          if (count > 0) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      onRemoveSoundFormat(event, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].sound_format_name = "";
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].sound_format_id = null;

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },
      onRemoveExperienceHandler(event, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_experience_format_name = "";
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_experience_format_id = null;
      },
      onRemoveContentType(event, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].format_name = "";
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].format_id = null;
      },
      onRemoveResolution(event, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_resolution_name = "";
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_resolution_id = null;

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },
      onRemoveAspectRatio(event, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_aspect_ratio_name = "";
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_aspect_ratio_id = null;

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },
      removeLabels(label) {
        if (label.ml_id) {
          this.removedLabels.push(label);
        }
      },
      getBannerList(movie_id) {
        MasterService.GetAllBanners({
          movie_id: movie_id,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.bannerlist = data.Records;
              console.log(data.Records);
              // this.rows = data.totalRows;
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      removeCastLanguage(event, index) {
        this.cast_and_crew.splice(index, 1);
      },
      addCastLang() {
        this.cast_and_crew.push({
          language_id: null,
          langauge: "",
          selectedLanguage: {
            lang_id: null,
            lang_name: "",
          },
          movieCastAndCrewList: [
            {
              id: "",
              crew_title: "",
              selected_cast: "",
              crew_id: null,
              members: [],
            },
          ],
        });
      },
      parseDate(date) {
        return moment(date).format("DD-MM-YYYY");
      },
      saveShowType(item, movieItem, index) {
        let findIndeNew = movieItem["selectShowType"].findIndex((x) => {
          return x.booking_type_id == item.booking_type_id;
        });
        if (findIndeNew >= 0) {
          movieItem["selectShowType"].splice(findIndeNew, 1);
        } else {
          movieItem["selectShowType"].push(item);
        }
        this.onChangeEvent(index);
        this.checkScheduleExistsAlertForModification(movieItem);
        console.log(movieItem["selectShowType"], "fdfsdfsd");
      },
      setModalData(
        index,
        height,
        width,
        calledby,
        index2,
        category = "",
        langauge = {}
      ) {
        this.finalIndex = index;
        this.set_height = height;
        this.set_width = width;
        this.showModal = !this.showModal;
        this.calledby = calledby;
        this.movieContentIndex = index2;
        this.image_category = category;
        this.image_language = langauge;
        console.log("this.finalIndex :>> ", this.finalIndex);
        console.log("this.movieContentIndex :>> ", this.movieContentIndex);
        console.log(
          "this.movieContentIndexset_widthset_widthset_width :>> ",
          this.set_height,
          this.set_width
        );
        if (category == "Signage Scene") {
          this.cropSizeEnable = false;
        } else {
          this.cropSizeEnable = true;
        }
      },
      setSignageModalData(index, width, height, imageUrl) {},
      getSoundFormats: function() {
        let payload = {
          tableName: "ms_sound_formats",
          sound_format_is_active: "Y",
          orderBy: "asc",
          columnName: "sf_order",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.soundFormatList = data.Records;
              console.log(" this.soundFormatList :>> ", this.soundFormatList);
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getResolutionsList: function() {
        this.Genre = [];
        let payload = {
          tableName: "ms_movie_resolutions",
          resolution_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Resolutions = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getAspectRatiosList: function() {
        this.Genre = [];
        let payload = {
          tableName: "ms_aspect_ratios",
          aspect_ratio_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.AspectRatios = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getMovieExperiencesList: function() {
        this.Genre = [];
        let payload = {
          tableName: "ms_movie_experiences",
          movie_experience_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Experiences = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getRegions: function() {
        let payload = {
          tableName: "ms_regions",
          region_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Regions = data.Records;
              let tempobj = {
                region_name: "All",
                region_id: 0,
              };
              this.Regions.unshift(tempobj);
              console.log(" this.Regions :>> ", this.Regions);
            } else {
              // Show Errors
              // console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getCustomFields: async function(movie_id) {
        let payload2 = {
          table_name: "ms_movies",
        };
        MasterService.getCustomFields(payload2)
          .then(async (response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.custom_fields_list = _.sortBy(data.Records, ["order_id"]);

              let payload = {
                table_name: "ms_movies",
                table_item_id: parseInt(movie_id),
              };
              MasterService.getCustomFieldValue(payload)
                .then((response) => {
                  const { data } = response;
                  if (data.status && data.Records.length > 0) {
                    console.log("data.Records :>> ", data.Records);
                    data.Records = _.sortBy(data.Records, ["order_id"]);
                    data.Records.map((x) => {
                      this.input_data.push(
                        x.custom_field_data == "Yes"
                          ? true
                          : x.custom_field_data == "No"
                          ? false
                          : x.custom_field_data
                      );
                    });
                    console.log(
                      "this.custom_fields_list :>> ",
                      this.custom_fields_list
                    );
                    console.log("this.input_data :>> ", this.input_data);
                  } else {
                  }
                })
                .catch((error) => {
                  // Show Catch Error
                  console.log("show error :", error);
                });
            } else {
              // Show Errors
              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      selectCountry(Country) {
        console.log("Country :", Country);
        this.MovieContainer.country_name = Country.country_name;
        this.MovieContainer.country_id = Country.country_id;

        console.log("this.MovieContainer :", this.MovieContainer);
      },
      removeCountry() {
        this.MovieContainer.country_name = "";
        this.MovieContainer.country_id = null;
        console.log("this.MovieContainer :", this.MovieContainer);
      },
      selectCountryRating(Country) {
        this.MovieContainer.movieRatings[0].country_name = Country.country_name;
        this.MovieContainer.movieRatings[0].country_id = Country.country_id;
        console.log(
          "this.MovieContainer.movieRatings[0] :",
          this.MovieContainer.movieRatings[0]
        );
      },
      removeCountryRating() {
        this.MovieContainer.movieRatings[0].country_name = "";
        this.MovieContainer.movieRatings[0].country_id = null;
        console.log(
          "this.MovieContainer.movieRatings[0] :",
          this.MovieContainer.movieRatings[0]
        );
      },
      openImageModal: function(image_name, image_path) {
        this.tempModalImagePath = image_path;
        this.tempModalImageName = image_name;
        this.$refs["preview-modal"].show();
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
      getMovieVersionText(movie) {
        let temp_arr = [];
        if (movie.mf_name) temp_arr.push(movie.mf_name.mf_name);
        if (movie.iso_2) temp_arr.push(movie.iso_2);
        if (movie.sound_format_name) temp_arr.push(movie.sound_format_name);
        if (movie.resolution_short_code)
          temp_arr.push(movie.resolution_short_code);
        if (movie.aspect_ratio_name) temp_arr.push(movie.aspect_ratio_name);
        if (movie.movie_experience) temp_arr.push(movie.movie_experience);
        if (movie.sub_lang_1_iso_2) temp_arr.push(movie.sub_lang_1_iso_2);
        if (movie.sub_lang_2_iso_2) temp_arr.push(movie.sub_lang_2_iso_2);

        if (temp_arr.length > 0) {
          return temp_arr.join("-").toUpperCase();
        } else {
          return "";
        }
      },
      onRemoveParentVersion(parentVersion) {
        let tempArray = [];
        tempArray = this.featureVersionArray.filter((el) => {
          return this.MovieContainer.selected_version.some((v) => {
            return v.md_id == el.parent_version_id;
          });
        });
        this.leadTimes = [];
        tempArray.map((x, i) => {
          if (x.lead_time_in_hours) {
            let split = x.lead_time_in_hours.split(":");
            console.log({ i, split, x });
            this.leadTimes[i] = {};
            if (split.length) {
              this.leadTimes[i].leadTimeHH = split[0];
              this.leadTimes[i].leadTimeMM = split[1];
            }
          } else {
            this.leadTimes[i].leadTimeHH = "";
            this.leadTimes[i].leadTimeMM = "";
          }
        });
        this.MovieContainer.movieLangaugeFormatDistributor = tempArray;
      },
      onSelectParentVersion(parentVersion) {
        let tempArray = [];
        tempArray = this.featureVersionArray.filter((el) => {
          return this.MovieContainer.selected_version.some((v) => {
            return v.md_id == el.parent_version_id;
          });
        });
        this.leadTimes = [];

        this.originalFeatureArray.forEach((element) => {
          const itemIndex = tempArray.findIndex(
            (o) => o.parent_version_id == element.parent_version_id
          );
          if (itemIndex > -1) {
            tempArray[itemIndex] = element;
          }
        });

        tempArray.map((x, i) => {
          if (x.lead_time_in_hours) {
            let split = x.lead_time_in_hours.split(":");
            console.log({ i, split, x });
            this.leadTimes[i] = {};
            if (split.length) {
              this.leadTimes[i].leadTimeHH = split[0];
              this.leadTimes[i].leadTimeMM = split[1];
            }
          } else {
            this.leadTimes[i].leadTimeHH = "";
            this.leadTimes[i].leadTimeMM = "";
          }
        });

        this.MovieContainer.movieLangaugeFormatDistributor = tempArray;
      },
      getEventVersions(movie_id) {
        let payload = {
          movie_id,
        };
        MovieService.GetEditMoviesDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (
                data.MovieContainer.movieLangaugeFormatDistributor.length > 0
              ) {
                this.featureVersionArray =
                  data.MovieContainer.movieLangaugeFormatDistributor;
                this.featureVersionArray.forEach((x) => {
                  x["mf_name"] = x.searchable_format;
                  x["parent_movie_id"] = movie_id;
                  x["parent_version_id"] = x.md_id;
                  delete x.md_id;

                  let obj = {
                    md_id: x.parent_version_id,
                    version_id: x.parent_version_id,
                    version_name: this.getMovieVersionText(x),
                  };
                  this.versionArray.push(obj);

                  if (x.sound_format_id && x.sound_format_name) {
                    x["selected_sound_format"] = {
                      sound_format_id: x.sound_format_id,
                      sound_format_name: x.sound_format_name,
                    };
                  } else {
                    x["selected_sound_format"] = null;
                  }

                  if (!x.subtitle_language_id_1) {
                    x.subtitle_language_name_1 = "";
                  }
                  if (!x.subtitle_language_id_2) {
                    x.subtitle_language_name_2 = "";
                  }
                  if (x.movieDistributors.length == 0) {
                    x.movieDistributors = _.cloneDeep(this.movieDistributors);
                  } else {
                    x.movieDistributors.map((y) => {
                      console.log("Y", y);
                      y.selected_distributor = {
                        d_id: y.distributor_id,
                        d_company_name: y.distributor_name,
                      };
                    });
                  }

                  x["selectShowType"] = [];

                  let findIndex = -1;

                  if (x.is_classic_show) {
                    findIndex = x["selectShowType"].findIndex((y) => {
                      return y.column_name == "is_classic_show";
                    });

                    if (findIndex < 0) {
                      x["selectShowType"].push(this.ShowTypeArray[0]);
                    }
                  }
                  if (x.is_confirmed_show) {
                    findIndex = x["selectShowType"].findIndex((y) => {
                      return y.column_name == "is_confirmed_show";
                    });

                    if (findIndex < 0) {
                      x["selectShowType"].push(this.ShowTypeArray[2]);
                    }
                  }
                  if (x.is_private_show) {
                    findIndex = x["selectShowType"].findIndex((y) => {
                      return y.column_name == "is_private_show";
                    });

                    if (findIndex < 0) {
                      x["selectShowType"].push(this.ShowTypeArray[1]);
                    }
                  }
                  if (x.is_crowd_show) {
                    findIndex = x["selectShowType"].findIndex((y) => {
                      return y.column_name == "is_crowd_show";
                    });

                    if (findIndex < 0) {
                      x["selectShowType"].push(this.ShowTypeArray[3]);
                    }
                  }
                  if (x.is_movie_club) {
                    findIndex = x["selectShowType"].findIndex((y) => {
                      return y.column_name == "is_movie_club";
                    });

                    if (findIndex < 0) {
                      x["selectShowType"].push(this.ShowTypeArray[4]);
                    }
                  }
                });

                this.featureVersionArray = this.featureVersionArray.map((x) => {
                  const {
                    is_classic_show,
                    is_confirmed_show,
                    is_private_show,
                    is_crowd_show,
                    is_movie_club,
                  } = x;

                  return {
                    ...x,
                    is_classic_show: is_classic_show === "Y" ? true : false,
                    is_confirmed_show: is_confirmed_show === "Y" ? true : false,
                    is_private_show: is_private_show === "Y" ? true : false,
                    is_crowd_show: is_crowd_show === "Y" ? true : false,
                    is_movie_club: is_movie_club === "Y" ? true : false,
                  };
                });

                this.MovieContainer.selected_version = this.versionArray.filter(
                  (el) => {
                    return this.MovieContainer.movieLangaugeFormatDistributor.some(
                      (v) => {
                        console.log("v.parent_version_id", v.parent_version_id);
                        console.log("el.md_id", el.md_id);
                        return v.parent_version_id == el.md_id;
                      }
                    );
                  }
                );
              }
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      getAllActiveMovies: function(parent_movie_id) {
        let payload = {
          movie_is_active: "Y",
        };
        MovieService.GetActiveMasterMovies(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.Movies = data.Records;
              if (parent_movie_id) {
                this.MovieContainer.selected_parent_movie = this.Movies.find(
                  (x) => x.movie_id == parent_movie_id
                );
              }
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error on getAllActiveMovies :", error);
          });
      },
      // Get Selected Movie Details
      getMoviesDetails(movie_id) {
        let loader = this.$loading.show();
        let payload = {
          movie_id,
        };
        MovieService.GetEditMoviesDetails(payload)
          .then((response) => {
            const { data } = response;
            console.log("data :", data);
            if (data && data.status) {
              this.MovieDetailsCityAndStatesHandler = [];
              this.movie_trailers = data.movieTrailers;
              this.signageContainer = data.SignageContainer;
              this.MovieContentContainer = data.MovieContentContainer;
              this.whatsAppMovieTitleForEpix = this.MovieContentContainer[0];
              if (data.movieScenes && data.movieScenes.length > 0) {
                this.movieScenes = data.movieScenes;
              }

              let TempArray = [];

              // this.MovieContentContainer.map((x, i) => {
              //   if (x.langauge.toLowerCase() == "english") {
              //     let obj = {
              //       language_id: x.langaugeId,
              //       langauge: x.langauge,
              //       selectedLanguage: {
              //         lang_id: x.langaugeId,
              //         lang_name: x.langauge,
              //       },
              //       movieCastAndCrewList: [
              //         {
              //           id: "",
              //           crew_title: "select crew",
              //           crew_id: null,
              //           selected_cast: "",
              //           members: [],
              //         },
              //       ],
              //     };
              //     TempArray.push(obj);
              //   } else {
              //     let obj = {
              //       language_id: x.langaugeId,
              //       langauge: x.langauge,
              //       selectedLanguage: {
              //         lang_id: x.langaugeId,
              //         lang_name: x.langauge,
              //       },
              //       movieCastAndCrewList: [
              //         {
              //           id: "",
              //           crew_title: "select crew",
              //           crew_id: null,
              //           selected_cast: "",
              //           members: [],
              //         },
              //       ],
              //     };
              //     TempArray.push(obj);
              //   }
              // });

              this.cast_and_crew = [];
              // if (data.CastAndCrew && data.CastAndCrew.length > 0) {
              //   this.cast_and_crew = data.CastAndCrew;
              // } else {
              //   this.cast_and_crew = TempArray;
              // }
              this.MovieContentContainer.map((x, i) => {
                if (data.CastAndCrew && data.CastAndCrew.length > 0) {
                  let tempCastCrew = data.CastAndCrew.filter(
                    (_cas) => _cas["language_id"] == x.langaugeId
                  );
                  if (tempCastCrew && tempCastCrew.length) {
                    this.cast_and_crew.push(tempCastCrew[0]);
                  } else {
                    let obj = {
                      language_id: x.langaugeId,
                      langauge: x.langauge,
                      selectedLanguage: {
                        lang_id: x.langaugeId,
                        lang_name: x.langauge,
                      },
                      movieCastAndCrewList: [
                        {
                          id: "",
                          crew_title: "select crew",
                          crew_id: null,
                          selected_cast: "",
                          members: [],
                        },
                      ],
                    };
                    this.cast_and_crew.push(obj);
                  }
                } else {
                   let obj = {
                      language_id: x.langaugeId,
                      langauge: x.langauge,
                      selectedLanguage: {
                        lang_id: x.langaugeId,
                        lang_name: x.langauge,
                      },
                      movieCastAndCrewList: [
                        {
                          id: "",
                          crew_title: "select crew",
                          crew_id: null,
                          selected_cast: "",
                          members: [],
                        },
                      ],
                    };
                    this.cast_and_crew.push(obj);
                }
                if (x.movieCastAndCrewList.length === 0) {
                  x.movieCastAndCrewList.push({
                    id: "",
                    crew_title: "Select Crew",
                    crew_id: null,
                    selected_cast: "",
                    members: [],
                  });
                }
                if (x.movieScenes.length == 0) {
                  x.movieScenes.push({
                    image_path: "",
                  });
                }
                if (
                  x.langauge.toLowerCase() !== "english" &&
                  x.movieContentTitle
                ) {
                  this.translated[i] = true;
                }

                if (x.moviePosters && x.moviePosters.length > 0) {
                  let imageSettings = _.cloneDeep(x.moviePosters);
                  console.log("imageSettings", imageSettings);
                  let artworkSettings = imageSettings.filter(
                    (x) =>
                      x.image_setting_name.toLowerCase().trim() ==
                      "movie artwork"
                  );
                  if (artworkSettings && artworkSettings.length > 0) {
                    this.artwork_image_height =
                      artworkSettings[0].image_setting_height || 3050;
                    this.artwork_image_width =
                      artworkSettings[0].image_setting_width || 2160;
                  }
                  x.moviePosters = x.moviePosters.filter((x) => {
                    if (
                      (x.image_setting_name &&
                        x.image_setting_name.toLowerCase().trim() ===
                          "web banner") ||
                      (x.image_setting_desciption &&
                        x.image_setting_desciption.toLowerCase().trim() ===
                          "web banner") ||
                      (x.image_setting_desciption &&
                        x.image_setting_desciption.toLowerCase().trim() ==
                          "movie artwork") ||
                      (x.image_setting_name &&
                        x.image_setting_name.toLowerCase().trim() ==
                          "movie artwork")
                    ) {
                      return false;
                    }
                    return true;
                  });
                }
              });
            } else {
              // Show Message Here
              console.log("data.message :", data.message);
            }
            return data;
          })
          .then((data) => {
            if (data && data.status) {
              this.selected_country = data.MovieContainer.country_name
                ? {
                    country_name: data.MovieContainer.country_name,
                  }
                : null;
              if (data.MovieContainer.movieRatings[0]) {
                this.selected_country_rating = {
                  country_name: data.MovieContainer.movieRatings[0]
                    ? data.MovieContainer.movieRatings[0].country_name
                    : "",
                };
              }
              if(data.MovieContainer.productionCompany){
                this.selectedProductionCompany=data.MovieContainer.productionCompany.length?data.MovieContainer.productionCompany:[]
              }

              if (
                data.MovieContainer.original_distributor_id &&
                data.MovieContainer.original_distributor_name
              ) {
                this.original_distributor = {
                  d_id: data.MovieContainer.original_distributor_id,
                  d_company_name: data.MovieContainer.original_distributor_name,
                };
              }
              if (
                data.MovieContainer.original_lang_id &&
                data.MovieContainer.original_language_name
              ) {
                this.original_language = {
                  lang_id: data.MovieContainer.original_lang_id,
                  lang_name: data.MovieContainer.original_language_name,
                };
              }
              this.original_release_date = data.MovieContainer
                .original_release_date
                ? data.MovieContainer.original_release_date
                : "";
              // this.MovieContainer.country_name = data.MovieContainer.country_name;
              // this.MovieContainer.country_id = data.MovieContainer.country_id;
              if (
                data.MovieContainer &&
                data.MovieContainer.movieRatings.length == 0
              ) {
                data.MovieContainer.movieRatings = this.MovieContainer.movieRatings;
              } else {
                data.MovieContainer.movieRatings.map((x, i) => {
                  x.selected_rating_country = {
                    country_id: x.country_id,
                    country_name: x.country_name,
                  };
                  x.selected_rating =
                    x.rating && x.rating_id
                      ? {
                          rating: x.rating,
                          rating_id: x.rating_id,
                        }
                      : "";

                  if (x.region_id && x.region_name) {
                    x.region_obj = {
                      region_id: x.region_id,
                      region_name: x.region_name,
                    };
                  }
                });
              }
              if (
                data.MovieContainer &&
                data.MovieContainer.movieLangaugeFormatDistributor.length == 0
              ) {
                data.MovieContainer.movieLangaugeFormatDistributor = this.MovieContainer.movieLangaugeFormatDistributor;
              }
              if (data.MovieContainer.movieLangaugeFormatDistributor) {
                this.leadTimes = [];
                // if( data.MovieContainer.movieLangaugeFormatDistributor.length>0){
                data.MovieContainer.movieLangaugeFormatDistributor.map(
                  (x, i) => {
                    if (x.lead_time_in_hours) {
                      let split = x.lead_time_in_hours.split(":");
                      console.log({ i, split, x });
                      this.leadTimes[i] = {};
                      if (split.length) {
                        this.leadTimes[i].leadTimeHH = split[0];
                        this.leadTimes[i].leadTimeMM = split[1];
                      }
                    } else {
                      this.leadTimes[i].leadTimeHH = "";
                      this.leadTimes[i].leadTimeMM = "";
                    }

                    if (x.sound_format_id && x.sound_format_name) {
                      x["selected_sound_format"] = {
                        sound_format_id: x.sound_format_id,
                        sound_format_name: x.sound_format_name,
                      };
                    } else {
                      x["selected_sound_format"] = null;
                    }

                    if (x.kdm_id && x.kdm) {
                      x["selected_kdm"] = {
                        kdm_id: x.kdm_id,
                        kdm_title: x.kdm,
                      };
                    }

                    x["sales_channel"] = [];
                    if (
                      x.hasOwnProperty("md_sales_channel") &&
                      x.md_sales_channel &&
                      x.md_sales_channel.length > 0
                    ) {
                      this.aggregatorUsersList.map((u) => {
                        if (
                          x.md_sales_channel.some(
                            (el) => el.user_id == u.user_id
                          )
                        ) {
                          x["sales_channel"].push(u);
                        }
                      });
                    } else if (x.md_sales_channel == null) {
                      x["sales_channel"] = _.cloneDeep(
                        this.aggregatorUsersList
                      );
                    } else {
                      x["sales_channel"] = [];
                    }

                    if (!x.subtitle_language_id_1) {
                      x.subtitle_language_name_1 = "";
                    }
                    if (!x.subtitle_language_id_2) {
                      x.subtitle_language_name_2 = "";
                    }
                    if (x.movieDistributors.length == 0) {
                      x.movieDistributors = _.cloneDeep(this.movieDistributors);
                    } else {
                      x.movieDistributors.map((y) => {
                        console.log("Y", y);
                        y.selected_distributor = {
                          d_id: y.distributor_id,
                          d_company_name: y.distributor_name,
                        };
                      });
                    }
                  }
                );

                // }
              }

              if (
                data.MovieContainer &&
                data.MovieContainer.movieLangaugeFormatDistributor
              ) {
                data.MovieContainer.movieLangaugeFormatDistributor = data.MovieContainer.movieLangaugeFormatDistributor.map(
                  (lfd) => {
                    const {
                      is_classic_show,
                      is_confirmed_show,
                      is_private_show,
                      is_crowd_show,
                      is_movie_club,
                    } = lfd;

                    return {
                      ...lfd,
                      is_classic_show: is_classic_show === "Y" ? true : false,
                      is_confirmed_show:
                        is_confirmed_show === "Y" ? true : false,
                      is_private_show: is_private_show === "Y" ? true : false,
                      is_crowd_show: is_crowd_show === "Y" ? true : false,
                      is_movie_club: is_movie_club === "Y" ? true : false,
                    };
                  }
                );
              }

              data.MovieContainer = {
                ...data.MovieContainer,
                is_classic_show:
                  data.MovieContainer.is_classic_show === "Y" ? true : false,
                is_confirmed_show:
                  data.MovieContainer.is_confirmed_show === "Y" ? true : false,
                is_private_show:
                  data.MovieContainer.is_private_show === "Y" ? true : false,
                is_crowd_show:
                  data.MovieContainer.is_crowd_show === "Y" ? true : false,
                is_movie_club:
                  data.MovieContainer.is_movie_club === "Y" ? true : false,
                is_event: data.MovieContainer.is_event == "Y" ? true : false,
              };

              this.MovieContainer = {
                ...this.MovieContainer,
                ...data.MovieContainer,
              };

              if (
                data.MovieContainer.movieLangaugeFormatDistributor[0] &&
                data.MovieContainer.movieLangaugeFormatDistributor[0]
                  .original_lang_name
              ) {
                this.MovieContainer.original_lang[0].lang_name =
                  data.MovieContainer.movieLangaugeFormatDistributor[0].original_lang_name;
              }

              if (
                data.MovieContainer.movieLangaugeFormatDistributor[0] &&
                data.MovieContainer.movieLangaugeFormatDistributor[0]
                  .original_lang_id
              ) {
                this.MovieContainer.original_lang[0].lang_id =
                  data.MovieContainer.movieLangaugeFormatDistributor[0].original_lang_id;
              }

              // this.MovieContainer.original_lang_id =
              //   data.MovieContainer.movieLangaugeFormatDistributor[0].original_lang_id;
              // this.MovieContainer.original_lang_name =
              //   data.MovieContainer.movieLangaugeFormatDistributor[0].original_lang_name;

              if (
                data.MovieContainer.movieLangaugeFormatDistributor[0] &&
                data.MovieContainer.movieLangaugeFormatDistributor[0]
                  .original_distributor_name
              ) {
                this.MovieContainer.original_lang[0].d_company_name =
                  data.MovieContainer.movieLangaugeFormatDistributor[0].original_distributor_name;
              }

              if (
                data.MovieContainer.movieLangaugeFormatDistributor[0] &&
                data.MovieContainer.movieLangaugeFormatDistributor[0]
                  .original_distributor_id
              ) {
                this.MovieContainer.original_lang[0].d_id =
                  data.MovieContainer.movieLangaugeFormatDistributor[0].original_distributor_id;
              }

              console.log(" this.MovieContainer :", this.MovieContainer);
              this.movie_id = this.MovieContainer.movie_id;
            }

            this.MovieContainer.movieLangaugeFormatDistributor.map((x) => {
              x["selectShowType"] = [];

              let findIndex = -1;

              if (x.is_classic_show) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_classic_show";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[0]);
                }
              }
              if (x.is_confirmed_show) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_confirmed_show";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[2]);
                }
              }
              if (x.is_private_show) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_private_show";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[1]);
                }
              }
              if (x.is_crowd_show) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_crowd_show";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[3]);
                }
              }
              if (x.is_movie_club) {
                findIndex = x["selectShowType"].findIndex((y) => {
                  return y.column_name == "is_movie_club";
                });

                if (findIndex < 0) {
                  x["selectShowType"].push(this.ShowTypeArray[4]);
                }
              }
            });
            if (
              this.MovieContainer.is_event &&
              this.MovieContainer.parent_movie_id
            ) {
              this.originalFeatureArray = this.MovieContainer.movieLangaugeFormatDistributor;
              this.getAllActiveMovies(this.MovieContainer.parent_movie_id);
              this.getEventVersions(this.MovieContainer.parent_movie_id);
            }
            console.log("this.MovieContainer", this.MovieContainer);
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },
      /**
       * GET REQUEST LIST START
       */
      getCinemasList: function(cine_id) {
        this.Cinemas = [];
        let body = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        };
        // MasterService.GetActiveList(body)
        //   .then(response => {
        //     const { data } = response;
        //     if (data && data.status && data.Records.length > 0) {
        //       this.Cinemas = data.Records;
        //       this.Cinemas.map(x => {
        //         if (String(cine_id) === String(x.cine_id)) {
        //           // this.DistributorItem.cinema_name = x.cine_name;
        //           console.log(
        //             "this.movieLangaugeFormatDistributor :",
        //             this.MovieContainer.movieLangaugeFormatDistributor
        //           );
        //           this.MovieContainer.movieLangaugeFormatDistributor = this.MovieContainer.movieLangaugeFormatDistributor.map(
        //             singleMovieFormat => {
        //               // // console.log("singleMovieFormat :", singleMovieFormat);
        //               singleMovieFormat.movieDistributors.map(
        //                 singleMovieDistributor => {
        //                   singleMovieDistributor.cinema_name = x.cine_name;
        //                 }
        //               );
        //               return singleMovieFormat;
        //             }
        //           );
        //           this.cinema_id = cine_id;
        //         }
        //       });
        //     } else
        //       this.$toasted.show(data.message || "Opps! Something went wrong");
        //   })
        //   .catch(this._CatchError);

        MasterService.GetCinemasMovieLicence()
          .then((resp) => {
            const { data } = resp;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.DistributorItem.cinema_name = x.cine_name;
                  console.log(
                    "this.movieLangaugeFormatDistributor :",
                    x.cine_id
                  );
                  this.MovieContainer.movieLangaugeFormatDistributor = this.MovieContainer.movieLangaugeFormatDistributor.map(
                    (singleMovieFormat) => {
                      // // console.log("singleMovieFormat :", singleMovieFormat);
                      singleMovieFormat.movieDistributors.map(
                        (singleMovieDistributor) => {
                          singleMovieDistributor.cinema_name = x.cine_name;
                          singleMovieDistributor.cinema_id = x.cine_id;
                        }
                      );
                      return singleMovieFormat;
                    }
                  );
                }
              });

              this.CinemasGroupedByRegion = _.toPairs(
                _.groupBy(
                  data.Records.filter((x) => x.region_id),
                  "region_id"
                )
              );

              let tempTerittoryGrp = _.toPairs(
                _.groupBy(data.Records, "territory_id")
              );

              this.newgroupRegionCinema = [];

              // this.CinemasGroupedByRegion.forEach((_group) => {
              //   this.newgroupRegionCinema.push({
              //     label: _group[1][0]["region_name"],
              //     Cinemas: _group[1],
              //   });
              // });

              tempTerittoryGrp.forEach((_group) => {
                this.newgroupRegionCinema.push({
                  label:
                    _group[1][0]["territory_name"] ||
                    _group[1][0]["region_name"] ||
                    "All",
                  Cinemas: _group[1],
                });
              });
              console.log(
                "this.CinemasGroupedByRegion",
                this.CinemasGroupedByRegion
              );
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },
      onChangeOriginalReleaseDate: function(event) {
        if (event.target.value) {
          let releasedate = event.target.value;
          this.setDefaultLicenceStartDate(releasedate);
        }
      },
      onClickCinemaPill: function(
        event,
        cinema,
        DistributorItem,
        DistributorIndex
      ) {
        this.onChangeEvent(DistributorIndex);
        console.log("onClickCinemaPill called");
        let selected_cinemas = DistributorItem.selected_cinema;
        let doesExist = selected_cinemas.findIndex(
          (x) => x.cine_id == cinema.cine_id
        );
        if (doesExist !== -1) {
          selected_cinemas.splice(doesExist, 1);
          this.setLeadTime(null, DistributorIndex, "reset");
        } else {
          selected_cinemas.push(cinema);
          this.setLeadTime(selected_cinemas, DistributorIndex, "set");
        }

        console.log(
          "DistributorItem.selected_cinema",
          DistributorItem.selected_cinema
        );

        if (event && event.target) {
          event.target.blur();
        }

        this.checkScheduleExistsAlertForModification(DistributorItem);
      },
      setLeadTime(cinema, index, type) {
        if (type == "reset") {
          this.leadTimes[index].leadTimeHH = "00";
          this.leadTimes[index].leadTimeMM = "00";
        } else if (type == "set" && cinema[0]) {
          let split = cinema[0].lead_time_in_hours.split(":");
          if (split && split.length > 0) {
            this.leadTimes[index].leadTimeHH = split[0];
            this.leadTimes[index].leadTimeMM = split[1];
          }
        } else {
          console.log("Error: please provide proper data");
        }
      },
      onClickCinemaRegion: function(cinemas, DistributorItem) {
        let selected_cinemas = DistributorItem.selected_cinema;

        const doesAllExist = cinemas.every((c) => {
          if (selected_cinemas.findIndex((x) => x.cine_id == c.cine_id) > -1) {
            return true;
          }
          return false;
        });

        if (doesAllExist) {
          DistributorItem.selected_cinema = selected_cinemas.filter((x) => {
            if (cinemas.findIndex((c) => c.cine_id == x.cine_id) > -1) {
              return false;
            }
            return true;
          });
        } else {
          cinemas.forEach((c) => {
            if (
              selected_cinemas.findIndex((x) => x.cine_id == c.cine_id) === -1
            ) {
              selected_cinemas.push(c);
            }
          });
        }

        this.checkScheduleExistsAlertForModification(DistributorItem);
      },

      getCountriesList: function() {
        this.Countries = [];
        let payload = {
          tableName: "ms_countries",
          country_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Countries = data.Records;
              let globalOptions = this.$store.getters.getGlobalOptions;
              if (this.Countries.length > 0 && globalOptions.length > 0) {
                let operationCountryId = globalOptions.find((data) => {
                  return data.go_key === "OPERATION_COUNTRY";
                });
                let countryInfo = this.Countries.find((data) => {
                  return data.country_id == operationCountryId.go_value;
                });
                this.defaultCountry = { ...countryInfo };
              }
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getGenreList: function() {
        this.Genre = [];
        let payload = {
          tableName: "ms_genre",
          g_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Genres = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getLabelList: function() {
        this.Labels = [];
        let payload = {
          tableName: "ms_movie_labels",
          label_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Labels = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getProductionList: function() {
        this.Production = [];
        let payload = {
          tableName: "ms_production_companies",
          production_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Productions = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getLanguagesList: function() {
        this.Languages = [];
        this.LanguagesCopy = [];
        let payload = {
          tableName: "ms_language",
          lang_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Languages = data.Records;
              this.LanguagesCopy = [...data.Records];
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getFormatsList: function() {
        this.Formats = [];
        let payload = {
          tableName: "ms_movie_formats",
          mf_is_active: "Y",
          orderBy: "asc",
          columnName: "mf_order",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Formats = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getRatingsList: function() {
        this.Ratings = [];
        let payload = {
          tableName: "ms_ratings",
          rating_is_active: "Y",
          orderBy: "asc",
          columnName: "r_order",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Ratings = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
       getCastMasters: function() {
        let payload = {
          tableName: "ms_cast_master",
          cast_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.CastMasters = data.Records;
            } else {
              this.CastMasters = []
            }
          })
          .catch((error) => {
            console.log("show error :", error);
          });
      },
      getCrewsList: function() {
        this.Crews = [];
        let payload = {
          tableName: "ms_crew",
          crew_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Crews = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getCitiesList: function(state_id, mainIndex, arrayIndex) {
        // this.Cities = [];
        let payload = {
          tableName: "ms_cities",
          city_is_active: "Y",
          state_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              // this.Cities = data.Records;
              this.MovieDetailsCityAndStatesHandler[mainIndex][
                arrayIndex
              ].cityList = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getStatesList: function(country_id, mainIndex, arrayIndex) {
        // this.States = [];
        let payload = {
          tableName: "ms_states",
          state_is_active: "Y",
          country_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              // this.States = data.Records;
              this.MovieDetailsCityAndStatesHandler[mainIndex][
                arrayIndex
              ].stateList = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getDistributorsList: function() {
        this.Distributors = [];
        let payload = {
          tableName: "ms_distributors",
          d_is_active: "Y",
          parent_distributor_id: 0,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Distributors = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },

      getSubDistributorsList: function(d_id, d_name) {
        let payload = {
          tableName: "ms_distributors",
          d_is_active: "Y",
          parent_distributor_id: d_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.subdistributor = data.Records;
            } else {
              this.subdistributor = [];
              this.$toasted.show("No Sub-Distributor found for " + d_name);
              // Show Errors
              console.log("show error :::::", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      /**
       * GET REQUEST LIST END
       */

      /**
       * MOVIE TOP INFO SECTION START
       */

      onSelectCountryHandler: function(
        event,
        flag,
        Country,
        Obj,
        DistributorIndex,
        MovieContentIndex
      ) {
        if (flag) {
          this.MovieContainer.country_name = Country.country_name;
          this.MovieContainer.country_id = Country.country_id;
        } else {
          this.MovieContentContainer[MovieContentIndex].movieDistributors[
            DistributorIndex
          ].country_name = Country.country_name;
          this.MovieContentContainer[MovieContentIndex].movieDistributors[
            DistributorIndex
          ].country_id = Country.country_id;
        }
      },
      /**
       * MOVIE TOP INFO SECTION END
       */

      /**
       * DISTRIBUTORS DROPDOWN HANDLERS START
       */
      onSelectDistributorHandler: function(
        DistributorListItem,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].distributor_name =
          DistributorListItem.d_company_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].distributor_id =
          DistributorListItem.d_id;

        //Clear SubDistributor Name and ID
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_name = "";

        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_id = null;
        this.getSubDistributorsList(
          DistributorListItem.d_id,
          DistributorListItem.d_company_name
        );

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },
      onRemoveDistributorHandler: function(
        DistributorListItem,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].distributor_name = "";
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].distributor_id = null;

        //Clear SubDistributor Name and ID
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_name = "";

        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_id = null;

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },
      onChangeLeadTime(
        event,
        DistributorIndex,
        LangaugeFormatDistributorIndex,
        type,
        LangaugeFormatDistributor
      ) {
        let time = event.target.value;

        if (type === "HH") {
          this.leadTimes[LangaugeFormatDistributorIndex].leadTimeHH = time;
        } else if (type === "MM") {
          this.leadTimes[LangaugeFormatDistributorIndex].leadTimeMM = time;
        }
        console.log({ leadTimes: this.leadTimes });
        this.checkScheduleExistsAlertForModification(LangaugeFormatDistributor);
        this.$forceUpdate();
      },
      onSelectSubDistributorHandler: function(
        event,
        DistributorListItem,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_name =
          DistributorListItem.d_company_name;

        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].sub_distributor_id =
          DistributorListItem.d_id;

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },
      onSelectDistributorCinemaHandler: function(
        Cinema,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].cinema_name = Cinema.cine_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].cinema_id = Cinema.cine_id;

        console.log("event TEST##", event);
      },
      onRemoveDistributorCinemaHandler: function(
        event,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        console.log(
          " this.MovieContainer.movieLangaugeFormatDistributor:>> ",
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex]
        );

        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].removed_cinema = event;

        console.log("event", event);
        // this.leadTimes[LangaugeFormatDistributorIndex].
        // this.MovieContainer.movieLangaugeFormatDistributor[
        //   LangaugeFormatDistributorIndex
        // ].movieDistributors[DistributorIndex].selected_cinema.splice(
        //   event.cine_name,
        //   1
        // );
      },
      onSelectDistributorsCountryHandler: function(
        event,
        Country,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].country_name =
          Country.country_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].country_id = Country.country_id;
        this.onResetSelectedDistributorDropdown(
          ["state", "city"],
          LangaugeFormatDistributorIndex,
          DistributorIndex
        );
        this.getStatesList(
          Country.country_id,
          LangaugeFormatDistributorIndex,
          DistributorIndex
        );
      },
      onSelectStateHandler: function(
        event,
        State,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].state_name = State.state_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].state_id = State.state_id;
        this.onResetSelectedDistributorDropdown(
          [, "city"],
          LangaugeFormatDistributorIndex,
          DistributorIndex
        );
        this.getCitiesList(
          State.state_id,
          LangaugeFormatDistributorIndex,
          DistributorIndex
        );
      },
      onSelectCityHandler: function(
        event,
        City,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].city_name = City.city_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors[DistributorIndex].city_id = City.city_id;
      },
      onResetSelectedDistributorDropdown: function(
        [state, city],
        LangaugeFormatDistributorIndex,
        DistributorIndex
      ) {
        if (state && state === "state") {
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex].state_name = "";
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex].state_id = null;
          this.MovieDetailsCityAndStatesHandler[LangaugeFormatDistributorIndex][
            DistributorIndex
          ].stateList = [];
        }
        if (city && city === "city") {
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex].city_name = "";
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ].movieDistributors[DistributorIndex].city_id = null;
          this.MovieDetailsCityAndStatesHandler[LangaugeFormatDistributorIndex][
            DistributorIndex
          ].cityList = [];
        }
      },
      // Increase & decrease Distributor

      removeDistributor: function(
        event,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors.splice(DistributorIndex, 1);
        // this.MovieDetailsCityAndStatesHandler[
        //   LangaugeFormatDistributorIndex
        // ].splice(DistributorIndex, 1);
      },
      addDistributor: function(
        event,
        DistributorIndex,
        LangaugeFormatDistributorIndex
      ) {
        console.log("this.MovieContainer", this.MovieContainer);
        let obj = {
          id: "",
          distributor_name: this.MovieContainer.original_distributor_name
            ? this.MovieContainer.original_distributor_name
            : "",
          distributor_id: this.MovieContainer.original_distributor_id
            ? this.MovieContainer.original_distributor_id
            : "",
          selected_distributor: this.MovieContainer.original_distributor_id
            ? {
                d_id: this.MovieContainer.original_distributor_id,
                d_company_name: this.MovieContainer.original_distributor_name,
              }
            : "",
          city_name: "",
          city_id: null,
          state_name: "",
          state_id: null,
          country_name: "",
          country_id: null,
          fromdate: new Date(),
          todate: new Date(),
          // NEW
          cinema_id: null,
          cinema_name: "",
          sub_distributor_name: "",
          sub_distributor_id: null,
          selected_cinema: [],
        };
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movieDistributors.push(obj);
        let _obj = {
          country_id: null,
          stateList: [],
          cityList: [],
        };
        // this.MovieDetailsCityAndStatesHandler[
        //   LangaugeFormatDistributorIndex
        // ].push(_obj);
      },
      addSignageData() {
        this.signageContainer.push({
          width: "",
          height: "",
          imageUrl: "",
        });
      },
      removeSignage(index) {
        this.signageContainer.splice(index, 1);
      },

      addSceneImage: function(event, screenIndex) {
        this.movieScenes.push({
          image_path: "",
        });
        // this.Scenes.push({
        //   SceneImageUrl: "",
        //   SceneImageName: ""
        // })
      },
      removeSceneImage: function(event, sceneIndex) {
        this.movieScenes.splice(sceneIndex, 1);
      },
      removeImageHandler: function(obj, type) {
        if (!obj) return;

        if (type === 1) {
          // movie content artwork
          obj.artwork = "";
        } else if (type === 2) {
          // lang specific other images
          obj.image_setting_path = "";
          obj.original_mp_poster_url = "";
          obj.is_compressed = "N";
        } else if (type === 3) {
          // movie scene
          obj.image_path = "";
        } else if (type === 4) {
          // movie versions artwork
          if (!this.checkDisableFeatureVersion(obj)) {
            obj.md_thumbnail_url = "";
            obj.original_md_thumbnail_url = "";
            obj.is_compressed = "N";
          }
          this.checkScheduleExistsAlertForModification(obj);
        } else if (type === 5) {
          // original movie artwork
          obj.original_artwork = "";
          obj.is_compressed = "N";
        }

        this.$forceUpdate();
      },
      /**
       * DISTRIBUTORS DROPDOWN HANDLERS END
       */
      /**
       * MOVIE DETAILS -LANGUAGE -FORMAT HANDLER START
       */
      onSelectLanguageHandler: function(Language, index, type = 2) {
        if (type === 1) {
          // movie trailers language
          this.movie_trailers[index].language_id = Language.lang_id;
        } else if (type === 2) {
          // movie version language
          this.MovieContainer.movieLangaugeFormatDistributor[index].lang_name =
            Language.lang_name;
          this.MovieContainer.movieLangaugeFormatDistributor[index].lang_id =
            Language.lang_id;
        } else if (type === 3) {
          // original trailer language
          this.MovieContainer.original_trailer.language_id = Language.lang_id;
        } else if (type === 4) {
          this.cast_and_crew[index].language_id = Language.lang_id;
          this.cast_and_crew[index].langauge = Language.lang_name;
        }
      },
      onRemoveLanguageHandler: function(Language, index, type = 2) {
        if (type === 1) {
          // movie trailers language
          this.movie_trailers[index].language_id = null;
        } else if (type === 2) {
          // movie version language
          this.MovieContainer.movieLangaugeFormatDistributor[index].lang_name =
            "";
          this.MovieContainer.movieLangaugeFormatDistributor[
            index
          ].lang_id = null;
        } else if (type === 3) {
          // original trailer language
          this.MovieContainer.original_trailer.language_id = null;
        } else if (type === 4) {
          this.cast_and_crew[index].language_id = null;
          this.cast_and_crew[index].langauge = "";
        }
      },

      onSearchLanguage: function(query, id) {
        if (!query) {
          this.LanguagesCopy = [...this.Languages];
        } else {
          this.LanguagesCopy = this.Languages.filter((lang) => {
            if (
              (lang.lang_name &&
                lang.lang_name.toLowerCase().includes(query)) ||
              (lang.iso_3 && lang.iso_3.toLowerCase().includes(query)) ||
              (lang.iso_2 && lang.iso_2.toLowerCase().includes(query))
            ) {
              return true;
            } else {
              return false;
            }
          });
        }
      },

      onSelectOriginalLanguageHandler: function(Language) {
        this.MovieContainer.original_lang.lang_id = Language.lang_id;
        this.MovieContainer.original_lang.lang_name = Language.lang_name;

        this.MovieContainer.original_lang_name = Language.lang_name;
        this.MovieContainer.original_lang_id = Language.lang_id;
      },
      onSelectOriginalDistributorHandler(distributor) {
        this.MovieContainer.copyright = `Copyright ${distributor.d_company_name}`;
        this.MovieContainer.original_distributor_name =
          distributor.d_company_name;
        this.MovieContainer.original_distributor_id = distributor.d_id;
        console.log(
          "this.MovieContainer.movieLangaugeFormatDistributor",
          this.MovieContainer.movieLangaugeFormatDistributor
        );
        this.MovieContainer.movieLangaugeFormatDistributor.forEach((lfd) => {
          if (lfd.movieDistributors && lfd.movieDistributors.length > 0) {
            lfd.movieDistributors.forEach((md) => {
              if (!md.distributor_id) {
                md.distributor_id = distributor.d_id;
                md.distributor_name = distributor.d_company_name;
                md.selected_distributor = {
                  d_company_name: distributor.d_company_name,
                  d_id: distributor.d_id,
                };
              } else {
                md.distributor_id = distributor.d_id;
                md.distributor_name = distributor.d_company_name;
                md.selected_distributor = {
                  d_company_name: distributor.d_company_name,
                  d_id: distributor.d_id,
                };
              }
            });
          }
        });
      },
      onSelectFormatHandler(Format, LangaugeFormatDistributorIndex) {
        // this.MovieContainer.movieLangaugeFormatDistributor[
        //   LangaugeFormatDistributorIndex
        // ].searchable_format.mf_name = Format.mf_name;

        // this.MovieContainer.movieLangaugeFormatDistributor[
        //   LangaugeFormatDistributorIndex
        // ].searchable_format.mf_id = Format.mf_id;
        //
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].format_name = Format.mf_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].format_id = Format.mf_id;
      },
      onSelectSoundFormatHandler: function(
        Format,
        LangaugeFormatDistributorIndex
      ) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].selected_sound_format = Format;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].sound_format_name = Format.sound_format_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].sound_format_id = Format.sound_format_id;

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },

      onSelectExperienceHandler(experience, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_experience_format_name = experience.movie_experience;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_experience_format_id = experience.movie_experience_id;
      },
      onSelectAspectRatio(ar, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_aspect_ratio_name = ar.aspect_ratio_name;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_aspect_ratio_id = ar.aspect_ratio_id;

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },
      onSelectMovieResolution(resolution, LangaugeFormatDistributorIndex) {
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_resolution_name = resolution.resolution_short_code;
        this.MovieContainer.movieLangaugeFormatDistributor[
          LangaugeFormatDistributorIndex
        ].movie_resolution_id = resolution.resolution_id;

        this.checkScheduleExistsAlertForModification(
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
      },

      //Set Image
      // setImage: function(e, LangaugeFormatDistributorIndex) {
      //   this.file = e.target.files[0];
      //   this.filename = e.target.files[0]["name"];
      //   this.indexofthubmnail = LangaugeFormatDistributorIndex;

      //   // console.log("file.type.indexOf :", file.type);
      //   if (this.file.type.indexOf("image/") === -1) {
      //     this.$toasted.show("Please select an image file");
      //     return;
      //   }
      //   if (typeof FileReader === "function") {
      //     const reader = new FileReader();
      //     reader.onload = event => {
      //       this.imgSrc = event.target.result;
      //       // rebuild cropperjs with the updated source
      //       this.$bvModal.show("imagecropper");
      //       e.target.value = "";
      //     };
      //     reader.readAsDataURL(this.file);
      //   } else {
      //     // alert("Sorry, FileReader API not supported");
      //   }
      // },

      // cropImage() {
      //   // get image data for post processing, e.g. upload or setting image src
      //   this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      //   var block = this.cropImg.split(";");
      //   // Get the content type of the image
      //   var contentType = block[0].split(":")[1]; // In this case "image/gif"
      //   // get the real base64 content of the file
      //   var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      //   // Convert it to a blob to upload
      //   var blob1 = this.b64toBlob(realData, contentType);
      //   this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
      // },
      // b64toBlob(b64Data, contentType, sliceSize) {
      //   contentType = contentType || "";
      //   sliceSize = sliceSize || 512;

      //   var byteCharacters = atob(b64Data);
      //   var byteArrays = [];

      //   for (
      //     var offset = 0;
      //     offset < byteCharacters.length;
      //     offset += sliceSize
      //   ) {
      //     var slice = byteCharacters.slice(offset, offset + sliceSize);

      //     var byteNumbers = new Array(slice.length);
      //     for (var i = 0; i < slice.length; i++) {
      //       byteNumbers[i] = slice.charCodeAt(i);
      //     }

      //     var byteArray = new Uint8Array(byteNumbers);

      //     byteArrays.push(byteArray);
      //   }

      //   var blob = new Blob(byteArrays, { type: contentType });
      //   return blob;
      // },

      // event, LangaugeFormatDistributor, LangaugeFormatDistributorIndex
      // onThumbnailUpload: function(
      //   image,
      //   filename,
      //   LangaugeFormatDistributorIndex
      // ) {
      //   let loader = this.$loading.show();
      //   let formData = new FormData();
      //   formData.append("image", image, filename);
      //   formData.append("imagePath", "Movie Image");

      //   MasterService.GlobalUploadImage(formData)
      //     .then(response => {
      //       const { data } = response;
      //       if (data && data.status) {
      //         this.MovieContainer.movieLangaugeFormatDistributor[
      //           LangaugeFormatDistributorIndex
      //         ].md_thumbnail_url = data.path;

      //         this.imgSrc = "";
      //         this.$bvModal.hide("imagecropper");
      //       } else {
      //         data["message"] && data["message"]["message"]
      //           ? this.$toasted.show(data.message.message)
      //           : this.$toasted.show(
      //               data.message ||
      //                 "Sorry! Something went wrong. kindly contact your administrator"
      //             );
      //       }
      //     })
      //     .catch(this._CatchError)
      //     .finally(() => {
      //       setTimeout(() => loader.hide(), 1000);
      //     });
      // },
      // Increase & decrease
      addLangaugeFormatDistributor: function(event) {
        let obj = {
          id: "",
          lang_name: "",
          lang_id: null,
          searchable_language: "",
          searchable_format: [
            {
              mf_name: "Select Format",
              mf_id: null,
            },
          ],
          format_id: null,
          format_name: "",
          mf_id: null,
          mf_name: "",
          sound_format_id: null,
          sound_format_name: "",
          trailer: "",
          macs_status: "Y",
          is_foreign_movie: "N",
          kdm: null,
          kdm_id: null,
          selected_kdm: "",
          key_valid_from: "",
          key_valid_to: "",
          md_thumbnail_url: "",
          md_thumbnail_path: "/uploads/moviethumbnail/",
          md_thumbnail_name: "Upload Poster",
          md_thumbnail_size: "",
          subtitle_language_id_1: null,
          subtitle_language_name_1: "",
          subtitle_language_id_2: null,
          subtitle_language_name_2: "",
          sales_channel: _.cloneDeep(this.aggregatorUsersList),
          dist_share_threshold: null,
          dcp_available: "N",

          tms_id: "",
          uuid: "",
          movie_tms_length:
            this.MovieContainer.movieRatings &&
            this.MovieContainer.movieRatings[0] &&
            this.MovieContainer.movieRatings[0].runTime
              ? this.getTimeString(
                  this.MovieContainer.movieRatings[0].runTime
                ) || ""
              : "",
          movie_tms_intermission_time: "",
          movie_tms_credits_time: "",
          movie_fps: 24,
          movie_length_in_frames: null,
          movie_intermission_time_in_frames: null,
          movie_credits_time_in_frames: null,
          showMore: false,
          movie_aspect_ratio_id: null,
          movie_aspect_ratio_name: "",

          movie_experience_format_id: null,
          movie_experience_format_name: null,

          movie_resolution_id: null,
          movie_resolution_name: "",

          is_classic_show: this.MovieContainer.is_classic_show,
          is_confirmed_show: this.MovieContainer.is_confirmed_show,
          is_private_show: this.MovieContainer.is_private_show,
          is_crowd_show: this.MovieContainer.is_crowd_show,
          is_movie_club: this.MovieContainer.is_movie_club,

          movieDistributors: [
            {
              id: "",
              distributor_name: this.MovieContainer.original_distributor_name
                ? this.MovieContainer.original_distributor_name
                : "",
              distributor_id: this.MovieContainer.original_distributor_id
                ? this.MovieContainer.original_distributor_id
                : "",
              selected_distributor: this.MovieContainer.original_distributor_id
                ? {
                    d_id: this.MovieContainer.original_distributor_id,
                    d_company_name: this.MovieContainer
                      .original_distributor_name,
                  }
                : "",
              city_name: "",
              city_id: null,
              state_name: "",
              state_id: null,
              country_name: "",
              country_id: null,
              fromdate: new Date(),
              todate: new Date(),
              // NEW
              cinema_id: null,
              cinema_name: "",
              selected_cinema: [],
            },
          ],
          selected_cinema: this.Cinemas || [],
          licence_start_date: this.MovieContainer.original_release_date
            ? this.MovieContainer.original_release_date
            : "",
          licence_end_date: "",
          selectShowType: [],
          interval_time: "",
        };
        let tempObj = this.copyPreviousFeatureData(obj);
        obj = _.cloneDeep(tempObj);
        this.MovieContainer.movieLangaugeFormatDistributor.push(obj);
        let leadtime = {
          leadTimeHH: "00",
          leadTimeMM: "00",
        };
        this.leadTimes.push(leadtime);
        console.log("this.leadTimes", this.leadTimes);
        let _obj = [
          {
            country_id: null,
            stateList: [],
            cityList: [],
          },
        ];
        this.MovieDetailsCityAndStatesHandler.push(_obj);
      },
      removeLangaugeFormatDistributor: function(
        event,
        LangaugeFormatDistributorIndex
      ) {
        console.log(
          "this.MovieContainer.movieLangaugeFormatDistributor[LangaugeFormatDistributorIndex] :>> ",
          this.MovieContainer.movieLangaugeFormatDistributor[
            LangaugeFormatDistributorIndex
          ]
        );
        if (
          !this.checkDisableFeatureVersion(
            this.MovieContainer.movieLangaugeFormatDistributor[
              LangaugeFormatDistributorIndex
            ]
          ) &&
          !this.disableFeatureVersion
        ) {
          if (
            this.MovieContainer.movieLangaugeFormatDistributor[
              LangaugeFormatDistributorIndex
            ].md_id
          ) {
            this.removedMovies.push(
              this.MovieContainer.movieLangaugeFormatDistributor[
                LangaugeFormatDistributorIndex
              ]
            );
          }
          console.log("this.removedMovies :>> ", this.removedMovies);
          this.MovieContainer.movieLangaugeFormatDistributor.splice(
            LangaugeFormatDistributorIndex,
            1
          );
          this.MovieDetailsCityAndStatesHandler.splice(
            LangaugeFormatDistributorIndex,
            1
          );
          this.leadTimes.splice(LangaugeFormatDistributorIndex, 1);
        } else {
          if (this.disableFeatureVersion) {
            return this.$toasted.show("Edit Not Allowed For Events");
          } else {
            return this.$toasted.show(
              "Schedule Exists for this feature version, Edit Not Allowed!"
            );
          }
        }
      },
      calculateFramesFromLength: function(LangaugeFormatDistributor) {
        if (
          LangaugeFormatDistributor &&
          !isNaN(parseInt(LangaugeFormatDistributor.movie_fps))
        ) {
          let fps = parseInt(LangaugeFormatDistributor.movie_fps);

          if (
            LangaugeFormatDistributor &&
            LangaugeFormatDistributor.movie_tms_length
          ) {
            let length_in_seconds = this.getTimeFromTimeString(
              LangaugeFormatDistributor.movie_tms_length
            );
            let total_frames = length_in_seconds * fps;
            LangaugeFormatDistributor.movie_length_in_frames = total_frames;
          } else {
            LangaugeFormatDistributor.movie_length_in_frames = null;
          }

          if (
            LangaugeFormatDistributor &&
            LangaugeFormatDistributor.movie_tms_intermission_time
          ) {
            let length_in_seconds = this.getTimeFromTimeString(
              LangaugeFormatDistributor.movie_tms_intermission_time
            );
            let total_frames = length_in_seconds * fps;
            LangaugeFormatDistributor.movie_intermission_time_in_frames = total_frames;
          } else {
            LangaugeFormatDistributor.movie_intermission_time_in_frames = null;
          }

          if (
            LangaugeFormatDistributor &&
            LangaugeFormatDistributor.movie_tms_credits_time
          ) {
            let length_in_seconds = this.getTimeFromTimeString(
              LangaugeFormatDistributor.movie_tms_credits_time
            );
            let total_frames = length_in_seconds * fps;
            LangaugeFormatDistributor.movie_credits_time_in_frames = total_frames;
          } else {
            LangaugeFormatDistributor.movie_credits_time_in_frames = null;
          }
        }
      },
      calculateLengthFromFrames: function(LangaugeFormatDistributor) {
        if (
          LangaugeFormatDistributor &&
          !isNaN(parseInt(LangaugeFormatDistributor.movie_fps))
        ) {
          let fps = parseInt(LangaugeFormatDistributor.movie_fps);
          console.log("🚀 ~ file: addMovies.vue ~ line 7973 ~ fps", fps);

          if (
            LangaugeFormatDistributor &&
            !isNaN(parseInt(LangaugeFormatDistributor.movie_length_in_frames))
          ) {
            let total_frames = parseInt(
              LangaugeFormatDistributor.movie_length_in_frames
            );
            let total_seconds = Math.floor(total_frames / fps);
            let time_string_from_seconds = this.getTimeStringFromSeconds(
              total_seconds
            );
            LangaugeFormatDistributor.movie_tms_length = time_string_from_seconds;
          } else {
            LangaugeFormatDistributor.movie_tms_length = "";
          }

          if (
            LangaugeFormatDistributor &&
            !isNaN(
              parseInt(
                LangaugeFormatDistributor.movie_intermission_time_in_frames
              )
            )
          ) {
            let total_frames = parseInt(
              LangaugeFormatDistributor.movie_intermission_time_in_frames
            );
            let total_seconds = Math.floor(total_frames / fps);
            let time_string_from_seconds = this.getTimeStringFromSeconds(
              total_seconds
            );
            LangaugeFormatDistributor.movie_tms_intermission_time = time_string_from_seconds;
          } else {
            LangaugeFormatDistributor.movie_tms_intermission_time = "";
          }

          if (
            LangaugeFormatDistributor &&
            !isNaN(
              parseInt(LangaugeFormatDistributor.movie_credits_time_in_frames)
            )
          ) {
            let total_frames = parseInt(
              LangaugeFormatDistributor.movie_credits_time_in_frames
            );
            let total_seconds = Math.floor(total_frames / fps);
            let time_string_from_seconds = this.getTimeStringFromSeconds(
              total_seconds
            );
            LangaugeFormatDistributor.movie_tms_credits_time = time_string_from_seconds;
          } else {
            LangaugeFormatDistributor.movie_tms_credits_time = "";
          }
        }
      },
      getTimeFromTimeString: function(time_string) {
        if (!time_string || time_string.split(":").length !== 3) {
          return 0;
        }

        let time_components = time_string.trim().split(":");
        let hours = parseInt(time_components[0]);
        let minutes = parseInt(time_components[1]);
        let seconds = parseInt(time_components[2]);

        let total_minutes = hours * 60 + minutes;
        let total_seconds = total_minutes * 60 + seconds;

        return total_seconds;
      },
      /**
       * MOVIE DETAILS -LANGUAGE -FORMAT HANDLER END
       */
      onSelectRatingCountryHandler: function(Country, RatingIndex) {
        this.MovieContainer.movieRatings[RatingIndex].country_name =
          Country.country_name;
        this.MovieContainer.movieRatings[RatingIndex].country_id =
          Country.country_id;
      },

      onSelectRatingRegionHandler: function(region, RatingIndex) {
        this.MovieContainer.movieRatings[RatingIndex].region_id =
          region.region_id;
        this.MovieContainer.movieRatings[RatingIndex].region_name =
          region.region_name;
        if (region.region_id == 0) {
          this.MovieContainer.movieRatings = this.MovieContainer.movieRatings.filter(
            (x, index) => index == RatingIndex
          );
        }
      },

      onSelectMovieRatingHandler: function(MovieRating, RatingIndex) {
        this.MovieContainer.movieRatings[RatingIndex].rating =
          MovieRating.rating;
        this.MovieContainer.movieRatings[RatingIndex].rating_id =
          MovieRating.rating_id;
      },
      onRemoveSubtitleLanguageHandler(
        Language,
        index,
        subtitle_number,
        type = 2
      ) {
        if (type == 2) {
          this.MovieContainer.movieLangaugeFormatDistributor[index][
            `subtitle_language_id_${subtitle_number}`
          ] = null;
        }
      },
      onSelectSubtitleLanguageHandler: function(
        Language,
        index,
        subtitle_number,
        type = 2
      ) {
        if (type === 1) {
          // movie trailer subtitle language
          this.movie_trailers[index][`subtitle_lang_id_${subtitle_number}`] =
            Language.lang_id;
        } else if (type === 2) {
          // movie version subtitle lang
          this.MovieContainer.movieLangaugeFormatDistributor[index][
            `subtitle_language_name_${subtitle_number}`
          ] = Language.lang_name;
          this.MovieContainer.movieLangaugeFormatDistributor[index][
            `subtitle_language_id_${subtitle_number}`
          ] = Language.lang_id;
          this.checkScheduleExistsAlertForModification(
            this.MovieContainer.movieLangaugeFormatDistributor[index]
          );
        } else if (type === 3) {
          // original trailer subtitle lang
          this.MovieContainer.original_trailer[
            `subtitle_lang_id_${subtitle_number}`
          ] = Language.lang_id;
        }

        this.dummy = Math.random(); // to cause the featureVersionsText to recompute
        this.$forceUpdate();
      },
      // Increase & decrease Rating
      addMoreRating: function(event) {
        console.log("this.defaultCountry", this.defaultCountry);
        this.MovieContainer.movieRatings.push({
          id: "",
          country_name: this.defaultCountry
            ? this.defaultCountry.country_name
            : "Select Country",
          selected_rating_country: this.defaultCountry
            ? { ...this.defaultCountry }
            : "",
          country_id: this.defaultCountry
            ? this.defaultCountry.country_id
            : null,
          rating: "",
          rating_id: null,
          releaseDate: null,
          // date: new Date(2016, 9, 16),
          runTime: "",
          intervalTime: "",
          region_id: null,
          region_obj: null,
          region_name: "",
        });
      },
      removeRating: function(event, RatingIndex) {
        this.MovieContainer.movieRatings.splice(RatingIndex, 1);
      },

      addMovieTrailer: function() {
        this.movie_trailers.push({
          language_id: null,
          language: null,
          trailer_link: "",
          subtitle_lang_id_1: null,
          subtitle_lang_1: null,
          subtitle_lang_id_2: null,
          subtitle_lang_2: null,
        });
      },

      removeMovieTrailer: function(index) {
        this.movie_trailers.splice(index, 1);
      },

      /**
       * -RATING -RELEASED DATE -RUNTIME SECTION START
       */
      /**
       * MOVIE CONTENT DROPDOWN HANDLERS START
       */
      onSelectCrewHandler: function(
        event,
        CrewItem,
        Obj,
        CrewIndex,
        MovieContentIndex
      ) {
        console.log("MovieContentIndex", MovieContentIndex);
        console.log("this.cast_and_crew", this.cast_and_crew);
        console.log("CrewIndex", CrewIndex);
        console.log("CrewItem", CrewItem);
        console.log("this.cast_and_crew", this.cast_and_crew);
        console.log(
          "this.cast_and_crew full",
          this.cast_and_crew[MovieContentIndex].movieCastAndCrewList[CrewIndex]
        );
        this.cast_and_crew[MovieContentIndex].movieCastAndCrewList[
          CrewIndex
        ].crew_title = CrewItem.crew_title;
        this.cast_and_crew[MovieContentIndex].movieCastAndCrewList[
          CrewIndex
        ].crew_id = CrewItem.crew_id;
      },
      // Increase & decrease Cast & Crew
      _addCastAndCrew: function(event, MovieContentIndex) {
        this.MovieContentContainer[MovieContentIndex].movieCastAndCrewList.push(
          {
            id: "",
            crew_title: "Select Crew",
            crew_id: null,
            selected_cast: "",
            members: [],
          }
        );
      },

      addCastAndCrew: function(event, index) {
        this.cast_and_crew[index].movieCastAndCrewList.push({
          id: "",
          crew_title: "",
          crew_id: null,
          selected_cast: "",
          members: [],
        });
      },

      _removeCastAndCrew: function(event, CrewIndex, MovieContentIndex) {
        this.MovieContentContainer[
          MovieContentIndex
        ].movieCastAndCrewList.splice(CrewIndex, 1);
      },

      removeCastAndCrew: function(event, CrewIndex, ContentIndex) {
        this.cast_and_crew[ContentIndex].movieCastAndCrewList.splice(
          CrewIndex,
          1
        );
      },
       onAddCastCrewOption: function(option, CastAndCrewItem) {
        CastAndCrewItem.members.push({
          person_name: option['cast_name'],
          order_no: "",
          mcm_id: option['mcm_id'] || null,
        });
        this.recomputeOrder(CastAndCrewItem.members, "order_no");
        console.log('CastAndCrewItem.members', CastAndCrewItem.members);
      },
      onRemoveCastCrewOption: function(event, CastAndCrewItem) {
        let tempCastsArray = CastAndCrewItem['selectedCastMembers'].map((x, index) => {return {person_name: x['cast_name'], order_no: index, mcm_id: x['cast_name']}})
        CastAndCrewItem.members = _.cloneDeep(tempCastsArray)
        this.recomputeOrder(CastAndCrewItem.members, "order_no");
        console.log('CastAndCrewItem.members', CastAndCrewItem.members);
      },

      addCastCrewMember: function(CastAndCrewItem) {
        console.log("CastAndCrewItem", CastAndCrewItem);
        CastAndCrewItem.members.push({
          person_name: "",
          order_no: "",
        });

        this.recomputeOrder(CastAndCrewItem.members, "order_no");
      },
      removeCastCrewMember: function(CastAndCrewItem, itemIndex) {
        CastAndCrewItem.members.splice(itemIndex, 1);
        this.recomputeOrder(CastAndCrewItem.members, "order_no");
      },
      recomputeOrder: function(items, prop_name) {
        if (!items || !Array.isArray(items) || !prop_name) return;

        for (let i = 0; i < items.length; i++) {
          items[i][prop_name] = i + 1;
        }
      },

      onChangeDraftStatus: function(changed) {
        console.log("🚀 ~ file: addMovies.vue ~ line 4812 ~ changed", changed);
        if (changed === "Y" && this.MovieContainer.movie_isActive === "Y") {
          this.$toasted.show(
            "Please set movie to inactive and then set to draft."
          );
          this.$nextTick(() => {
            this.MovieContainer.movie_is_draft = "N";
          });
        }
      },

      onChangeActiveStatus: function(changed) {
        if (changed === "Y") {
          this.MovieContainer.movie_is_draft = "N";
        }
      },

      getTimeString: function(val) {
        val = parseInt(val);
        if (isNaN(val)) {
          return null;
        }

        let hours = Math.floor(val / 60);
        let minutes = val - hours * 60;
        let seconds = "00";

        hours = hours.toString().padStart(2, "0");
        minutes = minutes.toString().padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
      },

      getTimeStringFromSeconds: function(val) {
        val = parseInt(val);
        if (isNaN(val)) {
          return null;
        }

        let hours = Math.floor(val / (60 * 60));
        let remaining_seconds = val - hours * 60 * 60;
        let minutes = Math.floor(remaining_seconds / 60);
        let seconds = remaining_seconds - minutes * 60;

        hours = hours.toString().padStart(2, "0");
        minutes = minutes.toString().padStart(2, "0");
        seconds = seconds.toString().padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
      },

      onChangeRuntime: _.debounce(function(event, RatingIndex) {
        let runtime = parseInt(event.target.value);
        if (!runtime) {
          return;
        }

        let timestring = this.getTimeString(runtime);
        if (timestring) {
          this.setDefaultMovieLength(timestring);
        }
      }, 2000),

      // setImagePosters: function(e, PosterItem, PosterIndex, MovieContentIndex) {
      //   this.file = e.target.files[0];
      //   this.filename = e.target.files[0]["name"];
      //   this.indexofthubmnail = PosterIndex;
      //   this.movieindex = MovieContentIndex;
      //   this.posteritem = PosterItem;

      //   this.width = PosterItem.image_setting_width;
      //   this.height = PosterItem.image_setting_height;

      //   if (this.file.type.indexOf("image/") === -1) {
      //     this.$toasted.show("Please select an image file");
      //     return;
      //   }
      //   if (typeof FileReader === "function") {
      //     const reader = new FileReader();
      //     reader.onload = event => {
      //       this.imgSrc = event.target.result;

      //       this.$bvModal.show("imagecropperposters");
      //       e.target.value = "";
      //     };
      //     reader.readAsDataURL(this.file);
      //   } else {
      //     // alert("Sorry, FileReader API not supported");
      //   }
      // },

      // cropImagePoster() {
      //   // get image data for post processing, e.g. upload or setting image src
      //   this.cropImg = this.$refs.cropperposters.getCroppedCanvas().toDataURL();
      //   // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      //   var block = this.cropImg.split(";");
      //   // Get the content type of the image
      //   var contentType = block[0].split(":")[1]; // In this case "image/gif"
      //   // get the real base64 content of the file
      //   var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      //   // Convert it to a blob to upload
      //   var blob1 = this.b64toBlob1(realData, contentType);
      //   this.onFileUpload(
      //     blob1,
      //     this.filename,
      //     this.posteritem,
      //     this.indexofthubmnail,
      //     this.movieindex
      //   );
      // },

      // b64toBlob1(b64Data, contentType, sliceSize) {
      //   contentType = contentType || "";
      //   sliceSize = sliceSize || 512;

      //   var byteCharacters = atob(b64Data);
      //   var byteArrays = [];

      //   for (
      //     var offset = 0;
      //     offset < byteCharacters.length;
      //     offset += sliceSize
      //   ) {
      //     var slice = byteCharacters.slice(offset, offset + sliceSize);

      //     var byteNumbers = new Array(slice.length);
      //     for (var i = 0; i < slice.length; i++) {
      //       byteNumbers[i] = slice.charCodeAt(i);
      //     }

      //     var byteArray = new Uint8Array(byteNumbers);

      //     byteArrays.push(byteArray);
      //   }

      //   var blob = new Blob(byteArrays, { type: contentType });
      //   return blob;
      // },

      // onFileUpload: function(
      //   image,
      //   filename,
      //   PosterItem,
      //   PosterIndex,
      //   MovieContentIndex
      // ) {
      //   let loader = this.$loading.show();

      //   let _posters = PosterItem;
      //   // // $event.target.files[0]
      //   let formData = new FormData();

      //   formData.append("image", image, filename);
      //   formData.append("imagePath", "Movie Poster Image");
      //   // formData.append("imagePath", PosterItem.image_setting_static_path);

      //   MasterService.GlobalUploadImage(formData)
      //     .then(response => {
      //       const { data } = response;
      //       if (data && data.status) {
      //         // this.Posters.image_setting_path = data.path;
      //         this.MovieContentContainer[MovieContentIndex].moviePosters[
      //           PosterIndex
      //         ].image_setting_path = data.path;
      //         this.$bvModal.hide("imagecropperposters");
      //       } else {
      //         data["message"] && data["message"]["message"]
      //           ? this.$toasted.show(data.message.message)
      //           : this.$toasted.show(
      //               data.message ||
      //                 "Sorry! Something went wrong. kindly contact your administrator"
      //             );
      //       }
      //     })
      //     .catch(this._CatchError)
      //     .finally(() => {
      //       setTimeout(() => loader.hide(), 1000);
      //     });
      // },
      /**
       * MOVIE CONTENT DROPDOWN HANDLERS END
       */

      MovieContentValidations: function() {
        // crew_title: "",
        // person_name: "",
        // order_no: ""
        let array = [
          { title: "movieContentTitle", type: "String", isRequired: true },
          {
            title: "movieCastAndCrewList",
            type: "Array",
            isRequired: true,
            keys: ["crew_title"],
          },
        ];

        // let TempMovieContentContainer = this.MovieContentContainer;
        // Testing Only One Language Content or use above for all.
        let TempMovieContentContainer = [this.MovieContentContainer[0]];

        for (let i = 0; i < TempMovieContentContainer.length; i++) {
          const element = this.MovieContentContainer[i];
          for (let j = 0; j < array.length; j++) {
            const key = array[j];
            if (key.isRequired && key.type === "String") {
              if (!this.ValidateString(element[key.title])) {
                this.$toasted.show(
                  `Movie ${key.title} field cannot be empty in ${element.langauge} section.`
                );
                return false;
              }
            } else if (key.isRequired && key.type === "Array") {
              if (
                !this.ValidateArray(
                  element[key.title],
                  element[key.title].length,
                  key.keys
                )
              ) {
                this.$toasted.show(
                  `Movie ${key.title} field list cannot be empty in ${element.langauge} section.`
                );
                return false;
              }
            }

            if (
              // i == this.MovieContentContainer.length - 1 &&
              // Testing Only One Language Content or use above for all.
              i === TempMovieContentContainer.length - 1 &&
              // j === array.filter((x)=> x.isRequired).length - 1
              // Right Now I'am checking all, use above for check only is Required
              j == array.length - 1
            ) {
              return true;
            }
          }
        }
      },
      ValidateString(value) {
        return !value && String(value).trim().length == 0 ? false : true;
      },
      ValidateArray(array, length, keys) {
        return (
          array.filter((x) => {
            return this.compaireKeys(x, keys);
          }).length == length
        );
      },
      compaireKeys: function(obj, keys) {
        return (
          keys.filter((y) => obj[y] && String(obj[y]).trim().length > 0)
            .length === keys.length
        );
      },
      CastCrewValidation: function() {
        let count = 0;
        let isDirectorFound = false;

        for (let i = 0; i < this.cast_and_crew.length; i++) {
          let x = this.cast_and_crew[i];

          if (!x.language_id) {
            this.$toasted.show(
              `Please Select Language In Cast And Crew Section`
            );
            return true;
          }

          let castCrew = x.movieCastAndCrewList;

          // if (!x.movieContentTitle || x.movieContentTitle.length === 0) {
          //   this.$toasted.show(
          //     `Please Enter Movie Title for ${x.langauge} language`
          //   );
          //   return true;
          // }

          for (let j = 0; j < castCrew.length; j++) {
            let y = castCrew[j];
            if (
              y.crew_title &&
              y.crew_title.toLowerCase() === "director" &&
              x.langauge.toLowerCase() === "english"
            ) {
              isDirectorFound = true;
            }

            if (y.crew_id == null && y.members && y.members.length > 0) {
              count++;
              this.$toasted.show(
                `Please Enter Cast/Crew details for ${x.langauge} language`
              );
              break;
            } else if (
              y.crew_id !== null &&
              y.members &&
              y.members.length === 0
            ) {
              count++;
              this.$toasted.show(
                `Please Enter Crew Members for ${y.crew_title}`
              );
              break;
            }
          }
        }

        if (!isDirectorFound) {
          this.$toasted.show(`Please Add Director For English language`);
        }

        if (count > 0 || !isDirectorFound) {
          return true;
        } else {
          return false;
        }
      },
      movieDescriptionsValidation: function() {
        let count = 0;

        for (let i = 0; i < this.MovieContentContainer.length; i++) {
          let x = this.MovieContentContainer[i];

          if (
            x.langauge &&
            x.langauge.toLowerCase() === "english" &&
            (!x.movieShortDescription || !x.movieDescription)
          ) {
            this.$toasted.show(
              `Please Enter Movie Descriptions for ${x.langauge} language`
            );
            count++;
            break;
          }
        }

        if (count > 0) {
          return true;
        } else {
          return false;
        }
      },
      durationValidation: function(value) {
        if (!value) return false;

        let splits = value.split(":");
        if (splits.length !== 3) return false;
        if (splits.some((num) => isNaN(parseInt(num)))) return false;

        return true;
      },
      FormatValidation: function() {
        let count = 0;
        // console.log("coming to format validation");
        // console.log("this.MovieContainer.movieLangaugeFormatDistributor", this.MovieContainer.movieLangaugeFormatDistributor)
        this.MovieContainer.movieLangaugeFormatDistributor.map((x) => {
          if (x.lang_id == null) {
            count++;
          }
        });

        if (count > 0) {
          return true;
        } else {
          return false;
        }
      },
      RatingValidation: function() {
        let count = 0;
        this.MovieContainer.movieRatings.map((x) => {
          if (x.country_id == null || x.rating_id == null) {
            count++;
          }
        });
        if (count > 0) {
          return true;
        } else {
          return false;
        }
      },
      basicInfoValidation: function() {
        console.log("this.MovieContainer", this.MovieContainer);
        if (
          !this.MovieContainer.movieTitle ||
          !this.MovieContainer.movie_unique_identifier
        ) {
          return false;
        }
        return true;
      },
      filmInfoValidation: function() {
        console.log("this.MovieContainer", this.MovieContainer);
        if (
          !this.MovieContainer.country_name ||
          this.MovieContainer.genres.length === 0
        ) {
          return false;
        }
        return true;
      },
      setDefaultMovieLength: function(timestring) {
        this.MovieContainer.movieLangaugeFormatDistributor.forEach((mlfd) => {
          if (mlfd.movie_tms_length === "") {
            mlfd.movie_tms_length = timestring || "";
          }
        });
      },
      setDefaultLicenceStartDate: function(date) {
        this.MovieContainer.movieLangaugeFormatDistributor.forEach((mldf) => {
          if (!mldf.licence_start_date) {
            mldf.licence_start_date = date || "";
          }
        });
      },
      onSaveAsDraft: function() {
        this.MovieContainer.movie_is_draft = "Y";
        this.MovieContainer.movie_isActive = "N";

        this.OnFinalSubmit(false);
      },
      checkMovieUUIDValidation() {
        let count = 0;
        this.ErrorIndex = [];
        this.MovieContainer.movieLangaugeFormatDistributor.forEach(
          (x, index) => {
            let regex = /^\S*$/;
            if (x.uuid.match(regex)) {
              this.uuidErrorMessage = "";
            } else {
              this.ErrorIndex.push(index);
              this.uuidErrorMessage = "Spaces are not Allowed.";
              count++;
            }
          }
        );
        if (count > 0) {
          return false;
        } else {
          return true;
        }
      },
      updateStep1(step = "", validate = true) {
        console.log("updateStep1", { step });

        let flag = true;
        let input = [];
        if (
          this.MovieContainer.movie_unique_identifier == "" ||
          this.MovieContainer.movie_unique_identifier == null
        ) {
          this.sectionCollapse.basicInfo = true;
          return this.$toasted.show("Please enter movie unique Id");
        }
        this.custom_fields_list.map((field, index) => {
          if (
            field.custom_field_type == "checkbox" &&
            (this.input_data[index] == undefined ||
              this.input_data[index] == "")
          ) {
            console.log("in here :>> ");
            this.input_data[index] = false;
          }
          if (field.field_is_required == "Y") {
            if (
              (this.input_data[index] == undefined ||
                this.input_data[index] == "") &&
              this.input_data[index] !== false
            ) {
              this.$toasted.show("Enter Custom Field details");
              flag = false;
              return;
            }
          }
        });
        this.submitted = true;

        if (!validate) {
          this.showErrorMessages = false;
        } else {
          this.showErrorMessages = true;
        }

        this.$validator.validate().then((valid) => {
          console.log(this.MovieContainer.original_artwork);
          if (valid) {
            // if (!this.checkMovieUUIDValidation()) {
            //   return;
            // }

            if (!this.basicInfoValidation()) {
              this.sectionCollapse.basicInfo = true;
              console.log("this.basicInfoValidation coming here");
              return;
            }

            if (validate) {
              if (
                this.MovieContainer.original_lang_id == null ||
                this.MovieContainer.original_distributor_id === null
              ) {
                this.sectionCollapse.basicInfo = true;
                console.log("this.basicInfoValidation coming here");
                return;
              }
            }

            if (!validate || true) {
              if (flag || !validate) {
                let loader = this.$loading.show();
                for (let i in this.custom_fields_list) {
                  input.push({
                    custom_field_id: this.custom_fields_list[i].custom_field_id,
                    input_data: this.input_data[i],
                  });
                }

                if (!this.checkAddMoreRatings) {
                  let RatignwithAllRegions = _.cloneDeep(
                    this.MovieContainer.movieRatings.filter(
                      (x) => x.region_id == 0
                    )
                  );
                  if (RatignwithAllRegions.length > 0) {
                    this.MovieContainer.movieRatings = [];
                    this.Regions.filter((y) => y.region_id).map((x) => {
                      let obj = {
                        ...RatignwithAllRegions[0],
                      };
                      console.log("x.region_id", x.region_id);
                      console.log("x.region_name", x.region_name);
                      obj["region_id"] = x.region_id;
                      obj["region_name"] = x.region_name;
                      obj["mrrdr_id"] = null;
                      obj["mrrdr_id"] = null;
                      obj["region_obj"] = {
                        region_id: x.region_id,
                        region_name: x.region_name,
                      };
                      this.MovieContainer.movieRatings.push(obj);
                    });
                  }
                }

                let finalObj = {
                  ...this.MovieContainer,
                  MovieContentContainer: this.MovieContentContainer,
                  removedMovies: this.removedMovies,
                  custom_field_values: input,
                  original_distributor: this.original_distributor,
                  original_language: this.original_language,
                  movieScenes: this.movieScenes,
                  movie_trailers: this.movie_trailers,
                  CastAndCrewContainer: this.cast_and_crew,
                  RemovedLabels: this.removedLabels,
                  SignageContainer: this.signageContainer,
                };

                finalObj.movieLangaugeFormatDistributor.forEach((x, i) => {
                  this.leadTimes[i].leadTimeHH = this.leadTimes[i].leadTimeHH
                    ? this.leadTimes[i].leadTimeHH
                    : "00";
                  this.leadTimes[i].leadTimeMM = this.leadTimes[i].leadTimeMM
                    ? this.leadTimes[i].leadTimeMM
                    : "00";
                  x.lead_time_in_hours = `${this.leadTimes[i].leadTimeHH}:${this.leadTimes[i].leadTimeMM}`;
                });

                finalObj.movieLangaugeFormatDistributor.map(
                  (scheduleDetail) => {
                    let errorMsg = "";
                    if (!scheduleDetail.licence_start_date) {
                      errorMsg = "Please Select License Start Date";
                    }
                    if (!scheduleDetail.licence_end_date) {
                      errorMsg = "Please Select License End Date";
                    }

                    if (
                      moment(scheduleDetail.licence_end_date).isBefore(
                        scheduleDetail.licence_start_date
                      )
                    ) {
                      errorMsg =
                        "License End Date Should be grater than Start Date";
                    }
                    if (
                      (!scheduleDetail.selected_cinema ||
                      scheduleDetail.selected_cinema.length == 0) && false
                    ) {
                      errorMsg = "Please Select Cinema";
                    }

                    if (
                      (!scheduleDetail.selectShowType ||
                        scheduleDetail.selectShowType.length == 0) &&
                      this.getMyCinemaStatusNew() == "Y"
                    ) {
                      errorMsg = "Please Select Show Type";
                    }

                    console.log({ errorMsg });

                    // if (!scheduleDetail.interval_time) {
                    //   errorMsg = "Please Select Intermission Time";
                    // }
                    // let loader = this.$loading.show();
                    let MulScheduleCinemaArray = [];
                    if (!errorMsg) {
                      let is_private_show = true;
                      let is_confirmed_show = true;
                      let is_crowd_show = true;
                      let showTypeArray = Array.prototype.map.call(
                        scheduleDetail.selectShowType,
                        function(item) {
                          return String(item.booking_type_id);
                        }
                      );
                      scheduleDetail.selected_cinema.map((x) => {
                        let cinema_obj = {
                          cinema_id: x.cine_id,
                          category_id: 1,
                          sch_start_date: scheduleDetail.licence_start_date,
                          sch_end_date: scheduleDetail.licence_end_date,
                          MultipleSchedule: [],
                        };
                        x.screen_array.map((y) => {
                          if (y.is_default_screen == "Y") {
                            let filterModule = cinema_obj.MultipleSchedule.findIndex(
                              (scree) => {
                                return scree.screen_id == y.screen_id;
                              }
                            );
                            let newArray = [...showTypeArray];
                            if (filterModule < 0) {
                              if (
                                y.is_confirmed_show == "N" ||
                                x.is_confirmed_show == "N"
                              ) {
                                is_confirmed_show = false;

                                let index_crowd = newArray.indexOf("1");
                                if (index_crowd >= 0) {
                                  newArray.splice(index_crowd, 1);
                                }
                              }
                              if (
                                y.is_crowd_show == "N" ||
                                x.is_crowd_show == "N"
                              ) {
                                is_crowd_show = false;

                                let index_crowd = newArray.indexOf("2");
                                if (index_crowd >= 0) {
                                  newArray.splice(index_crowd, 1);
                                }
                              }
                              if (
                                y.is_private_show == "N" ||
                                x.is_private_show == "N"
                              ) {
                                is_private_show = false;

                                let index_crowd = newArray.indexOf("3");
                                if (index_crowd >= 0) {
                                  newArray.splice(index_crowd, 1);
                                }
                              }

                              let screen_obj = {
                                screen_id: y.screen_id,
                                selectShowType:
                                  this.getMyCinemaStatusNew() == "Y"
                                    ? newArray.join(",")
                                    : "4",

                                moviesArray: [
                                  {
                                    privateRateCard: {
                                      rate_card_id: y.rc_id_private,
                                      rate_card_group_id:
                                        y.rate_card_private_id,
                                    },

                                    cleaning_time_in_mins:
                                      x.cine_cleaning_time_in_mins,
                                    interval_time_in_mins:
                                      x.cine_interval_time_in_mins,
                                    ads_time_in_mins:
                                      x.cine_setting_ads_time_in_mins,
                                    // movie_details_id: scheduleDetail.md_id,
                                    min_seats: y.min_seats,
                                    booked_seats: 0,
                                    gogo_user_id: 0,
                                    ss_category_id: 0,
                                    start_time: y.start_date_time,
                                    end_time: y.end_date_time,
                                    interval_time: x.mycinema_creation_interval
                                      ? x.mycinema_creation_interval
                                      : 0,
                                    is_monday: y.is_monday,
                                    is_tuesday: y.is_tuesday,
                                    is_wednesday: y.is_wednesday,
                                    is_thursday: y.is_thursday,
                                    is_friday: y.is_friday,
                                    is_saturday: y.is_saturday,
                                    is_sunday: y.is_sunday,
                                    scheduling_price: [
                                      {
                                        screen_seat_type_id:
                                          y.screen_seat_type_id,
                                        rate_card_id: y.rc_id,
                                        rate_card_private_id: 0,
                                        rate_card_group_id: y.rate_card_id,
                                      },
                                    ],
                                  },
                                ],
                              };
                              cinema_obj.MultipleSchedule.push(screen_obj);
                            } else {
                              let findIndexNew = cinema_obj.MultipleSchedule[
                                filterModule
                              ].moviesArray.findIndex((mov) => {
                                return (
                                  mov.start_time == y.start_date_time &&
                                  mov.end_time == y.end_date_time
                                );
                              });
                              if (findIndexNew < 0) {
                                let Movieobj = {
                                  privateRateCard: {
                                    rate_card_id: y.rc_id_private,
                                    rate_card_group_id: y.rate_card_private_id,
                                  },
                                  cleaning_time_in_mins:
                                    x.cine_cleaning_time_in_mins,
                                  interval_time_in_mins:
                                    x.cine_interval_time_in_mins,
                                  ads_time_in_mins:
                                    x.cine_setting_ads_time_in_mins,
                                  movie_details_id: scheduleDetail.md_id,
                                  min_seats: y.min_seats,
                                  booked_seats: 0,
                                  gogo_user_id: 0,
                                  ss_category_id: 0,
                                  start_time: y.start_date_time,
                                  end_time: y.end_date_time,
                                  interval_time: scheduleDetail.interval_time,
                                  is_monday: y.is_monday,
                                  is_tuesday: y.is_tuesday,
                                  is_wednesday: y.is_wednesday,
                                  is_thursday: y.is_thursday,
                                  is_friday: y.is_friday,
                                  is_saturday: y.is_saturday,
                                  is_sunday: y.is_sunday,
                                  scheduling_price: [
                                    {
                                      screen_seat_type_id:
                                        y.screen_seat_type_id,
                                      rate_card_id: y.rc_id,
                                      rate_card_private_id: 0,
                                      rate_card_group_id: y.rate_card_id,
                                    },
                                  ],
                                };
                                cinema_obj.MultipleSchedule[
                                  filterModule
                                ].moviesArray.push(Movieobj);
                              } else {
                                cinema_obj.MultipleSchedule[
                                  filterModule
                                ].moviesArray[
                                  findIndexNew
                                ].scheduling_price.push({
                                  screen_seat_type_id: y.screen_seat_type_id,
                                  rate_card_id: y.rc_id,
                                  rate_card_private_id: 0,
                                  rate_card_group_id: y.rate_card_id,
                                });
                              }
                            }
                          }
                        });

                        MulScheduleCinemaArray.push(cinema_obj);
                      });
                    }

                    scheduleDetail["MulScheduleCinemaArray"] = {
                      md_id: 0,
                      CinemaSchedule: MulScheduleCinemaArray,
                    };
                  }
                );

                console.log("finalObj", JSON.parse(JSON.stringify(finalObj)));

                let op = Promise.resolve({
                  data: { status: false, message: "Unknown Step" },
                });

                if (step == "1") {
                  op = MovieService.updateMovieupdateStep1(finalObj);
                }
                if (step == "2") {
                  op = MovieService.updateMovieupdateStep2(finalObj);
                }
                if (step == "3") {
                  op = MovieService.updateMovieupdateStep3(finalObj);
                }
                if (step == "4") {
                  op = MovieService.updateMovieupdateStep4(finalObj);
                }
                if (step == "5") {
                  op = MovieService.updateMovieupdateStep5(finalObj);
                }
                if (step == "6") {
                  op = MovieService.updateMovieupdateStep6(finalObj);
                }
                if (step == "7") {
                  op = MovieService.updateMovieupdateStep7(finalObj);
                }
                if (step == "8") {
                  op = MovieService.updateMovieupdateStep8(finalObj);
                }

                op.then((result) => {
                  this.btenable = false;
                  loader.hide();

                  const { data } = result;
                  console.log("data", data);

                  if (data && data.status) {
                    this.$router.push({ path: "/cinema-manager/movies" });
                  }

                  this.$toasted.show(data.message || "Something Went Wrong!");
                }).catch((e) => {
                  this.btenable = false;
                  loader.hide();

                  console.log("Update Error", e);

                  this.$toasted.show("Something Went Wrong!");
                  this._CatchError(e);
                });
              } else {
                this.sectionCollapse.customFields = true;
                this.$toasted.show("Please Enter Custom Field details ");
              }
            }
          }
        });
      },
      validateMovieInfo(type = "save", showMsg = true) {
        this.errorHandlerObj["errMsg"] = ``;
        this.errorHandlerObj["errorSectionIndex"] = null;
        this.errorHandlerObj["errorArrayIndex"] = null;

        let errorIndex = null;
        let errorFvIndex = null;
        let errorSectionIndex = null;
        let errorCount = 0;
        let errMsg = ``;

        // this.whatsAppMovieTitleForEpix = this.MovieContentContainer.filter(
        //   (data) => {
        //     return data.content_lang_id == 3;
        //   }
        // );

        // console.log(
        //   this.whatsAppMovieTitleForEpix,
        //   " whatsAppMovieTitleForEpix"
        // );
        // console.log(
        //   this.whatsAppMovieTitleForEpix[0].movieContentTitle.length,
        //   " whatsAppMovieTitleForEpix[0].movieContentTitle.length"
        // );
        // console.log(
        //   whatsAppMovieTitleForEpix[0].movieContentTitle.length > 24,
        //   " whatsAppMovieTitleForEpix[0].movieContentTitle.length > 24"
        // );
        if (type == "draft") {
          if (!this.MovieContainer.movieTitle) {
            errorCount++;
            errMsg = `Movie Title Required.`;
            errorSectionIndex = 1;
          } else if (
            !this.MovieContainer.movie_unique_identifier &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Movie UUID Required.`;
            errorSectionIndex = 1;
          }
        } else {
          if (!this.MovieContainer.movieTitle) {
            errorCount++;
            errMsg = `Movie Title Required.`;
            errorSectionIndex = 1;
          } else if (
            !this.MovieContainer.movie_unique_identifier &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Movie UUID Required.`;
            errorSectionIndex = 1;
          } else if (!this.MovieContainer.original_lang_id && errorCount == 0) {
            errorCount++;
            errMsg = `Language (Original) Required.`;
            errorSectionIndex = 1;
          }
          else if (!this.MovieContainer.productionCompany.length && errorCount == 0) {
            errorCount++;
            errMsg = `Production Company Required.`;
            errorSectionIndex = 1;
          }
          else if (
            !this.MovieContainer.original_distributor_id &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Default Distributor Required.`;
            errorSectionIndex = 1;
          } else if (
            !moment(this.MovieContainer.original_release_date).isValid() &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Please enter Valid Original Release Date.`;
            errorSectionIndex = 1;
          } else if (
            this.MovieContainer.is_event &&
            !this.MovieContainer.parent_movie_id &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Parent Movie Required for Event.`;
            errorSectionIndex = 1;
          } else if (
            this.MovieContainer.is_event &&
            !this.MovieContainer.selected_version.length &&
            errorCount == 0
          ) {
            errorCount++;
            errMsg = `Parent Movie Version Required for Event.`;
            errorSectionIndex = 1;
          } else if (
            this.EPIX_CLIENT &&
            !this.whatsAppMovieTitleForEpix.movieContentTitle
          ) {
            errorCount++;
            errMsg = `WhatsApp Movie Title Required.`;
            errorSectionIndex = 1;
          } else if (
            this.EPIX_CLIENT &&
            this.whatsAppMovieTitleForEpix &&
            this.whatsAppMovieTitleForEpix.length > 0 &&
            this.whatsAppMovieTitleForEpix.movieContentTitle.length > 24
          ) {
            errorCount++;
            errMsg = `WhatsApp Movie Title should be Less then or Equal to 24 Characters.`;
            errorSectionIndex = 1;
          }

          if (errorCount == 0) {
            if (
              !this.MovieContainer.movieRatings ||
              !this.MovieContainer.movieRatings.length
            ) {
              errorCount++;
              errMsg = `Please Select Movie Ratings.`;
              errorSectionIndex = 1;
            } else {
              this.MovieContainer.movieRatings.forEach((_rating, ratIndex) => {
                if (!_rating.region_name) {
                  errorCount++;
                  errMsg = `Region Required.`;
                  errorSectionIndex = 1;
                  errorIndex = ratIndex;
                } else if (!moment(_rating.releaseDate).isValid()) {
                  errorCount++;
                  errMsg = `Release Date Invalid.`;
                  errorSectionIndex = 1;
                  errorIndex = ratIndex;
                } else if (!_rating.rating_id) {
                  errorCount++;
                  errMsg = `Please Select Ratings.`;
                  errorSectionIndex = 1;
                  errorIndex = ratIndex;
                } else if (isNaN(String(_rating.runTime))) {
                  errorCount++;
                  errMsg = `Runtime Required.`;
                  errorSectionIndex = 1;
                  errorIndex = ratIndex;
                }
              });
            }
          }

          if (errorCount == 0) {
            if (
              (!this.MovieContainer.movieLangaugeFormatDistributor ||
                !this.MovieContainer.movieLangaugeFormatDistributor.length) &&
              false
            ) {
              errorCount++;
              errMsg = `Please Add Movie Feature Versions.`;
              errorSectionIndex = 5;
            } else if (
              this.MovieContainer.movieLangaugeFormatDistributor &&
              this.MovieContainer.movieLangaugeFormatDistributor.length
            ) {
              this.MovieContainer.movieLangaugeFormatDistributor.forEach(
                (_version, verIndex) => {
                  console.log("_version", _version);

                  if (errorCount == 0) {
                    if (!_version.format_id) {
                      errorCount++;
                      errMsg = `Content Type Required.`;
                      errorSectionIndex = 5;
                      errorIndex = verIndex;
                    } else if (!_version.lang_id) {
                      errorCount++;
                      errMsg = `Language Required.`;
                      errorSectionIndex = 5;
                      errorIndex = verIndex;
                    } else if (
                      !_version.movieDistributors ||
                      !_version.movieDistributors.length ||
                      !_version.movieDistributors[0]["distributor_id"]
                    ) {
                      errorCount++;
                      errMsg = `Distributor Required.`;
                      errorSectionIndex = 5;
                      errorIndex = verIndex;
                    } else if (
                      (!_version.selected_cinema ||
                      !_version.selected_cinema.length) && false
                    ) {
                      errorCount++;
                      errMsg = `Cinema Required for version.`;
                      errorSectionIndex = 5;
                      errorIndex = verIndex;
                    }
                  }
                }
              );
            }
          }

          if (errorCount == 0) {
            if (
              !this.MovieContentContainer ||
              !this.MovieContentContainer.length
            ) {
            } else {
              this.MovieContentContainer.forEach((_lang, langIndex) => {
                if (
                  errorCount == 0 &&
                  _lang.langauge.toLowerCase() == "english"
                ) {
                  if (!_lang.movieShortDescription && false) {
                    errorCount++;
                    errMsg = `Movie Short Description Required.`;
                    errorSectionIndex = 2;
                    errorIndex = langIndex;
                  } else if (!_lang.movieDescription) {
                    errorCount++;
                    errMsg = `Movie Long Description Required.`;
                    errorSectionIndex = 2;
                    errorIndex = langIndex;
                  }
                }
              });
            }
          }
        }

        if (errorCount > 0) {
          if (showMsg) {
            this.$toasted.show(errMsg);
          }

          console.log(" this.errorHandlerObj", this.errorHandlerObj);

          this.errorHandlerObj["errMsg"] = errMsg;
          this.errorHandlerObj["errorSectionIndex"] = errorSectionIndex;
          this.errorHandlerObj["errorArrayIndex"] = errorIndex;

          if (errorSectionIndex == 1) {
            this.sectionCollapse["basicInfo"] = true;
          } else if (errorSectionIndex == 5) {
            this.sectionCollapse["detailsAndDistributors"] = true;
          } else if (errorSectionIndex == 2) {
            this.sectionCollapse["movieContent"] = true;
          }
          return false;
        } else {
          return true;
        }
      },
      OnFinalSubmit(validate = true) {
        console.log("validate", validate);
        let flag = true;
        let input = [];

        let validateType = !validate ? "draft" : "save";

        if (!this.validateMovieInfo(validateType, true)) {
          return false;
        }

        this.submitted = true;

        if (!validate) {
          this.showErrorMessages = false;
        } else {
          this.showErrorMessages = true;
        }

        this.$validator.validate().then((valid) => {
          console.log("valid Final submit", valid);
          console.log(this.MovieContainer.original_artwork);
          if (valid) {
            let loader = this.$loading.show();
            for (let i in this.custom_fields_list) {
              input.push({
                custom_field_id: this.custom_fields_list[i].custom_field_id,
                input_data: this.input_data[i],
              });
            }

            if (!this.checkAddMoreRatings) {
              let RatignwithAllRegions = _.cloneDeep(
                this.MovieContainer.movieRatings.filter((x) => x.region_id == 0)
              );
              if (RatignwithAllRegions.length > 0) {
                this.MovieContainer.movieRatings = [];
                this.Regions.filter((y) => y.region_id).map((x) => {
                  let obj = {
                    ...RatignwithAllRegions[0],
                  };
                  console.log("x.region_id", x.region_id);
                  console.log("x.region_name", x.region_name);
                  obj["region_id"] = x.region_id;
                  obj["region_name"] = x.region_name;
                  obj["mrrdr_id"] = null;
                  obj["mrrdr_id"] = null;
                  obj["region_obj"] = {
                    region_id: x.region_id,
                    region_name: x.region_name,
                  };
                  this.MovieContainer.movieRatings.push(obj);
                });
              }
            }
            if (
              this.EPIX_CLIENT &&
              this.whatsAppMovieTitleForEpix &&
              Object.keys(this.whatsAppMovieTitleForEpix).length > 0 &&
              this.whatsAppMovieTitleForEpix.hasOwnProperty("movieContentTitle")
            ) {
              // console.log("this if is working");
              this.MovieContainer[
                "movieAlternateLangTitle"
              ] = this.whatsAppMovieTitleForEpix.movieContentTitle;
            }
            // console.log(
            //   JSON.stringify(this.MovieContainer),
            //   "this.MovieContainer"
            // );
            if(this.inactiveProductionCompany.length){
              this.MovieContainer[
                "productionCompany"
              ]=[...this.MovieContainer.productionCompany,...this.inactiveProductionCompany]
            }
            let finalObj = {
              // movie_details_id: this.movie_details_id,
              ...this.MovieContainer,
              MovieContentContainer: this.MovieContentContainer,
              removedMovies: this.removedMovies,
              custom_field_values: input,
              original_distributor: this.original_distributor,
              original_language: this.original_language,
              movieScenes: this.movieScenes,
              movie_trailers: this.movie_trailers,
              CastAndCrewContainer: this.cast_and_crew,
              RemovedLabels: this.removedLabels,
              SignageContainer: this.signageContainer,
            };

            finalObj.movieLangaugeFormatDistributor.forEach((x, i) => {
              this.leadTimes[i].leadTimeHH = this.leadTimes[i].leadTimeHH
                ? this.leadTimes[i].leadTimeHH
                : "00";
              this.leadTimes[i].leadTimeMM = this.leadTimes[i].leadTimeMM
                ? this.leadTimes[i].leadTimeMM
                : "00";
              x.lead_time_in_hours = `${this.leadTimes[i].leadTimeHH}:${this.leadTimes[i].leadTimeMM}`;
            });
            console.log("finalObj :>> ", finalObj);

            finalObj.movieLangaugeFormatDistributor.map((scheduleDetail) => {
              let errorMsg = "";
              if (!scheduleDetail.licence_start_date) {
                errorMsg = "Please Select License Start Date";
              }
              if (!scheduleDetail.licence_end_date) {
                errorMsg = "Please Select License End Date";
              }

              if (
                moment(scheduleDetail.licence_end_date).isBefore(
                  scheduleDetail.licence_start_date
                )
              ) {
                errorMsg = "License End Date Should be grater than Start Date";
              }
              if (
                (!scheduleDetail.selected_cinema ||
                scheduleDetail.selected_cinema.length == 0) && false
              ) {
                errorMsg = "Please Select Cinema";
              }

              if (
                (!scheduleDetail.selectShowType ||
                  scheduleDetail.selectShowType.length == 0) &&
                this.getMyCinemaStatusNew() == "Y"
              ) {
                errorMsg = "Please Select Show Type";
              }

              console.log(errorMsg);

              // if (!scheduleDetail.interval_time) {
              //   errorMsg = "Please Select Intermission Time";
              // }
              // let loader = this.$loading.show();
              let MulScheduleCinemaArray = [];
              if (!errorMsg) {
                let is_private_show = true;
                let is_confirmed_show = true;
                let is_crowd_show = true;
                let showTypeArray = Array.prototype.map.call(
                  scheduleDetail.selectShowType,
                  function(item) {
                    return String(item.booking_type_id);
                  }
                );
                scheduleDetail.selected_cinema.map((x) => {
                  let cinema_obj = {
                    cinema_id: x.cine_id,
                    category_id: 1,
                    sch_start_date: scheduleDetail.licence_start_date,
                    sch_end_date: scheduleDetail.licence_end_date,
                    MultipleSchedule: [],
                  };
                  x.screen_array.map((y) => {
                    if (y.is_default_screen == "Y") {
                      let filterModule = cinema_obj.MultipleSchedule.findIndex(
                        (scree) => {
                          return scree.screen_id == y.screen_id;
                        }
                      );
                      let newArray = [...showTypeArray];
                      if (filterModule < 0) {
                        if (
                          y.is_confirmed_show == "N" ||
                          x.is_confirmed_show == "N"
                        ) {
                          is_confirmed_show = false;

                          let index_crowd = newArray.indexOf("1");
                          if (index_crowd >= 0) {
                            newArray.splice(index_crowd, 1);
                          }
                        }
                        if (y.is_crowd_show == "N" || x.is_crowd_show == "N") {
                          is_crowd_show = false;

                          let index_crowd = newArray.indexOf("2");
                          if (index_crowd >= 0) {
                            newArray.splice(index_crowd, 1);
                          }
                        }
                        if (
                          y.is_private_show == "N" ||
                          x.is_private_show == "N"
                        ) {
                          is_private_show = false;

                          let index_crowd = newArray.indexOf("3");
                          if (index_crowd >= 0) {
                            newArray.splice(index_crowd, 1);
                          }
                        }

                        let screen_obj = {
                          screen_id: y.screen_id,
                          selectShowType:
                            this.getMyCinemaStatusNew() == "Y"
                              ? newArray.join(",")
                              : "4",

                          moviesArray: [
                            {
                              privateRateCard: {
                                rate_card_id: y.rc_id_private,
                                rate_card_group_id: y.rate_card_private_id,
                              },

                              cleaning_time_in_mins:
                                x.cine_cleaning_time_in_mins,
                              interval_time_in_mins:
                                x.cine_interval_time_in_mins,
                              ads_time_in_mins: x.cine_setting_ads_time_in_mins,
                              // movie_details_id: scheduleDetail.md_id,
                              min_seats: y.min_seats,
                              booked_seats: 0,
                              gogo_user_id: 0,
                              ss_category_id: 0,
                              start_time: y.start_date_time,
                              end_time: y.end_date_time,
                              interval_time: x.mycinema_creation_interval
                                ? x.mycinema_creation_interval
                                : 0,
                              is_monday: y.is_monday,
                              is_tuesday: y.is_tuesday,
                              is_wednesday: y.is_wednesday,
                              is_thursday: y.is_thursday,
                              is_friday: y.is_friday,
                              is_saturday: y.is_saturday,
                              is_sunday: y.is_sunday,
                              scheduling_price: [
                                {
                                  screen_seat_type_id: y.screen_seat_type_id,
                                  rate_card_id: y.rc_id,
                                  rate_card_private_id: 0,
                                  rate_card_group_id: y.rate_card_id,
                                },
                              ],
                            },
                          ],
                        };
                        cinema_obj.MultipleSchedule.push(screen_obj);
                      } else {
                        let findIndexNew = cinema_obj.MultipleSchedule[
                          filterModule
                        ].moviesArray.findIndex((mov) => {
                          return (
                            mov.start_time == y.start_date_time &&
                            mov.end_time == y.end_date_time
                          );
                        });
                        if (findIndexNew < 0) {
                          let Movieobj = {
                            privateRateCard: {
                              rate_card_id: y.rc_id_private,
                              rate_card_group_id: y.rate_card_private_id,
                            },
                            cleaning_time_in_mins: x.cine_cleaning_time_in_mins,
                            interval_time_in_mins: x.cine_interval_time_in_mins,
                            ads_time_in_mins: x.cine_setting_ads_time_in_mins,
                            movie_details_id: scheduleDetail.md_id,
                            min_seats: y.min_seats,
                            booked_seats: 0,
                            gogo_user_id: 0,
                            ss_category_id: 0,
                            start_time: y.start_date_time,
                            end_time: y.end_date_time,
                            interval_time: scheduleDetail.interval_time,
                            is_monday: y.is_monday,
                            is_tuesday: y.is_tuesday,
                            is_wednesday: y.is_wednesday,
                            is_thursday: y.is_thursday,
                            is_friday: y.is_friday,
                            is_saturday: y.is_saturday,
                            is_sunday: y.is_sunday,
                            scheduling_price: [
                              {
                                screen_seat_type_id: y.screen_seat_type_id,
                                rate_card_id: y.rc_id,
                                rate_card_private_id: 0,
                                rate_card_group_id: y.rate_card_id,
                              },
                            ],
                          };
                          cinema_obj.MultipleSchedule[
                            filterModule
                          ].moviesArray.push(Movieobj);
                        } else {
                          cinema_obj.MultipleSchedule[filterModule].moviesArray[
                            findIndexNew
                          ].scheduling_price.push({
                            screen_seat_type_id: y.screen_seat_type_id,
                            rate_card_id: y.rc_id,
                            rate_card_private_id: 0,
                            rate_card_group_id: y.rate_card_id,
                          });
                        }
                      }
                    }
                  });

                  MulScheduleCinemaArray.push(cinema_obj);
                });
              }

              scheduleDetail["MulScheduleCinemaArray"] = {
                md_id: 0,
                CinemaSchedule: MulScheduleCinemaArray,
              };
            });
            // console.log("finalObj :", JSON.stringify(finalObj));

            console.log("finalObj", JSON.parse(JSON.stringify(finalObj)));
            // return;

            MovieService.updateMovieV2(finalObj)
              .then((result) => {
                this.btenable = false;
                const { data } = result;
                console.log(data.status);
                if (data.status) {
                  loader.hide();
                  // this.job_id = data.job_id

                  // let self = this
                  // this.job_checker = setInterval(async () => {
                  //   let { data: job_data } = await MasterService.GetJobOverHttpStatus(this.job_id)
                  //   this.job_status_check_count += this.job_status_check_count
                  //   console.log({ job_data, 'this.job_status_check_count': this.job_status_check_count })

                  //   if (job_data && job_data.job_state && job_data.job_state == 'completed') {
                  //     clearInterval(self.job_checker)
                  //     loader.hide()
                  //     this.$router.push({
                  //       path: "/cinema-manager/movies",
                  //     });
                  //   }
                  // }, 2000)
                  this.$router.push({
                    path: "/cinema-manager/movies",
                  });
                } else {
                  loader.hide();
                  this.$toasted.show(data.message || "Something Went Wrong!");
                }
              })
              .catch(this._CatchError)
              .finally(() => {
                loader.hide();
                // setTimeout(() => loader.hide(), 1000);
              });
          }
        });
        // }
      },
      translateToOtherLangs: function(movieContent, index) {
        console.log("translateToOtherLangs is called");

        console.log("movieContent", movieContent);
        console.log("this.MovieContentContainer", this.MovieContentContainer);

        let englishContent = this.MovieContentContainer.find((x) => {
          if (
            (x.movieDescription && x.movieDescription.length > 0) ||
            (x.movieShortDescription && x.movieShortDescription.length > 0)
          ) {
            return true;
          }
        });

        if (
          !englishContent ||
          !englishContent.movieDescription ||
          !englishContent.movieShortDescription
        ) {
          this.$toasted.show(
            "Please enter title and description for any language"
          );
          return;
        }

        let targetLang = movieContent.iso_2;

        if (!targetLang) {
          this.$toasted.show(
            "No ISO code found for " + movieContent.langauge + "language"
          );
          return;
        }

        this.onChangeTabHandler(null, index);
        this.translationLoading[index] = true;

        MovieService.GetDeeplTranslations({
          target_langs: [targetLang],
          text: [
            englishContent.movieDescription,
            englishContent.movieShortDescription,
          ],
        })
          .then((resp) => {
            const { data } = resp;
            console.log("data", data);

            if (data.status) {
              let translations = data.data[targetLang].translations;

              movieContent.movieDescription = translations[0].text;
              movieContent.movieShortDescription = translations[1].text;
              this.translated[index] = true;
            }
          })
          .catch((err) => {
            this.$toasted.show("Error when fetching translations");
            console.log("Error while fetching translations");
            console.log(err);
          })
          .finally(() => {
            this.translationLoading[index] = false;
            this.$forceUpdate();
          });
      },
      CheckEmptyContent: function(movieContent, index) {
        if (movieContent.langauge.toLowerCase() !== "english") {
          if (movieContent.movieContentTitle) {
            this.translated[index] = true;
          } else {
            this.translated[index] = false;
          }
        }
      },
      onChangeOriginalShowtype: function(event, showtype, item) {
        // console.log(event, showtype)
        // let movieLangaugeFormatDistributor1 = this.MovieContainer.movieLangaugeFormatDistributor.map(
        //   (mlfd, i) => {
        //     console.log("mlfd[showtype]", mlfd);
        //     mlfd[showtype] = event.target.checked;
        //     this.$set(
        //       this.MovieContainer.movieLangaugeFormatDistributor,
        //       i,
        //       mlfd
        //     );
        //     // this.MovieContainer.movieLangaugeFormatDistributor.$set(i, mlfd)
        //     return mlfd;
        //   }
        // );
        this.MovieContainer.movieLangaugeFormatDistributor.map((mlfd, i) => {
          mlfd[showtype] = event.target.checked;

          let findIndeNew = mlfd["selectShowType"].findIndex((x) => {
            return x.booking_type_id == item.booking_type_id;
          });
          if (findIndeNew >= 0) {
            mlfd["selectShowType"].splice(findIndeNew, 1);
          } else {
            mlfd["selectShowType"].push(item);
          }
        });
        setTimeout(this.$forceUpdate(), 1000);
        // this.componentKey1 = this.componentKey1 + 1;
        // console.log('Vue.MovieContainer', Vue.MovieContainer)
        // this.$set(this.MovieContainer.movieLangaugeFormatDistributor, 0, movieLangaugeFormatDistributor1[0])
        console.log(this.MovieContainer.movieLangaugeFormatDistributor);
      },
      deleteImageUrl(distributor) {
        distributor.md_thumbnail_url = null;

        distributor.md_thumbnail_name = null;

        this.$emit("imageDeleted", distributor);
      },
      onSelectProductionCompany(payload){
        let companyIndex = this.inactiveProductionCompany.findIndex(company => company.production_id == payload.production_id);

      if (companyIndex !== -1) {
          let company = this.inactiveProductionCompany.splice(companyIndex, 1)[0];

          company.mpc_is_active = "Y";

          this.MovieContainer.productionCompany.push(company);
      }
      else{
        this.MovieContainer.productionCompany.push({...payload,mpc_is_active:"Y"})
      }

      },
      onRemoveProudctionCompany(payload){
        let companyIndex = this.MovieContainer.productionCompany.findIndex(company => company.production_id == payload.production_id);

      if (companyIndex !== -1) {
          let company = this.MovieContainer.productionCompany.splice(companyIndex, 1)[0];

          company.mpc_is_active = "N";

          this.inactiveProductionCompany.push(company);
      }

      },

      /**
       * Saif END
       */
    },
  };
</script>

<style>
  .disableFeatureVersion {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.8;
  }
  .disableFeatureVersion .forceAllowed {
    cursor: pointer !important;
    pointer-events: all !important;
    opacity: 1 !important;
  }
  #selectdistributor-1 .btn-dropdown-curve {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .no_edit_allowed {
    cursor: not-allowed !important;
  }

  .error_border {
    border: 2px solid rgb(247, 78, 78) !important;
  }

  .dcp_box {
    background-color: #f5d8ee !important;
  }
  .new-border {
    border: 1px solid #b1b4b8;
  }
  label {
    color: black !important;
  }
  .internal-border-new {
    border: 1px solid #3876d2;
    /*background-color: #e6e6f8;*/
  }
  .internal-border {
    border: 1px solid #3876d2;
    background-color: #e6e6f8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
  }
  .fs {
    font-size: 17px;
  }
  .back {
    background-color: #f5f5f5;
  }
  .mar {
    margin-left: 30px;
  }

  /* .custom-multiselect {
  width: 680px;
}
.custom-button-no-hover:hover {
  cursor: pointer;
}
.remove-tag {
  cursor: pointer;
  color: white;
border: solid red 1px;
}


.selected-cinema {
  background-color: rgb(74,135,225);
  color: white;
  padding: 2px 4px 2px 2px;
  border-radius: 4px;
  width: 80px;
  margin-left: 4px;
  margin-top: 5px;
  font-size: 12px;
  margin-bottom: 5px;
}
.custom-multiselect-tag {
  display: inline-flex;
  align-items: center;
 gap: 5px;
}
.custom-multiselect-remove {
  cursor: pointer;
  margin-left: 2px;

}
.remove-tag:hover {
  border-radius: 2px;
  background-color: rgba(255, 0, 0, 0.856);
} */

  .new_movie_layout .input-material {
    height: 33px !important;
  }

  .new_movie_layout .material-file-upload {
    border-radius: 5px !important;
  }

  .new_movie_layout .material-file-upload .label {
    font-weight: 500 !important;
  }

  .new_movie_layout .input-material input,
  .new_movie_layout .input-material-textarea textarea {
    border-radius: 5px;
    min-height: 33px;
  }

  .new_movie_layout .input-material input + label,
  .new_movie_layout .input-material textarea + label,
  .new_movie_layout .input-material-textarea textarea + label {
    position: unset !important;
  }

  .new_movie_layout label {
    text-transform: capitalize;
    margin-bottom: 0rem !important;
  }

  .new_movie_layout {
    line-height: unset !important;
  }

  .new_movie_layout .multiselect__select {
    height: 30px !important;
  }
  .new_movie_layout .multiselect {
    min-height: 30px !important;
  }
  .new_movie_layout .multiselect__tags {
    min-height: 30px !important;
    border-radius: 5px !important;
  }

  .new_movie_layout .multiselect__tag {
    margin-right: 5px;
    margin-bottom: 0px;
  }

  .new_movie_layout .dropdown-curve-container label,
  .new_movie_layout .input-material-textarea label {
    position: unset !important;
    background: transparent;
    letter-spacing: 0.3px;
  }

  .new_movie_layout .input-material input::placeholder,
  .new_movie_layout .input-material-textarea textarea::placeholder {
    /* color: black; */
    /* color: #9e9e9e !important; */
    color: #9e9e9e9e !important;
    /* font-style: italic; */
    font-size: 12px;
    letter-spacing: 0.3px;
  }

  .new_movie_layout .multiselect__placeholder {
    /* color: #9e9e9e !important; */
    color: #9e9e9e9e !important;
    /* font-style: italic; */
    font-size: 12px;
    font-weight: unset !important;
    letter-spacing: 0.3px;
  }

  .new_movie_layout input[type="date"]::placeholder {
    color: #9e9e9e9e !important;
    font-size: 12px;
    letter-spacing: 0.3px;
  }

  .new_movie_layout .multiselect__strong {
    font-weight: 500 !important;
  }

  .new_movie_layout .minWidth135 {
    min-width: 135px;
  }
  .new_movie_layout .minWidth175 {
    min-width: 177px;
  }

  .new_movie_layout .movie-version-box .movie-version-inner {
    border: 1px solid #a1a1a4;
    border-radius: 5px;
    padding: unset;
    padding-top: 0.5rem;
    background: #f5f5f5;
    box-shadow: 1px 2px 5px 0px lightgray;
  }

  .new_movie_layout .movie-version-box {
    border: unset;
    background: #e6e6f8;
    padding: unset;
    border-radius: 5px;
  }

  .new_movie_layout {
    /* font-family: sans-serif; */
    zoom: 0.88 !important;
  }

  .new_movie_layout .blue-badge {
    margin-bottom: 0;
  }

  .new_movie_layout .min-h {
    min-height: 30px !important;
  }

  .backWhite {
    background: white;
  }

  .movieSceneImage {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background: lightgray;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .movieSceneImage .plusScenes {
    font-size: 25px;
    font-weight: bold;
    color: white;
    padding-bottom: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
  }

  .movieSceneImageIcon .image-circle {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    cursor: pointer;
    object-fit: cover; /* Keeps image proportionate */
  }

  .borderRight {
    border-right: 1px solid;
  }

  .maxW85 {
    max-width: 85px;
  }

  /* Overlay options (hidden by default) */
  .movieSceneImageoptions {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(239 226 226 / 83%);
    /* background: rgb(171 171 171 / 50%); */
    /* background: rgba(0, 0, 0, 0.5); */
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0; /* Initially hidden */
    transition: opacity 0.3s ease; /* Smooth transition */
  }

  /* Hover effect to show options */
  .movieSceneImageIcon:hover .movieSceneImageoptions {
    opacity: 1; /* Show overlay */
  }

  /* Buttons for View and Delete */
  .movieSceneImageoptions button {
    background-color: white;
    border: none;
    padding: 10px;
    margin: 5px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  /* Hover effect for buttons */
  .movieSceneImageoptions button:hover {
    background-color: #f0f0f0;
  }

  /* Icons or Text */
  .movieSceneImageoptions button i {
    margin-right: 5px;
  }

  .castCrewTab {
    border: 0.5px solid lightgray;
    border-top: none;
    /* padding-inline: 15px; */
    background: #f5f5f5;
  }

  .manual_bill_item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .manual_bill_input input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
  }

  .manual_bill_input input::placeholder,
  .manual_bill_wrapper .multiselect__placeholder {
    font-size: 12px;
    font-style: italic;
  }

  .input_text-center input {
    text-align: center;
  }

  .input_text-right input {
    text-align: right;
  }

  .manual_bill_wrapper .multiselect__placeholder {
    font-weight: unset !important;
  }

  .noItemsClass {
    text-align: center;
    width: 100%;
    margin: 16px auto;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
  }

  .taxPopOver {
    zoom: 0.8;
    min-width: 200px;
  }

  .errRow {
    border: 2px solid red;
  }
  .borderNone {
    border: none !important;
  }

  .complete-tick {
    width: 120px;
    height: 120px;
    display: inline-block;
    background-size: contain;
  }

  .fv_collapse_inner {
    text-align: left;
    padding: 10px;
  }

  .fv_collapse_inner_container {
    background: #f5f5f5;
    margin-inline: 7px;
  }

  .new_movie_layout .btn-tab-title.active {
    background-color: #3876d217;
  }

  .basicInforWrapper {
    background: #f5f5f5;
  }

  .new_movie_layout .bg-lightprimary {
    background-color: #3876d217;
  }

  .new_movie_layout .multiselect__single {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-bottom: unset !important;
    vertical-align: text-bottom !important;
  }

  .new_movie_layout .image-previewer {
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }
  .sectionError {
    border: 2px solid red;
    border-radius: 5px;
  }

  .required_star {
    font-size: 14px;
    color: #ff0202;
    font-weight: bolder;
    padding-left: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MoviesComponents/editMovies.vue